// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=2.4.85", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=2.4.85", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=2.4.85", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=2.4.85", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/materialdesignicons-webfont.svg?v=2.4.85", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=2.4.85" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#materialdesigniconsregular" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-access-point:before {
  content: "\\F002";
}

.mdi-access-point-network:before {
  content: "\\F003";
}

.mdi-account:before {
  content: "\\F004";
}

.mdi-account-alert:before {
  content: "\\F005";
}

.mdi-account-box:before {
  content: "\\F006";
}

.mdi-account-box-multiple:before {
  content: "\\F933";
}

.mdi-account-box-outline:before {
  content: "\\F007";
}

.mdi-account-card-details:before {
  content: "\\F5D2";
}

.mdi-account-check:before {
  content: "\\F008";
}

.mdi-account-circle:before {
  content: "\\F009";
}

.mdi-account-convert:before {
  content: "\\F00A";
}

.mdi-account-edit:before {
  content: "\\F6BB";
}

.mdi-account-group:before {
  content: "\\F848";
}

.mdi-account-heart:before {
  content: "\\F898";
}

.mdi-account-key:before {
  content: "\\F00B";
}

.mdi-account-location:before {
  content: "\\F00C";
}

.mdi-account-minus:before {
  content: "\\F00D";
}

.mdi-account-multiple:before {
  content: "\\F00E";
}

.mdi-account-multiple-check:before {
  content: "\\F8C4";
}

.mdi-account-multiple-minus:before {
  content: "\\F5D3";
}

.mdi-account-multiple-outline:before {
  content: "\\F00F";
}

.mdi-account-multiple-plus:before {
  content: "\\F010";
}

.mdi-account-multiple-plus-outline:before {
  content: "\\F7FF";
}

.mdi-account-network:before {
  content: "\\F011";
}

.mdi-account-off:before {
  content: "\\F012";
}

.mdi-account-outline:before {
  content: "\\F013";
}

.mdi-account-plus:before {
  content: "\\F014";
}

.mdi-account-plus-outline:before {
  content: "\\F800";
}

.mdi-account-remove:before {
  content: "\\F015";
}

.mdi-account-search:before {
  content: "\\F016";
}

.mdi-account-search-outline:before {
  content: "\\F934";
}

.mdi-account-settings:before {
  content: "\\F630";
}

.mdi-account-settings-variant:before {
  content: "\\F631";
}

.mdi-account-star:before {
  content: "\\F017";
}

.mdi-account-switch:before {
  content: "\\F019";
}

.mdi-accusoft:before {
  content: "\\F849";
}

.mdi-adjust:before {
  content: "\\F01A";
}

.mdi-adobe:before {
  content: "\\F935";
}

.mdi-air-conditioner:before {
  content: "\\F01B";
}

.mdi-airballoon:before {
  content: "\\F01C";
}

.mdi-airplane:before {
  content: "\\F01D";
}

.mdi-airplane-landing:before {
  content: "\\F5D4";
}

.mdi-airplane-off:before {
  content: "\\F01E";
}

.mdi-airplane-takeoff:before {
  content: "\\F5D5";
}

.mdi-airplay:before {
  content: "\\F01F";
}

.mdi-airport:before {
  content: "\\F84A";
}

.mdi-alarm:before {
  content: "\\F020";
}

.mdi-alarm-bell:before {
  content: "\\F78D";
}

.mdi-alarm-check:before {
  content: "\\F021";
}

.mdi-alarm-light:before {
  content: "\\F78E";
}

.mdi-alarm-multiple:before {
  content: "\\F022";
}

.mdi-alarm-off:before {
  content: "\\F023";
}

.mdi-alarm-plus:before {
  content: "\\F024";
}

.mdi-alarm-snooze:before {
  content: "\\F68D";
}

.mdi-album:before {
  content: "\\F025";
}

.mdi-alert:before {
  content: "\\F026";
}

.mdi-alert-box:before {
  content: "\\F027";
}

.mdi-alert-circle:before {
  content: "\\F028";
}

.mdi-alert-circle-outline:before {
  content: "\\F5D6";
}

.mdi-alert-decagram:before {
  content: "\\F6BC";
}

.mdi-alert-octagon:before {
  content: "\\F029";
}

.mdi-alert-octagram:before {
  content: "\\F766";
}

.mdi-alert-outline:before {
  content: "\\F02A";
}

.mdi-alien:before {
  content: "\\F899";
}

.mdi-all-inclusive:before {
  content: "\\F6BD";
}

.mdi-alpha:before {
  content: "\\F02B";
}

.mdi-alphabetical:before {
  content: "\\F02C";
}

.mdi-altimeter:before {
  content: "\\F5D7";
}

.mdi-amazon:before {
  content: "\\F02D";
}

.mdi-amazon-alexa:before {
  content: "\\F8C5";
}

.mdi-amazon-drive:before {
  content: "\\F02E";
}

.mdi-ambulance:before {
  content: "\\F02F";
}

.mdi-amplifier:before {
  content: "\\F030";
}

.mdi-anchor:before {
  content: "\\F031";
}

.mdi-android:before {
  content: "\\F032";
}

.mdi-android-debug-bridge:before {
  content: "\\F033";
}

.mdi-android-head:before {
  content: "\\F78F";
}

.mdi-android-studio:before {
  content: "\\F034";
}

.mdi-angle-acute:before {
  content: "\\F936";
}

.mdi-angle-obtuse:before {
  content: "\\F937";
}

.mdi-angle-right:before {
  content: "\\F938";
}

.mdi-angular:before {
  content: "\\F6B1";
}

.mdi-angularjs:before {
  content: "\\F6BE";
}

.mdi-animation:before {
  content: "\\F5D8";
}

.mdi-animation-play:before {
  content: "\\F939";
}

.mdi-anvil:before {
  content: "\\F89A";
}

.mdi-apple:before {
  content: "\\F035";
}

.mdi-apple-finder:before {
  content: "\\F036";
}

.mdi-apple-icloud:before {
  content: "\\F038";
}

.mdi-apple-ios:before {
  content: "\\F037";
}

.mdi-apple-keyboard-caps:before {
  content: "\\F632";
}

.mdi-apple-keyboard-command:before {
  content: "\\F633";
}

.mdi-apple-keyboard-control:before {
  content: "\\F634";
}

.mdi-apple-keyboard-option:before {
  content: "\\F635";
}

.mdi-apple-keyboard-shift:before {
  content: "\\F636";
}

.mdi-apple-safari:before {
  content: "\\F039";
}

.mdi-application:before {
  content: "\\F614";
}

.mdi-approval:before {
  content: "\\F790";
}

.mdi-apps:before {
  content: "\\F03B";
}

.mdi-arch:before {
  content: "\\F8C6";
}

.mdi-archive:before {
  content: "\\F03C";
}

.mdi-arrange-bring-forward:before {
  content: "\\F03D";
}

.mdi-arrange-bring-to-front:before {
  content: "\\F03E";
}

.mdi-arrange-send-backward:before {
  content: "\\F03F";
}

.mdi-arrange-send-to-back:before {
  content: "\\F040";
}

.mdi-arrow-all:before {
  content: "\\F041";
}

.mdi-arrow-bottom-left:before {
  content: "\\F042";
}

.mdi-arrow-bottom-right:before {
  content: "\\F043";
}

.mdi-arrow-collapse:before {
  content: "\\F615";
}

.mdi-arrow-collapse-all:before {
  content: "\\F044";
}

.mdi-arrow-collapse-down:before {
  content: "\\F791";
}

.mdi-arrow-collapse-horizontal:before {
  content: "\\F84B";
}

.mdi-arrow-collapse-left:before {
  content: "\\F792";
}

.mdi-arrow-collapse-right:before {
  content: "\\F793";
}

.mdi-arrow-collapse-up:before {
  content: "\\F794";
}

.mdi-arrow-collapse-vertical:before {
  content: "\\F84C";
}

.mdi-arrow-down:before {
  content: "\\F045";
}

.mdi-arrow-down-bold:before {
  content: "\\F72D";
}

.mdi-arrow-down-bold-box:before {
  content: "\\F72E";
}

.mdi-arrow-down-bold-box-outline:before {
  content: "\\F72F";
}

.mdi-arrow-down-bold-circle:before {
  content: "\\F047";
}

.mdi-arrow-down-bold-circle-outline:before {
  content: "\\F048";
}

.mdi-arrow-down-bold-hexagon-outline:before {
  content: "\\F049";
}

.mdi-arrow-down-box:before {
  content: "\\F6BF";
}

.mdi-arrow-down-drop-circle:before {
  content: "\\F04A";
}

.mdi-arrow-down-drop-circle-outline:before {
  content: "\\F04B";
}

.mdi-arrow-down-thick:before {
  content: "\\F046";
}

.mdi-arrow-expand:before {
  content: "\\F616";
}

.mdi-arrow-expand-all:before {
  content: "\\F04C";
}

.mdi-arrow-expand-down:before {
  content: "\\F795";
}

.mdi-arrow-expand-horizontal:before {
  content: "\\F84D";
}

.mdi-arrow-expand-left:before {
  content: "\\F796";
}

.mdi-arrow-expand-right:before {
  content: "\\F797";
}

.mdi-arrow-expand-up:before {
  content: "\\F798";
}

.mdi-arrow-expand-vertical:before {
  content: "\\F84E";
}

.mdi-arrow-left:before {
  content: "\\F04D";
}

.mdi-arrow-left-bold:before {
  content: "\\F730";
}

.mdi-arrow-left-bold-box:before {
  content: "\\F731";
}

.mdi-arrow-left-bold-box-outline:before {
  content: "\\F732";
}

.mdi-arrow-left-bold-circle:before {
  content: "\\F04F";
}

.mdi-arrow-left-bold-circle-outline:before {
  content: "\\F050";
}

.mdi-arrow-left-bold-hexagon-outline:before {
  content: "\\F051";
}

.mdi-arrow-left-box:before {
  content: "\\F6C0";
}

.mdi-arrow-left-drop-circle:before {
  content: "\\F052";
}

.mdi-arrow-left-drop-circle-outline:before {
  content: "\\F053";
}

.mdi-arrow-left-thick:before {
  content: "\\F04E";
}

.mdi-arrow-right:before {
  content: "\\F054";
}

.mdi-arrow-right-bold:before {
  content: "\\F733";
}

.mdi-arrow-right-bold-box:before {
  content: "\\F734";
}

.mdi-arrow-right-bold-box-outline:before {
  content: "\\F735";
}

.mdi-arrow-right-bold-circle:before {
  content: "\\F056";
}

.mdi-arrow-right-bold-circle-outline:before {
  content: "\\F057";
}

.mdi-arrow-right-bold-hexagon-outline:before {
  content: "\\F058";
}

.mdi-arrow-right-box:before {
  content: "\\F6C1";
}

.mdi-arrow-right-drop-circle:before {
  content: "\\F059";
}

.mdi-arrow-right-drop-circle-outline:before {
  content: "\\F05A";
}

.mdi-arrow-right-thick:before {
  content: "\\F055";
}

.mdi-arrow-split-horizontal:before {
  content: "\\F93A";
}

.mdi-arrow-split-vertical:before {
  content: "\\F93B";
}

.mdi-arrow-top-left:before {
  content: "\\F05B";
}

.mdi-arrow-top-right:before {
  content: "\\F05C";
}

.mdi-arrow-up:before {
  content: "\\F05D";
}

.mdi-arrow-up-bold:before {
  content: "\\F736";
}

.mdi-arrow-up-bold-box:before {
  content: "\\F737";
}

.mdi-arrow-up-bold-box-outline:before {
  content: "\\F738";
}

.mdi-arrow-up-bold-circle:before {
  content: "\\F05F";
}

.mdi-arrow-up-bold-circle-outline:before {
  content: "\\F060";
}

.mdi-arrow-up-bold-hexagon-outline:before {
  content: "\\F061";
}

.mdi-arrow-up-box:before {
  content: "\\F6C2";
}

.mdi-arrow-up-drop-circle:before {
  content: "\\F062";
}

.mdi-arrow-up-drop-circle-outline:before {
  content: "\\F063";
}

.mdi-arrow-up-thick:before {
  content: "\\F05E";
}

.mdi-artist:before {
  content: "\\F802";
}

.mdi-assistant:before {
  content: "\\F064";
}

.mdi-asterisk:before {
  content: "\\F6C3";
}

.mdi-at:before {
  content: "\\F065";
}

.mdi-atlassian:before {
  content: "\\F803";
}

.mdi-atom:before {
  content: "\\F767";
}

.mdi-attachment:before {
  content: "\\F066";
}

.mdi-audio-video:before {
  content: "\\F93C";
}

.mdi-audiobook:before {
  content: "\\F067";
}

.mdi-augmented-reality:before {
  content: "\\F84F";
}

.mdi-auto-fix:before {
  content: "\\F068";
}

.mdi-auto-upload:before {
  content: "\\F069";
}

.mdi-autorenew:before {
  content: "\\F06A";
}

.mdi-av-timer:before {
  content: "\\F06B";
}

.mdi-axe:before {
  content: "\\F8C7";
}

.mdi-azure:before {
  content: "\\F804";
}

.mdi-baby:before {
  content: "\\F06C";
}

.mdi-baby-buggy:before {
  content: "\\F68E";
}

.mdi-backburger:before {
  content: "\\F06D";
}

.mdi-backspace:before {
  content: "\\F06E";
}

.mdi-backup-restore:before {
  content: "\\F06F";
}

.mdi-badminton:before {
  content: "\\F850";
}

.mdi-bandcamp:before {
  content: "\\F674";
}

.mdi-bank:before {
  content: "\\F070";
}

.mdi-barcode:before {
  content: "\\F071";
}

.mdi-barcode-scan:before {
  content: "\\F072";
}

.mdi-barley:before {
  content: "\\F073";
}

.mdi-barrel:before {
  content: "\\F074";
}

.mdi-baseball:before {
  content: "\\F851";
}

.mdi-baseball-bat:before {
  content: "\\F852";
}

.mdi-basecamp:before {
  content: "\\F075";
}

.mdi-basket:before {
  content: "\\F076";
}

.mdi-basket-fill:before {
  content: "\\F077";
}

.mdi-basket-unfill:before {
  content: "\\F078";
}

.mdi-basketball:before {
  content: "\\F805";
}

.mdi-battery:before {
  content: "\\F079";
}

.mdi-battery-10:before {
  content: "\\F07A";
}

.mdi-battery-10-bluetooth:before {
  content: "\\F93D";
}

.mdi-battery-20:before {
  content: "\\F07B";
}

.mdi-battery-20-bluetooth:before {
  content: "\\F93E";
}

.mdi-battery-30:before {
  content: "\\F07C";
}

.mdi-battery-30-bluetooth:before {
  content: "\\F93F";
}

.mdi-battery-40:before {
  content: "\\F07D";
}

.mdi-battery-40-bluetooth:before {
  content: "\\F940";
}

.mdi-battery-50:before {
  content: "\\F07E";
}

.mdi-battery-50-bluetooth:before {
  content: "\\F941";
}

.mdi-battery-60:before {
  content: "\\F07F";
}

.mdi-battery-60-bluetooth:before {
  content: "\\F942";
}

.mdi-battery-70:before {
  content: "\\F080";
}

.mdi-battery-70-bluetooth:before {
  content: "\\F943";
}

.mdi-battery-80:before {
  content: "\\F081";
}

.mdi-battery-80-bluetooth:before {
  content: "\\F944";
}

.mdi-battery-90:before {
  content: "\\F082";
}

.mdi-battery-90-bluetooth:before {
  content: "\\F945";
}

.mdi-battery-alert:before {
  content: "\\F083";
}

.mdi-battery-alert-bluetooth:before {
  content: "\\F946";
}

.mdi-battery-bluetooth:before {
  content: "\\F947";
}

.mdi-battery-bluetooth-variant:before {
  content: "\\F948";
}

.mdi-battery-charging:before {
  content: "\\F084";
}

.mdi-battery-charging-10:before {
  content: "\\F89B";
}

.mdi-battery-charging-100:before {
  content: "\\F085";
}

.mdi-battery-charging-20:before {
  content: "\\F086";
}

.mdi-battery-charging-30:before {
  content: "\\F087";
}

.mdi-battery-charging-40:before {
  content: "\\F088";
}

.mdi-battery-charging-50:before {
  content: "\\F89C";
}

.mdi-battery-charging-60:before {
  content: "\\F089";
}

.mdi-battery-charging-70:before {
  content: "\\F89D";
}

.mdi-battery-charging-80:before {
  content: "\\F08A";
}

.mdi-battery-charging-90:before {
  content: "\\F08B";
}

.mdi-battery-charging-outline:before {
  content: "\\F89E";
}

.mdi-battery-charging-wireless:before {
  content: "\\F806";
}

.mdi-battery-charging-wireless-10:before {
  content: "\\F807";
}

.mdi-battery-charging-wireless-20:before {
  content: "\\F808";
}

.mdi-battery-charging-wireless-30:before {
  content: "\\F809";
}

.mdi-battery-charging-wireless-40:before {
  content: "\\F80A";
}

.mdi-battery-charging-wireless-50:before {
  content: "\\F80B";
}

.mdi-battery-charging-wireless-60:before {
  content: "\\F80C";
}

.mdi-battery-charging-wireless-70:before {
  content: "\\F80D";
}

.mdi-battery-charging-wireless-80:before {
  content: "\\F80E";
}

.mdi-battery-charging-wireless-90:before {
  content: "\\F80F";
}

.mdi-battery-charging-wireless-alert:before {
  content: "\\F810";
}

.mdi-battery-charging-wireless-outline:before {
  content: "\\F811";
}

.mdi-battery-minus:before {
  content: "\\F08C";
}

.mdi-battery-negative:before {
  content: "\\F08D";
}

.mdi-battery-outline:before {
  content: "\\F08E";
}

.mdi-battery-plus:before {
  content: "\\F08F";
}

.mdi-battery-positive:before {
  content: "\\F090";
}

.mdi-battery-unknown:before {
  content: "\\F091";
}

.mdi-battery-unknown-bluetooth:before {
  content: "\\F949";
}

.mdi-beach:before {
  content: "\\F092";
}

.mdi-beaker:before {
  content: "\\F68F";
}

.mdi-beats:before {
  content: "\\F097";
}

.mdi-bed-empty:before {
  content: "\\F89F";
}

.mdi-beer:before {
  content: "\\F098";
}

.mdi-behance:before {
  content: "\\F099";
}

.mdi-bell:before {
  content: "\\F09A";
}

.mdi-bell-off:before {
  content: "\\F09B";
}

.mdi-bell-outline:before {
  content: "\\F09C";
}

.mdi-bell-plus:before {
  content: "\\F09D";
}

.mdi-bell-ring:before {
  content: "\\F09E";
}

.mdi-bell-ring-outline:before {
  content: "\\F09F";
}

.mdi-bell-sleep:before {
  content: "\\F0A0";
}

.mdi-beta:before {
  content: "\\F0A1";
}

.mdi-bible:before {
  content: "\\F0A2";
}

.mdi-bike:before {
  content: "\\F0A3";
}

.mdi-bing:before {
  content: "\\F0A4";
}

.mdi-binoculars:before {
  content: "\\F0A5";
}

.mdi-bio:before {
  content: "\\F0A6";
}

.mdi-biohazard:before {
  content: "\\F0A7";
}

.mdi-bitbucket:before {
  content: "\\F0A8";
}

.mdi-bitcoin:before {
  content: "\\F812";
}

.mdi-black-mesa:before {
  content: "\\F0A9";
}

.mdi-blackberry:before {
  content: "\\F0AA";
}

.mdi-blender:before {
  content: "\\F0AB";
}

.mdi-blinds:before {
  content: "\\F0AC";
}

.mdi-block-helper:before {
  content: "\\F0AD";
}

.mdi-blogger:before {
  content: "\\F0AE";
}

.mdi-bluetooth:before {
  content: "\\F0AF";
}

.mdi-bluetooth-audio:before {
  content: "\\F0B0";
}

.mdi-bluetooth-connect:before {
  content: "\\F0B1";
}

.mdi-bluetooth-off:before {
  content: "\\F0B2";
}

.mdi-bluetooth-settings:before {
  content: "\\F0B3";
}

.mdi-bluetooth-transfer:before {
  content: "\\F0B4";
}

.mdi-blur:before {
  content: "\\F0B5";
}

.mdi-blur-linear:before {
  content: "\\F0B6";
}

.mdi-blur-off:before {
  content: "\\F0B7";
}

.mdi-blur-radial:before {
  content: "\\F0B8";
}

.mdi-bomb:before {
  content: "\\F690";
}

.mdi-bomb-off:before {
  content: "\\F6C4";
}

.mdi-bone:before {
  content: "\\F0B9";
}

.mdi-book:before {
  content: "\\F0BA";
}

.mdi-book-minus:before {
  content: "\\F5D9";
}

.mdi-book-multiple:before {
  content: "\\F0BB";
}

.mdi-book-multiple-variant:before {
  content: "\\F0BC";
}

.mdi-book-open:before {
  content: "\\F0BD";
}

.mdi-book-open-page-variant:before {
  content: "\\F5DA";
}

.mdi-book-open-variant:before {
  content: "\\F0BE";
}

.mdi-book-plus:before {
  content: "\\F5DB";
}

.mdi-book-secure:before {
  content: "\\F799";
}

.mdi-book-unsecure:before {
  content: "\\F79A";
}

.mdi-book-variant:before {
  content: "\\F0BF";
}

.mdi-bookmark:before {
  content: "\\F0C0";
}

.mdi-bookmark-check:before {
  content: "\\F0C1";
}

.mdi-bookmark-music:before {
  content: "\\F0C2";
}

.mdi-bookmark-outline:before {
  content: "\\F0C3";
}

.mdi-bookmark-plus:before {
  content: "\\F0C5";
}

.mdi-bookmark-plus-outline:before {
  content: "\\F0C4";
}

.mdi-bookmark-remove:before {
  content: "\\F0C6";
}

.mdi-boombox:before {
  content: "\\F5DC";
}

.mdi-bootstrap:before {
  content: "\\F6C5";
}

.mdi-border-all:before {
  content: "\\F0C7";
}

.mdi-border-all-variant:before {
  content: "\\F8A0";
}

.mdi-border-bottom:before {
  content: "\\F0C8";
}

.mdi-border-bottom-variant:before {
  content: "\\F8A1";
}

.mdi-border-color:before {
  content: "\\F0C9";
}

.mdi-border-horizontal:before {
  content: "\\F0CA";
}

.mdi-border-inside:before {
  content: "\\F0CB";
}

.mdi-border-left:before {
  content: "\\F0CC";
}

.mdi-border-left-variant:before {
  content: "\\F8A2";
}

.mdi-border-none:before {
  content: "\\F0CD";
}

.mdi-border-none-variant:before {
  content: "\\F8A3";
}

.mdi-border-outside:before {
  content: "\\F0CE";
}

.mdi-border-right:before {
  content: "\\F0CF";
}

.mdi-border-right-variant:before {
  content: "\\F8A4";
}

.mdi-border-style:before {
  content: "\\F0D0";
}

.mdi-border-top:before {
  content: "\\F0D1";
}

.mdi-border-top-variant:before {
  content: "\\F8A5";
}

.mdi-border-vertical:before {
  content: "\\F0D2";
}

.mdi-bottle-wine:before {
  content: "\\F853";
}

.mdi-bow-tie:before {
  content: "\\F677";
}

.mdi-bowl:before {
  content: "\\F617";
}

.mdi-bowling:before {
  content: "\\F0D3";
}

.mdi-box:before {
  content: "\\F0D4";
}

.mdi-box-cutter:before {
  content: "\\F0D5";
}

.mdi-box-shadow:before {
  content: "\\F637";
}

.mdi-bridge:before {
  content: "\\F618";
}

.mdi-briefcase:before {
  content: "\\F0D6";
}

.mdi-briefcase-check:before {
  content: "\\F0D7";
}

.mdi-briefcase-download:before {
  content: "\\F0D8";
}

.mdi-briefcase-outline:before {
  content: "\\F813";
}

.mdi-briefcase-upload:before {
  content: "\\F0D9";
}

.mdi-brightness-1:before {
  content: "\\F0DA";
}

.mdi-brightness-2:before {
  content: "\\F0DB";
}

.mdi-brightness-3:before {
  content: "\\F0DC";
}

.mdi-brightness-4:before {
  content: "\\F0DD";
}

.mdi-brightness-5:before {
  content: "\\F0DE";
}

.mdi-brightness-6:before {
  content: "\\F0DF";
}

.mdi-brightness-7:before {
  content: "\\F0E0";
}

.mdi-brightness-auto:before {
  content: "\\F0E1";
}

.mdi-broom:before {
  content: "\\F0E2";
}

.mdi-brush:before {
  content: "\\F0E3";
}

.mdi-buddhism:before {
  content: "\\F94A";
}

.mdi-buffer:before {
  content: "\\F619";
}

.mdi-bug:before {
  content: "\\F0E4";
}

.mdi-bulletin-board:before {
  content: "\\F0E5";
}

.mdi-bullhorn:before {
  content: "\\F0E6";
}

.mdi-bullseye:before {
  content: "\\F5DD";
}

.mdi-bullseye-arrow:before {
  content: "\\F8C8";
}

.mdi-bus:before {
  content: "\\F0E7";
}

.mdi-bus-articulated-end:before {
  content: "\\F79B";
}

.mdi-bus-articulated-front:before {
  content: "\\F79C";
}

.mdi-bus-clock:before {
  content: "\\F8C9";
}

.mdi-bus-double-decker:before {
  content: "\\F79D";
}

.mdi-bus-school:before {
  content: "\\F79E";
}

.mdi-bus-side:before {
  content: "\\F79F";
}

.mdi-cached:before {
  content: "\\F0E8";
}

.mdi-cake:before {
  content: "\\F0E9";
}

.mdi-cake-layered:before {
  content: "\\F0EA";
}

.mdi-cake-variant:before {
  content: "\\F0EB";
}

.mdi-calculator:before {
  content: "\\F0EC";
}

.mdi-calendar:before {
  content: "\\F0ED";
}

.mdi-calendar-blank:before {
  content: "\\F0EE";
}

.mdi-calendar-check:before {
  content: "\\F0EF";
}

.mdi-calendar-clock:before {
  content: "\\F0F0";
}

.mdi-calendar-edit:before {
  content: "\\F8A6";
}

.mdi-calendar-multiple:before {
  content: "\\F0F1";
}

.mdi-calendar-multiple-check:before {
  content: "\\F0F2";
}

.mdi-calendar-plus:before {
  content: "\\F0F3";
}

.mdi-calendar-question:before {
  content: "\\F691";
}

.mdi-calendar-range:before {
  content: "\\F678";
}

.mdi-calendar-remove:before {
  content: "\\F0F4";
}

.mdi-calendar-search:before {
  content: "\\F94B";
}

.mdi-calendar-text:before {
  content: "\\F0F5";
}

.mdi-calendar-today:before {
  content: "\\F0F6";
}

.mdi-call-made:before {
  content: "\\F0F7";
}

.mdi-call-merge:before {
  content: "\\F0F8";
}

.mdi-call-missed:before {
  content: "\\F0F9";
}

.mdi-call-received:before {
  content: "\\F0FA";
}

.mdi-call-split:before {
  content: "\\F0FB";
}

.mdi-camcorder:before {
  content: "\\F0FC";
}

.mdi-camcorder-box:before {
  content: "\\F0FD";
}

.mdi-camcorder-box-off:before {
  content: "\\F0FE";
}

.mdi-camcorder-off:before {
  content: "\\F0FF";
}

.mdi-camera:before {
  content: "\\F100";
}

.mdi-camera-account:before {
  content: "\\F8CA";
}

.mdi-camera-burst:before {
  content: "\\F692";
}

.mdi-camera-enhance:before {
  content: "\\F101";
}

.mdi-camera-front:before {
  content: "\\F102";
}

.mdi-camera-front-variant:before {
  content: "\\F103";
}

.mdi-camera-gopro:before {
  content: "\\F7A0";
}

.mdi-camera-image:before {
  content: "\\F8CB";
}

.mdi-camera-iris:before {
  content: "\\F104";
}

.mdi-camera-metering-center:before {
  content: "\\F7A1";
}

.mdi-camera-metering-matrix:before {
  content: "\\F7A2";
}

.mdi-camera-metering-partial:before {
  content: "\\F7A3";
}

.mdi-camera-metering-spot:before {
  content: "\\F7A4";
}

.mdi-camera-off:before {
  content: "\\F5DF";
}

.mdi-camera-party-mode:before {
  content: "\\F105";
}

.mdi-camera-rear:before {
  content: "\\F106";
}

.mdi-camera-rear-variant:before {
  content: "\\F107";
}

.mdi-camera-switch:before {
  content: "\\F108";
}

.mdi-camera-timer:before {
  content: "\\F109";
}

.mdi-cancel:before {
  content: "\\F739";
}

.mdi-candle:before {
  content: "\\F5E2";
}

.mdi-candycane:before {
  content: "\\F10A";
}

.mdi-cannabis:before {
  content: "\\F7A5";
}

.mdi-car:before {
  content: "\\F10B";
}

.mdi-car-battery:before {
  content: "\\F10C";
}

.mdi-car-connected:before {
  content: "\\F10D";
}

.mdi-car-convertible:before {
  content: "\\F7A6";
}

.mdi-car-estate:before {
  content: "\\F7A7";
}

.mdi-car-hatchback:before {
  content: "\\F7A8";
}

.mdi-car-limousine:before {
  content: "\\F8CC";
}

.mdi-car-pickup:before {
  content: "\\F7A9";
}

.mdi-car-side:before {
  content: "\\F7AA";
}

.mdi-car-sports:before {
  content: "\\F7AB";
}

.mdi-car-wash:before {
  content: "\\F10E";
}

.mdi-caravan:before {
  content: "\\F7AC";
}

.mdi-cards:before {
  content: "\\F638";
}

.mdi-cards-club:before {
  content: "\\F8CD";
}

.mdi-cards-diamond:before {
  content: "\\F8CE";
}

.mdi-cards-heart:before {
  content: "\\F8CF";
}

.mdi-cards-outline:before {
  content: "\\F639";
}

.mdi-cards-playing-outline:before {
  content: "\\F63A";
}

.mdi-cards-spade:before {
  content: "\\F8D0";
}

.mdi-cards-variant:before {
  content: "\\F6C6";
}

.mdi-carrot:before {
  content: "\\F10F";
}

.mdi-cart:before {
  content: "\\F110";
}

.mdi-cart-off:before {
  content: "\\F66B";
}

.mdi-cart-outline:before {
  content: "\\F111";
}

.mdi-cart-plus:before {
  content: "\\F112";
}

.mdi-case-sensitive-alt:before {
  content: "\\F113";
}

.mdi-cash:before {
  content: "\\F114";
}

.mdi-cash-100:before {
  content: "\\F115";
}

.mdi-cash-multiple:before {
  content: "\\F116";
}

.mdi-cash-usd:before {
  content: "\\F117";
}

.mdi-cast:before {
  content: "\\F118";
}

.mdi-cast-connected:before {
  content: "\\F119";
}

.mdi-cast-off:before {
  content: "\\F789";
}

.mdi-castle:before {
  content: "\\F11A";
}

.mdi-cat:before {
  content: "\\F11B";
}

.mdi-cctv:before {
  content: "\\F7AD";
}

.mdi-ceiling-light:before {
  content: "\\F768";
}

.mdi-cellphone:before {
  content: "\\F11C";
}

.mdi-cellphone-android:before {
  content: "\\F11D";
}

.mdi-cellphone-basic:before {
  content: "\\F11E";
}

.mdi-cellphone-dock:before {
  content: "\\F11F";
}

.mdi-cellphone-erase:before {
  content: "\\F94C";
}

.mdi-cellphone-iphone:before {
  content: "\\F120";
}

.mdi-cellphone-key:before {
  content: "\\F94D";
}

.mdi-cellphone-link:before {
  content: "\\F121";
}

.mdi-cellphone-link-off:before {
  content: "\\F122";
}

.mdi-cellphone-lock:before {
  content: "\\F94E";
}

.mdi-cellphone-message:before {
  content: "\\F8D2";
}

.mdi-cellphone-off:before {
  content: "\\F94F";
}

.mdi-cellphone-settings:before {
  content: "\\F123";
}

.mdi-cellphone-settings-variant:before {
  content: "\\F950";
}

.mdi-cellphone-sound:before {
  content: "\\F951";
}

.mdi-cellphone-text:before {
  content: "\\F8D1";
}

.mdi-cellphone-wireless:before {
  content: "\\F814";
}

.mdi-certificate:before {
  content: "\\F124";
}

.mdi-chair-school:before {
  content: "\\F125";
}

.mdi-chart-arc:before {
  content: "\\F126";
}

.mdi-chart-areaspline:before {
  content: "\\F127";
}

.mdi-chart-bar:before {
  content: "\\F128";
}

.mdi-chart-bar-stacked:before {
  content: "\\F769";
}

.mdi-chart-bubble:before {
  content: "\\F5E3";
}

.mdi-chart-donut:before {
  content: "\\F7AE";
}

.mdi-chart-donut-variant:before {
  content: "\\F7AF";
}

.mdi-chart-gantt:before {
  content: "\\F66C";
}

.mdi-chart-histogram:before {
  content: "\\F129";
}

.mdi-chart-line:before {
  content: "\\F12A";
}

.mdi-chart-line-stacked:before {
  content: "\\F76A";
}

.mdi-chart-line-variant:before {
  content: "\\F7B0";
}

.mdi-chart-multiline:before {
  content: "\\F8D3";
}

.mdi-chart-pie:before {
  content: "\\F12B";
}

.mdi-chart-scatterplot-hexbin:before {
  content: "\\F66D";
}

.mdi-chart-timeline:before {
  content: "\\F66E";
}

.mdi-check:before {
  content: "\\F12C";
}

.mdi-check-all:before {
  content: "\\F12D";
}

.mdi-check-circle:before {
  content: "\\F5E0";
}

.mdi-check-circle-outline:before {
  content: "\\F5E1";
}

.mdi-check-outline:before {
  content: "\\F854";
}

.mdi-checkbox-blank:before {
  content: "\\F12E";
}

.mdi-checkbox-blank-circle:before {
  content: "\\F12F";
}

.mdi-checkbox-blank-circle-outline:before {
  content: "\\F130";
}

.mdi-checkbox-blank-outline:before {
  content: "\\F131";
}

.mdi-checkbox-intermediate:before {
  content: "\\F855";
}

.mdi-checkbox-marked:before {
  content: "\\F132";
}

.mdi-checkbox-marked-circle:before {
  content: "\\F133";
}

.mdi-checkbox-marked-circle-outline:before {
  content: "\\F134";
}

.mdi-checkbox-marked-outline:before {
  content: "\\F135";
}

.mdi-checkbox-multiple-blank:before {
  content: "\\F136";
}

.mdi-checkbox-multiple-blank-circle:before {
  content: "\\F63B";
}

.mdi-checkbox-multiple-blank-circle-outline:before {
  content: "\\F63C";
}

.mdi-checkbox-multiple-blank-outline:before {
  content: "\\F137";
}

.mdi-checkbox-multiple-marked:before {
  content: "\\F138";
}

.mdi-checkbox-multiple-marked-circle:before {
  content: "\\F63D";
}

.mdi-checkbox-multiple-marked-circle-outline:before {
  content: "\\F63E";
}

.mdi-checkbox-multiple-marked-outline:before {
  content: "\\F139";
}

.mdi-checkerboard:before {
  content: "\\F13A";
}

.mdi-chemical-weapon:before {
  content: "\\F13B";
}

.mdi-chess-bishop:before {
  content: "\\F85B";
}

.mdi-chess-king:before {
  content: "\\F856";
}

.mdi-chess-knight:before {
  content: "\\F857";
}

.mdi-chess-pawn:before {
  content: "\\F858";
}

.mdi-chess-queen:before {
  content: "\\F859";
}

.mdi-chess-rook:before {
  content: "\\F85A";
}

.mdi-chevron-double-down:before {
  content: "\\F13C";
}

.mdi-chevron-double-left:before {
  content: "\\F13D";
}

.mdi-chevron-double-right:before {
  content: "\\F13E";
}

.mdi-chevron-double-up:before {
  content: "\\F13F";
}

.mdi-chevron-down:before {
  content: "\\F140";
}

.mdi-chevron-left:before {
  content: "\\F141";
}

.mdi-chevron-right:before {
  content: "\\F142";
}

.mdi-chevron-up:before {
  content: "\\F143";
}

.mdi-chili-hot:before {
  content: "\\F7B1";
}

.mdi-chili-medium:before {
  content: "\\F7B2";
}

.mdi-chili-mild:before {
  content: "\\F7B3";
}

.mdi-chip:before {
  content: "\\F61A";
}

.mdi-christiantiy:before {
  content: "\\F952";
}

.mdi-church:before {
  content: "\\F144";
}

.mdi-circle:before {
  content: "\\F764";
}

.mdi-circle-edit-outline:before {
  content: "\\F8D4";
}

.mdi-circle-outline:before {
  content: "\\F765";
}

.mdi-cisco-webex:before {
  content: "\\F145";
}

.mdi-city:before {
  content: "\\F146";
}

.mdi-clipboard:before {
  content: "\\F147";
}

.mdi-clipboard-account:before {
  content: "\\F148";
}

.mdi-clipboard-alert:before {
  content: "\\F149";
}

.mdi-clipboard-arrow-down:before {
  content: "\\F14A";
}

.mdi-clipboard-arrow-left:before {
  content: "\\F14B";
}

.mdi-clipboard-check:before {
  content: "\\F14C";
}

.mdi-clipboard-check-outline:before {
  content: "\\F8A7";
}

.mdi-clipboard-flow:before {
  content: "\\F6C7";
}

.mdi-clipboard-outline:before {
  content: "\\F14D";
}

.mdi-clipboard-plus:before {
  content: "\\F750";
}

.mdi-clipboard-pulse:before {
  content: "\\F85C";
}

.mdi-clipboard-pulse-outline:before {
  content: "\\F85D";
}

.mdi-clipboard-text:before {
  content: "\\F14E";
}

.mdi-clippy:before {
  content: "\\F14F";
}

.mdi-clock:before {
  content: "\\F953";
}

.mdi-clock-alert:before {
  content: "\\F954";
}

.mdi-clock-alert-outline:before {
  content: "\\F5CE";
}

.mdi-clock-end:before {
  content: "\\F151";
}

.mdi-clock-fast:before {
  content: "\\F152";
}

.mdi-clock-in:before {
  content: "\\F153";
}

.mdi-clock-out:before {
  content: "\\F154";
}

.mdi-clock-outline:before {
  content: "\\F150";
}

.mdi-clock-start:before {
  content: "\\F155";
}

.mdi-close:before {
  content: "\\F156";
}

.mdi-close-box:before {
  content: "\\F157";
}

.mdi-close-box-outline:before {
  content: "\\F158";
}

.mdi-close-circle:before {
  content: "\\F159";
}

.mdi-close-circle-outline:before {
  content: "\\F15A";
}

.mdi-close-network:before {
  content: "\\F15B";
}

.mdi-close-octagon:before {
  content: "\\F15C";
}

.mdi-close-octagon-outline:before {
  content: "\\F15D";
}

.mdi-close-outline:before {
  content: "\\F6C8";
}

.mdi-closed-caption:before {
  content: "\\F15E";
}

.mdi-cloud:before {
  content: "\\F15F";
}

.mdi-cloud-braces:before {
  content: "\\F7B4";
}

.mdi-cloud-check:before {
  content: "\\F160";
}

.mdi-cloud-circle:before {
  content: "\\F161";
}

.mdi-cloud-download:before {
  content: "\\F162";
}

.mdi-cloud-off-outline:before {
  content: "\\F164";
}

.mdi-cloud-outline:before {
  content: "\\F163";
}

.mdi-cloud-print:before {
  content: "\\F165";
}

.mdi-cloud-print-outline:before {
  content: "\\F166";
}

.mdi-cloud-search:before {
  content: "\\F955";
}

.mdi-cloud-search-outline:before {
  content: "\\F956";
}

.mdi-cloud-sync:before {
  content: "\\F63F";
}

.mdi-cloud-tags:before {
  content: "\\F7B5";
}

.mdi-cloud-upload:before {
  content: "\\F167";
}

.mdi-clover:before {
  content: "\\F815";
}

.mdi-code-array:before {
  content: "\\F168";
}

.mdi-code-braces:before {
  content: "\\F169";
}

.mdi-code-brackets:before {
  content: "\\F16A";
}

.mdi-code-equal:before {
  content: "\\F16B";
}

.mdi-code-greater-than:before {
  content: "\\F16C";
}

.mdi-code-greater-than-or-equal:before {
  content: "\\F16D";
}

.mdi-code-less-than:before {
  content: "\\F16E";
}

.mdi-code-less-than-or-equal:before {
  content: "\\F16F";
}

.mdi-code-not-equal:before {
  content: "\\F170";
}

.mdi-code-not-equal-variant:before {
  content: "\\F171";
}

.mdi-code-parentheses:before {
  content: "\\F172";
}

.mdi-code-string:before {
  content: "\\F173";
}

.mdi-code-tags:before {
  content: "\\F174";
}

.mdi-code-tags-check:before {
  content: "\\F693";
}

.mdi-codepen:before {
  content: "\\F175";
}

.mdi-coffee:before {
  content: "\\F176";
}

.mdi-coffee-outline:before {
  content: "\\F6C9";
}

.mdi-coffee-to-go:before {
  content: "\\F177";
}

.mdi-cogs:before {
  content: "\\F8D5";
}

.mdi-coin:before {
  content: "\\F178";
}

.mdi-coins:before {
  content: "\\F694";
}

.mdi-collage:before {
  content: "\\F640";
}

.mdi-color-helper:before {
  content: "\\F179";
}

.mdi-comment:before {
  content: "\\F17A";
}

.mdi-comment-account:before {
  content: "\\F17B";
}

.mdi-comment-account-outline:before {
  content: "\\F17C";
}

.mdi-comment-alert:before {
  content: "\\F17D";
}

.mdi-comment-alert-outline:before {
  content: "\\F17E";
}

.mdi-comment-check:before {
  content: "\\F17F";
}

.mdi-comment-check-outline:before {
  content: "\\F180";
}

.mdi-comment-multiple:before {
  content: "\\F85E";
}

.mdi-comment-multiple-outline:before {
  content: "\\F181";
}

.mdi-comment-outline:before {
  content: "\\F182";
}

.mdi-comment-plus-outline:before {
  content: "\\F183";
}

.mdi-comment-processing:before {
  content: "\\F184";
}

.mdi-comment-processing-outline:before {
  content: "\\F185";
}

.mdi-comment-question:before {
  content: "\\F816";
}

.mdi-comment-question-outline:before {
  content: "\\F186";
}

.mdi-comment-remove:before {
  content: "\\F5DE";
}

.mdi-comment-remove-outline:before {
  content: "\\F187";
}

.mdi-comment-text:before {
  content: "\\F188";
}

.mdi-comment-text-multiple:before {
  content: "\\F85F";
}

.mdi-comment-text-multiple-outline:before {
  content: "\\F860";
}

.mdi-comment-text-outline:before {
  content: "\\F189";
}

.mdi-compare:before {
  content: "\\F18A";
}

.mdi-compass:before {
  content: "\\F18B";
}

.mdi-compass-outline:before {
  content: "\\F18C";
}

.mdi-console:before {
  content: "\\F18D";
}

.mdi-console-line:before {
  content: "\\F7B6";
}

.mdi-console-network:before {
  content: "\\F8A8";
}

.mdi-contact-mail:before {
  content: "\\F18E";
}

.mdi-contacts:before {
  content: "\\F6CA";
}

.mdi-content-copy:before {
  content: "\\F18F";
}

.mdi-content-cut:before {
  content: "\\F190";
}

.mdi-content-duplicate:before {
  content: "\\F191";
}

.mdi-content-paste:before {
  content: "\\F192";
}

.mdi-content-save:before {
  content: "\\F193";
}

.mdi-content-save-all:before {
  content: "\\F194";
}

.mdi-content-save-outline:before {
  content: "\\F817";
}

.mdi-content-save-settings:before {
  content: "\\F61B";
}

.mdi-contrast:before {
  content: "\\F195";
}

.mdi-contrast-box:before {
  content: "\\F196";
}

.mdi-contrast-circle:before {
  content: "\\F197";
}

.mdi-cookie:before {
  content: "\\F198";
}

.mdi-copyright:before {
  content: "\\F5E6";
}

.mdi-cordova:before {
  content: "\\F957";
}

.mdi-corn:before {
  content: "\\F7B7";
}

.mdi-counter:before {
  content: "\\F199";
}

.mdi-cow:before {
  content: "\\F19A";
}

.mdi-crane:before {
  content: "\\F861";
}

.mdi-creation:before {
  content: "\\F1C9";
}

.mdi-credit-card:before {
  content: "\\F19B";
}

.mdi-credit-card-multiple:before {
  content: "\\F19C";
}

.mdi-credit-card-off:before {
  content: "\\F5E4";
}

.mdi-credit-card-plus:before {
  content: "\\F675";
}

.mdi-credit-card-scan:before {
  content: "\\F19D";
}

.mdi-credit-card-settings:before {
  content: "\\F8D6";
}

.mdi-crop:before {
  content: "\\F19E";
}

.mdi-crop-free:before {
  content: "\\F19F";
}

.mdi-crop-landscape:before {
  content: "\\F1A0";
}

.mdi-crop-portrait:before {
  content: "\\F1A1";
}

.mdi-crop-rotate:before {
  content: "\\F695";
}

.mdi-crop-square:before {
  content: "\\F1A2";
}

.mdi-crosshairs:before {
  content: "\\F1A3";
}

.mdi-crosshairs-gps:before {
  content: "\\F1A4";
}

.mdi-crown:before {
  content: "\\F1A5";
}

.mdi-cryengine:before {
  content: "\\F958";
}

.mdi-cube:before {
  content: "\\F1A6";
}

.mdi-cube-outline:before {
  content: "\\F1A7";
}

.mdi-cube-send:before {
  content: "\\F1A8";
}

.mdi-cube-unfolded:before {
  content: "\\F1A9";
}

.mdi-cup:before {
  content: "\\F1AA";
}

.mdi-cup-off:before {
  content: "\\F5E5";
}

.mdi-cup-water:before {
  content: "\\F1AB";
}

.mdi-cupcake:before {
  content: "\\F959";
}

.mdi-curling:before {
  content: "\\F862";
}

.mdi-currency-bdt:before {
  content: "\\F863";
}

.mdi-currency-btc:before {
  content: "\\F1AC";
}

.mdi-currency-chf:before {
  content: "\\F7B8";
}

.mdi-currency-cny:before {
  content: "\\F7B9";
}

.mdi-currency-eth:before {
  content: "\\F7BA";
}

.mdi-currency-eur:before {
  content: "\\F1AD";
}

.mdi-currency-gbp:before {
  content: "\\F1AE";
}

.mdi-currency-inr:before {
  content: "\\F1AF";
}

.mdi-currency-jpy:before {
  content: "\\F7BB";
}

.mdi-currency-krw:before {
  content: "\\F7BC";
}

.mdi-currency-kzt:before {
  content: "\\F864";
}

.mdi-currency-ngn:before {
  content: "\\F1B0";
}

.mdi-currency-rub:before {
  content: "\\F1B1";
}

.mdi-currency-sign:before {
  content: "\\F7BD";
}

.mdi-currency-try:before {
  content: "\\F1B2";
}

.mdi-currency-twd:before {
  content: "\\F7BE";
}

.mdi-currency-usd:before {
  content: "\\F1B3";
}

.mdi-currency-usd-off:before {
  content: "\\F679";
}

.mdi-current-ac:before {
  content: "\\F95A";
}

.mdi-current-dc:before {
  content: "\\F95B";
}

.mdi-cursor-default:before {
  content: "\\F1B4";
}

.mdi-cursor-default-outline:before {
  content: "\\F1B5";
}

.mdi-cursor-move:before {
  content: "\\F1B6";
}

.mdi-cursor-pointer:before {
  content: "\\F1B7";
}

.mdi-cursor-text:before {
  content: "\\F5E7";
}

.mdi-database:before {
  content: "\\F1B8";
}

.mdi-database-export:before {
  content: "\\F95D";
}

.mdi-database-import:before {
  content: "\\F95C";
}

.mdi-database-minus:before {
  content: "\\F1B9";
}

.mdi-database-plus:before {
  content: "\\F1BA";
}

.mdi-database-search:before {
  content: "\\F865";
}

.mdi-death-star:before {
  content: "\\F8D7";
}

.mdi-death-star-variant:before {
  content: "\\F8D8";
}

.mdi-debian:before {
  content: "\\F8D9";
}

.mdi-debug-step-into:before {
  content: "\\F1BB";
}

.mdi-debug-step-out:before {
  content: "\\F1BC";
}

.mdi-debug-step-over:before {
  content: "\\F1BD";
}

.mdi-decagram:before {
  content: "\\F76B";
}

.mdi-decagram-outline:before {
  content: "\\F76C";
}

.mdi-decimal-decrease:before {
  content: "\\F1BE";
}

.mdi-decimal-increase:before {
  content: "\\F1BF";
}

.mdi-delete:before {
  content: "\\F1C0";
}

.mdi-delete-circle:before {
  content: "\\F682";
}

.mdi-delete-empty:before {
  content: "\\F6CB";
}

.mdi-delete-forever:before {
  content: "\\F5E8";
}

.mdi-delete-restore:before {
  content: "\\F818";
}

.mdi-delete-sweep:before {
  content: "\\F5E9";
}

.mdi-delete-variant:before {
  content: "\\F1C1";
}

.mdi-delta:before {
  content: "\\F1C2";
}

.mdi-desk-lamp:before {
  content: "\\F95E";
}

.mdi-deskphone:before {
  content: "\\F1C3";
}

.mdi-desktop-classic:before {
  content: "\\F7BF";
}

.mdi-desktop-mac:before {
  content: "\\F1C4";
}

.mdi-desktop-tower:before {
  content: "\\F1C5";
}

.mdi-details:before {
  content: "\\F1C6";
}

.mdi-developer-board:before {
  content: "\\F696";
}

.mdi-deviantart:before {
  content: "\\F1C7";
}

.mdi-dialpad:before {
  content: "\\F61C";
}

.mdi-diamond:before {
  content: "\\F1C8";
}

.mdi-dice-1:before {
  content: "\\F1CA";
}

.mdi-dice-2:before {
  content: "\\F1CB";
}

.mdi-dice-3:before {
  content: "\\F1CC";
}

.mdi-dice-4:before {
  content: "\\F1CD";
}

.mdi-dice-5:before {
  content: "\\F1CE";
}

.mdi-dice-6:before {
  content: "\\F1CF";
}

.mdi-dice-d10:before {
  content: "\\F76E";
}

.mdi-dice-d12:before {
  content: "\\F866";
}

.mdi-dice-d20:before {
  content: "\\F5EA";
}

.mdi-dice-d4:before {
  content: "\\F5EB";
}

.mdi-dice-d6:before {
  content: "\\F5EC";
}

.mdi-dice-d8:before {
  content: "\\F5ED";
}

.mdi-dice-multiple:before {
  content: "\\F76D";
}

.mdi-dictionary:before {
  content: "\\F61D";
}

.mdi-dip-switch:before {
  content: "\\F7C0";
}

.mdi-directions:before {
  content: "\\F1D0";
}

.mdi-directions-fork:before {
  content: "\\F641";
}

.mdi-discord:before {
  content: "\\F66F";
}

.mdi-disk:before {
  content: "\\F5EE";
}

.mdi-disk-alert:before {
  content: "\\F1D1";
}

.mdi-disk-player:before {
  content: "\\F95F";
}

.mdi-disqus:before {
  content: "\\F1D2";
}

.mdi-disqus-outline:before {
  content: "\\F1D3";
}

.mdi-division:before {
  content: "\\F1D4";
}

.mdi-division-box:before {
  content: "\\F1D5";
}

.mdi-dna:before {
  content: "\\F683";
}

.mdi-dns:before {
  content: "\\F1D6";
}

.mdi-do-not-disturb:before {
  content: "\\F697";
}

.mdi-do-not-disturb-off:before {
  content: "\\F698";
}

.mdi-docker:before {
  content: "\\F867";
}

.mdi-dolby:before {
  content: "\\F6B2";
}

.mdi-domain:before {
  content: "\\F1D7";
}

.mdi-donkey:before {
  content: "\\F7C1";
}

.mdi-door:before {
  content: "\\F819";
}

.mdi-door-closed:before {
  content: "\\F81A";
}

.mdi-door-open:before {
  content: "\\F81B";
}

.mdi-doorbell-video:before {
  content: "\\F868";
}

.mdi-dots-horizontal:before {
  content: "\\F1D8";
}

.mdi-dots-horizontal-circle:before {
  content: "\\F7C2";
}

.mdi-dots-vertical:before {
  content: "\\F1D9";
}

.mdi-dots-vertical-circle:before {
  content: "\\F7C3";
}

.mdi-douban:before {
  content: "\\F699";
}

.mdi-download:before {
  content: "\\F1DA";
}

.mdi-download-network:before {
  content: "\\F6F3";
}

.mdi-drag:before {
  content: "\\F1DB";
}

.mdi-drag-horizontal:before {
  content: "\\F1DC";
}

.mdi-drag-vertical:before {
  content: "\\F1DD";
}

.mdi-drawing:before {
  content: "\\F1DE";
}

.mdi-drawing-box:before {
  content: "\\F1DF";
}

.mdi-dribbble:before {
  content: "\\F1E0";
}

.mdi-dribbble-box:before {
  content: "\\F1E1";
}

.mdi-drone:before {
  content: "\\F1E2";
}

.mdi-dropbox:before {
  content: "\\F1E3";
}

.mdi-drupal:before {
  content: "\\F1E4";
}

.mdi-duck:before {
  content: "\\F1E5";
}

.mdi-dumbbell:before {
  content: "\\F1E6";
}

.mdi-ear-hearing:before {
  content: "\\F7C4";
}

.mdi-earth:before {
  content: "\\F1E7";
}

.mdi-earth-box:before {
  content: "\\F6CC";
}

.mdi-earth-box-off:before {
  content: "\\F6CD";
}

.mdi-earth-off:before {
  content: "\\F1E8";
}

.mdi-edge:before {
  content: "\\F1E9";
}

.mdi-eject:before {
  content: "\\F1EA";
}

.mdi-elephant:before {
  content: "\\F7C5";
}

.mdi-elevation-decline:before {
  content: "\\F1EB";
}

.mdi-elevation-rise:before {
  content: "\\F1EC";
}

.mdi-elevator:before {
  content: "\\F1ED";
}

.mdi-email:before {
  content: "\\F1EE";
}

.mdi-email-alert:before {
  content: "\\F6CE";
}

.mdi-email-open:before {
  content: "\\F1EF";
}

.mdi-email-open-outline:before {
  content: "\\F5EF";
}

.mdi-email-outline:before {
  content: "\\F1F0";
}

.mdi-email-search:before {
  content: "\\F960";
}

.mdi-email-search-outline:before {
  content: "\\F961";
}

.mdi-email-secure:before {
  content: "\\F1F1";
}

.mdi-email-variant:before {
  content: "\\F5F0";
}

.mdi-emby:before {
  content: "\\F6B3";
}

.mdi-emoticon:before {
  content: "\\F1F2";
}

.mdi-emoticon-cool:before {
  content: "\\F1F3";
}

.mdi-emoticon-dead:before {
  content: "\\F69A";
}

.mdi-emoticon-devil:before {
  content: "\\F1F4";
}

.mdi-emoticon-excited:before {
  content: "\\F69B";
}

.mdi-emoticon-happy:before {
  content: "\\F1F5";
}

.mdi-emoticon-neutral:before {
  content: "\\F1F6";
}

.mdi-emoticon-poop:before {
  content: "\\F1F7";
}

.mdi-emoticon-sad:before {
  content: "\\F1F8";
}

.mdi-emoticon-tongue:before {
  content: "\\F1F9";
}

.mdi-engine:before {
  content: "\\F1FA";
}

.mdi-engine-outline:before {
  content: "\\F1FB";
}

.mdi-equal:before {
  content: "\\F1FC";
}

.mdi-equal-box:before {
  content: "\\F1FD";
}

.mdi-eraser:before {
  content: "\\F1FE";
}

.mdi-eraser-variant:before {
  content: "\\F642";
}

.mdi-escalator:before {
  content: "\\F1FF";
}

.mdi-ethereum:before {
  content: "\\F869";
}

.mdi-ethernet:before {
  content: "\\F200";
}

.mdi-ethernet-cable:before {
  content: "\\F201";
}

.mdi-ethernet-cable-off:before {
  content: "\\F202";
}

.mdi-etsy:before {
  content: "\\F203";
}

.mdi-ev-station:before {
  content: "\\F5F1";
}

.mdi-eventbrite:before {
  content: "\\F7C6";
}

.mdi-evernote:before {
  content: "\\F204";
}

.mdi-exclamation:before {
  content: "\\F205";
}

.mdi-exit-to-app:before {
  content: "\\F206";
}

.mdi-exponent:before {
  content: "\\F962";
}

.mdi-exponent-box:before {
  content: "\\F963";
}

.mdi-export:before {
  content: "\\F207";
}

.mdi-eye:before {
  content: "\\F208";
}

.mdi-eye-off:before {
  content: "\\F209";
}

.mdi-eye-off-outline:before {
  content: "\\F6D0";
}

.mdi-eye-outline:before {
  content: "\\F6CF";
}

.mdi-eye-plus:before {
  content: "\\F86A";
}

.mdi-eye-plus-outline:before {
  content: "\\F86B";
}

.mdi-eye-settings:before {
  content: "\\F86C";
}

.mdi-eye-settings-outline:before {
  content: "\\F86D";
}

.mdi-eyedropper:before {
  content: "\\F20A";
}

.mdi-eyedropper-variant:before {
  content: "\\F20B";
}

.mdi-face:before {
  content: "\\F643";
}

.mdi-face-profile:before {
  content: "\\F644";
}

.mdi-facebook:before {
  content: "\\F20C";
}

.mdi-facebook-box:before {
  content: "\\F20D";
}

.mdi-facebook-messenger:before {
  content: "\\F20E";
}

.mdi-factory:before {
  content: "\\F20F";
}

.mdi-fan:before {
  content: "\\F210";
}

.mdi-fan-off:before {
  content: "\\F81C";
}

.mdi-fast-forward:before {
  content: "\\F211";
}

.mdi-fast-forward-outline:before {
  content: "\\F6D1";
}

.mdi-fax:before {
  content: "\\F212";
}

.mdi-feather:before {
  content: "\\F6D2";
}

.mdi-fedora:before {
  content: "\\F8DA";
}

.mdi-ferry:before {
  content: "\\F213";
}

.mdi-file:before {
  content: "\\F214";
}

.mdi-file-account:before {
  content: "\\F73A";
}

.mdi-file-chart:before {
  content: "\\F215";
}

.mdi-file-check:before {
  content: "\\F216";
}

.mdi-file-cloud:before {
  content: "\\F217";
}

.mdi-file-compare:before {
  content: "\\F8A9";
}

.mdi-file-delimited:before {
  content: "\\F218";
}

.mdi-file-document:before {
  content: "\\F219";
}

.mdi-file-document-box:before {
  content: "\\F21A";
}

.mdi-file-download:before {
  content: "\\F964";
}

.mdi-file-download-outline:before {
  content: "\\F965";
}

.mdi-file-excel:before {
  content: "\\F21B";
}

.mdi-file-excel-box:before {
  content: "\\F21C";
}

.mdi-file-export:before {
  content: "\\F21D";
}

.mdi-file-find:before {
  content: "\\F21E";
}

.mdi-file-hidden:before {
  content: "\\F613";
}

.mdi-file-image:before {
  content: "\\F21F";
}

.mdi-file-import:before {
  content: "\\F220";
}

.mdi-file-lock:before {
  content: "\\F221";
}

.mdi-file-multiple:before {
  content: "\\F222";
}

.mdi-file-music:before {
  content: "\\F223";
}

.mdi-file-outline:before {
  content: "\\F224";
}

.mdi-file-pdf:before {
  content: "\\F225";
}

.mdi-file-pdf-box:before {
  content: "\\F226";
}

.mdi-file-percent:before {
  content: "\\F81D";
}

.mdi-file-plus:before {
  content: "\\F751";
}

.mdi-file-powerpoint:before {
  content: "\\F227";
}

.mdi-file-powerpoint-box:before {
  content: "\\F228";
}

.mdi-file-presentation-box:before {
  content: "\\F229";
}

.mdi-file-question:before {
  content: "\\F86E";
}

.mdi-file-restore:before {
  content: "\\F670";
}

.mdi-file-send:before {
  content: "\\F22A";
}

.mdi-file-tree:before {
  content: "\\F645";
}

.mdi-file-undo:before {
  content: "\\F8DB";
}

.mdi-file-video:before {
  content: "\\F22B";
}

.mdi-file-word:before {
  content: "\\F22C";
}

.mdi-file-word-box:before {
  content: "\\F22D";
}

.mdi-file-xml:before {
  content: "\\F22E";
}

.mdi-film:before {
  content: "\\F22F";
}

.mdi-filmstrip:before {
  content: "\\F230";
}

.mdi-filmstrip-off:before {
  content: "\\F231";
}

.mdi-filter:before {
  content: "\\F232";
}

.mdi-filter-outline:before {
  content: "\\F233";
}

.mdi-filter-remove:before {
  content: "\\F234";
}

.mdi-filter-remove-outline:before {
  content: "\\F235";
}

.mdi-filter-variant:before {
  content: "\\F236";
}

.mdi-finance:before {
  content: "\\F81E";
}

.mdi-find-replace:before {
  content: "\\F6D3";
}

.mdi-fingerprint:before {
  content: "\\F237";
}

.mdi-fire:before {
  content: "\\F238";
}

.mdi-fire-truck:before {
  content: "\\F8AA";
}

.mdi-firebase:before {
  content: "\\F966";
}

.mdi-firefox:before {
  content: "\\F239";
}

.mdi-fish:before {
  content: "\\F23A";
}

.mdi-flag:before {
  content: "\\F23B";
}

.mdi-flag-checkered:before {
  content: "\\F23C";
}

.mdi-flag-outline:before {
  content: "\\F23D";
}

.mdi-flag-triangle:before {
  content: "\\F23F";
}

.mdi-flag-variant:before {
  content: "\\F240";
}

.mdi-flag-variant-outline:before {
  content: "\\F23E";
}

.mdi-flash:before {
  content: "\\F241";
}

.mdi-flash-auto:before {
  content: "\\F242";
}

.mdi-flash-circle:before {
  content: "\\F81F";
}

.mdi-flash-off:before {
  content: "\\F243";
}

.mdi-flash-outline:before {
  content: "\\F6D4";
}

.mdi-flash-red-eye:before {
  content: "\\F67A";
}

.mdi-flashlight:before {
  content: "\\F244";
}

.mdi-flashlight-off:before {
  content: "\\F245";
}

.mdi-flask:before {
  content: "\\F093";
}

.mdi-flask-empty:before {
  content: "\\F094";
}

.mdi-flask-empty-outline:before {
  content: "\\F095";
}

.mdi-flask-outline:before {
  content: "\\F096";
}

.mdi-flattr:before {
  content: "\\F246";
}

.mdi-flip-to-back:before {
  content: "\\F247";
}

.mdi-flip-to-front:before {
  content: "\\F248";
}

.mdi-floor-lamp:before {
  content: "\\F8DC";
}

.mdi-floor-plan:before {
  content: "\\F820";
}

.mdi-floppy:before {
  content: "\\F249";
}

.mdi-flower:before {
  content: "\\F24A";
}

.mdi-folder:before {
  content: "\\F24B";
}

.mdi-folder-account:before {
  content: "\\F24C";
}

.mdi-folder-download:before {
  content: "\\F24D";
}

.mdi-folder-edit:before {
  content: "\\F8DD";
}

.mdi-folder-google-drive:before {
  content: "\\F24E";
}

.mdi-folder-image:before {
  content: "\\F24F";
}

.mdi-folder-key:before {
  content: "\\F8AB";
}

.mdi-folder-key-network:before {
  content: "\\F8AC";
}

.mdi-folder-lock:before {
  content: "\\F250";
}

.mdi-folder-lock-open:before {
  content: "\\F251";
}

.mdi-folder-move:before {
  content: "\\F252";
}

.mdi-folder-multiple:before {
  content: "\\F253";
}

.mdi-folder-multiple-image:before {
  content: "\\F254";
}

.mdi-folder-multiple-outline:before {
  content: "\\F255";
}

.mdi-folder-network:before {
  content: "\\F86F";
}

.mdi-folder-open:before {
  content: "\\F76F";
}

.mdi-folder-outline:before {
  content: "\\F256";
}

.mdi-folder-plus:before {
  content: "\\F257";
}

.mdi-folder-remove:before {
  content: "\\F258";
}

.mdi-folder-search:before {
  content: "\\F967";
}

.mdi-folder-search-outline:before {
  content: "\\F968";
}

.mdi-folder-star:before {
  content: "\\F69C";
}

.mdi-folder-upload:before {
  content: "\\F259";
}

.mdi-font-awesome:before {
  content: "\\F03A";
}

.mdi-food:before {
  content: "\\F25A";
}

.mdi-food-apple:before {
  content: "\\F25B";
}

.mdi-food-croissant:before {
  content: "\\F7C7";
}

.mdi-food-fork-drink:before {
  content: "\\F5F2";
}

.mdi-food-off:before {
  content: "\\F5F3";
}

.mdi-food-variant:before {
  content: "\\F25C";
}

.mdi-football:before {
  content: "\\F25D";
}

.mdi-football-australian:before {
  content: "\\F25E";
}

.mdi-football-helmet:before {
  content: "\\F25F";
}

.mdi-forklift:before {
  content: "\\F7C8";
}

.mdi-format-align-bottom:before {
  content: "\\F752";
}

.mdi-format-align-center:before {
  content: "\\F260";
}

.mdi-format-align-justify:before {
  content: "\\F261";
}

.mdi-format-align-left:before {
  content: "\\F262";
}

.mdi-format-align-middle:before {
  content: "\\F753";
}

.mdi-format-align-right:before {
  content: "\\F263";
}

.mdi-format-align-top:before {
  content: "\\F754";
}

.mdi-format-annotation-plus:before {
  content: "\\F646";
}

.mdi-format-bold:before {
  content: "\\F264";
}

.mdi-format-clear:before {
  content: "\\F265";
}

.mdi-format-color-fill:before {
  content: "\\F266";
}

.mdi-format-color-text:before {
  content: "\\F69D";
}

.mdi-format-columns:before {
  content: "\\F8DE";
}

.mdi-format-float-center:before {
  content: "\\F267";
}

.mdi-format-float-left:before {
  content: "\\F268";
}

.mdi-format-float-none:before {
  content: "\\F269";
}

.mdi-format-float-right:before {
  content: "\\F26A";
}

.mdi-format-font:before {
  content: "\\F6D5";
}

.mdi-format-header-1:before {
  content: "\\F26B";
}

.mdi-format-header-2:before {
  content: "\\F26C";
}

.mdi-format-header-3:before {
  content: "\\F26D";
}

.mdi-format-header-4:before {
  content: "\\F26E";
}

.mdi-format-header-5:before {
  content: "\\F26F";
}

.mdi-format-header-6:before {
  content: "\\F270";
}

.mdi-format-header-decrease:before {
  content: "\\F271";
}

.mdi-format-header-equal:before {
  content: "\\F272";
}

.mdi-format-header-increase:before {
  content: "\\F273";
}

.mdi-format-header-pound:before {
  content: "\\F274";
}

.mdi-format-horizontal-align-center:before {
  content: "\\F61E";
}

.mdi-format-horizontal-align-left:before {
  content: "\\F61F";
}

.mdi-format-horizontal-align-right:before {
  content: "\\F620";
}

.mdi-format-indent-decrease:before {
  content: "\\F275";
}

.mdi-format-indent-increase:before {
  content: "\\F276";
}

.mdi-format-italic:before {
  content: "\\F277";
}

.mdi-format-line-spacing:before {
  content: "\\F278";
}

.mdi-format-line-style:before {
  content: "\\F5C8";
}

.mdi-format-line-weight:before {
  content: "\\F5C9";
}

.mdi-format-list-bulleted:before {
  content: "\\F279";
}

.mdi-format-list-bulleted-type:before {
  content: "\\F27A";
}

.mdi-format-list-checkbox:before {
  content: "\\F969";
}

.mdi-format-list-checks:before {
  content: "\\F755";
}

.mdi-format-list-numbers:before {
  content: "\\F27B";
}

.mdi-format-page-break:before {
  content: "\\F6D6";
}

.mdi-format-paint:before {
  content: "\\F27C";
}

.mdi-format-paragraph:before {
  content: "\\F27D";
}

.mdi-format-pilcrow:before {
  content: "\\F6D7";
}

.mdi-format-quote-close:before {
  content: "\\F27E";
}

.mdi-format-quote-open:before {
  content: "\\F756";
}

.mdi-format-rotate-90:before {
  content: "\\F6A9";
}

.mdi-format-section:before {
  content: "\\F69E";
}

.mdi-format-size:before {
  content: "\\F27F";
}

.mdi-format-strikethrough:before {
  content: "\\F280";
}

.mdi-format-strikethrough-variant:before {
  content: "\\F281";
}

.mdi-format-subscript:before {
  content: "\\F282";
}

.mdi-format-superscript:before {
  content: "\\F283";
}

.mdi-format-text:before {
  content: "\\F284";
}

.mdi-format-textdirection-l-to-r:before {
  content: "\\F285";
}

.mdi-format-textdirection-r-to-l:before {
  content: "\\F286";
}

.mdi-format-title:before {
  content: "\\F5F4";
}

.mdi-format-underline:before {
  content: "\\F287";
}

.mdi-format-vertical-align-bottom:before {
  content: "\\F621";
}

.mdi-format-vertical-align-center:before {
  content: "\\F622";
}

.mdi-format-vertical-align-top:before {
  content: "\\F623";
}

.mdi-format-wrap-inline:before {
  content: "\\F288";
}

.mdi-format-wrap-square:before {
  content: "\\F289";
}

.mdi-format-wrap-tight:before {
  content: "\\F28A";
}

.mdi-format-wrap-top-bottom:before {
  content: "\\F28B";
}

.mdi-forum:before {
  content: "\\F28C";
}

.mdi-forum-outline:before {
  content: "\\F821";
}

.mdi-forward:before {
  content: "\\F28D";
}

.mdi-fountain:before {
  content: "\\F96A";
}

.mdi-foursquare:before {
  content: "\\F28E";
}

.mdi-freebsd:before {
  content: "\\F8DF";
}

.mdi-fridge:before {
  content: "\\F28F";
}

.mdi-fridge-filled:before {
  content: "\\F290";
}

.mdi-fridge-filled-bottom:before {
  content: "\\F291";
}

.mdi-fridge-filled-top:before {
  content: "\\F292";
}

.mdi-fuel:before {
  content: "\\F7C9";
}

.mdi-fullscreen:before {
  content: "\\F293";
}

.mdi-fullscreen-exit:before {
  content: "\\F294";
}

.mdi-function:before {
  content: "\\F295";
}

.mdi-function-variant:before {
  content: "\\F870";
}

.mdi-gamepad:before {
  content: "\\F296";
}

.mdi-gamepad-variant:before {
  content: "\\F297";
}

.mdi-garage:before {
  content: "\\F6D8";
}

.mdi-garage-alert:before {
  content: "\\F871";
}

.mdi-garage-open:before {
  content: "\\F6D9";
}

.mdi-gas-cylinder:before {
  content: "\\F647";
}

.mdi-gas-station:before {
  content: "\\F298";
}

.mdi-gate:before {
  content: "\\F299";
}

.mdi-gate-and:before {
  content: "\\F8E0";
}

.mdi-gate-nand:before {
  content: "\\F8E1";
}

.mdi-gate-nor:before {
  content: "\\F8E2";
}

.mdi-gate-not:before {
  content: "\\F8E3";
}

.mdi-gate-or:before {
  content: "\\F8E4";
}

.mdi-gate-xnor:before {
  content: "\\F8E5";
}

.mdi-gate-xor:before {
  content: "\\F8E6";
}

.mdi-gauge:before {
  content: "\\F29A";
}

.mdi-gauge-empty:before {
  content: "\\F872";
}

.mdi-gauge-full:before {
  content: "\\F873";
}

.mdi-gauge-low:before {
  content: "\\F874";
}

.mdi-gavel:before {
  content: "\\F29B";
}

.mdi-gender-female:before {
  content: "\\F29C";
}

.mdi-gender-male:before {
  content: "\\F29D";
}

.mdi-gender-male-female:before {
  content: "\\F29E";
}

.mdi-gender-transgender:before {
  content: "\\F29F";
}

.mdi-gentoo:before {
  content: "\\F8E7";
}

.mdi-gesture:before {
  content: "\\F7CA";
}

.mdi-gesture-double-tap:before {
  content: "\\F73B";
}

.mdi-gesture-swipe-down:before {
  content: "\\F73C";
}

.mdi-gesture-swipe-left:before {
  content: "\\F73D";
}

.mdi-gesture-swipe-right:before {
  content: "\\F73E";
}

.mdi-gesture-swipe-up:before {
  content: "\\F73F";
}

.mdi-gesture-tap:before {
  content: "\\F740";
}

.mdi-gesture-two-double-tap:before {
  content: "\\F741";
}

.mdi-gesture-two-tap:before {
  content: "\\F742";
}

.mdi-ghost:before {
  content: "\\F2A0";
}

.mdi-gift:before {
  content: "\\F2A1";
}

.mdi-git:before {
  content: "\\F2A2";
}

.mdi-github-box:before {
  content: "\\F2A3";
}

.mdi-github-circle:before {
  content: "\\F2A4";
}

.mdi-github-face:before {
  content: "\\F6DA";
}

.mdi-glass-cocktail:before {
  content: "\\F356";
}

.mdi-glass-flute:before {
  content: "\\F2A5";
}

.mdi-glass-mug:before {
  content: "\\F2A6";
}

.mdi-glass-stange:before {
  content: "\\F2A7";
}

.mdi-glass-tulip:before {
  content: "\\F2A8";
}

.mdi-glass-wine:before {
  content: "\\F875";
}

.mdi-glassdoor:before {
  content: "\\F2A9";
}

.mdi-glasses:before {
  content: "\\F2AA";
}

.mdi-globe-model:before {
  content: "\\F8E8";
}

.mdi-gmail:before {
  content: "\\F2AB";
}

.mdi-gnome:before {
  content: "\\F2AC";
}

.mdi-golf:before {
  content: "\\F822";
}

.mdi-gondola:before {
  content: "\\F685";
}

.mdi-google:before {
  content: "\\F2AD";
}

.mdi-google-allo:before {
  content: "\\F801";
}

.mdi-google-analytics:before {
  content: "\\F7CB";
}

.mdi-google-assistant:before {
  content: "\\F7CC";
}

.mdi-google-cardboard:before {
  content: "\\F2AE";
}

.mdi-google-chrome:before {
  content: "\\F2AF";
}

.mdi-google-circles:before {
  content: "\\F2B0";
}

.mdi-google-circles-communities:before {
  content: "\\F2B1";
}

.mdi-google-circles-extended:before {
  content: "\\F2B2";
}

.mdi-google-circles-group:before {
  content: "\\F2B3";
}

.mdi-google-controller:before {
  content: "\\F2B4";
}

.mdi-google-controller-off:before {
  content: "\\F2B5";
}

.mdi-google-drive:before {
  content: "\\F2B6";
}

.mdi-google-earth:before {
  content: "\\F2B7";
}

.mdi-google-fit:before {
  content: "\\F96B";
}

.mdi-google-glass:before {
  content: "\\F2B8";
}

.mdi-google-hangouts:before {
  content: "\\F2C9";
}

.mdi-google-home:before {
  content: "\\F823";
}

.mdi-google-keep:before {
  content: "\\F6DB";
}

.mdi-google-maps:before {
  content: "\\F5F5";
}

.mdi-google-nearby:before {
  content: "\\F2B9";
}

.mdi-google-pages:before {
  content: "\\F2BA";
}

.mdi-google-photos:before {
  content: "\\F6DC";
}

.mdi-google-physical-web:before {
  content: "\\F2BB";
}

.mdi-google-play:before {
  content: "\\F2BC";
}

.mdi-google-plus:before {
  content: "\\F2BD";
}

.mdi-google-plus-box:before {
  content: "\\F2BE";
}

.mdi-google-translate:before {
  content: "\\F2BF";
}

.mdi-google-wallet:before {
  content: "\\F2C0";
}

.mdi-gpu:before {
  content: "\\F8AD";
}

.mdi-gradient:before {
  content: "\\F69F";
}

.mdi-graphql:before {
  content: "\\F876";
}

.mdi-grease-pencil:before {
  content: "\\F648";
}

.mdi-greater-than:before {
  content: "\\F96C";
}

.mdi-greater-than-or-equal:before {
  content: "\\F96D";
}

.mdi-grid:before {
  content: "\\F2C1";
}

.mdi-grid-large:before {
  content: "\\F757";
}

.mdi-grid-off:before {
  content: "\\F2C2";
}

.mdi-group:before {
  content: "\\F2C3";
}

.mdi-guitar-acoustic:before {
  content: "\\F770";
}

.mdi-guitar-electric:before {
  content: "\\F2C4";
}

.mdi-guitar-pick:before {
  content: "\\F2C5";
}

.mdi-guitar-pick-outline:before {
  content: "\\F2C6";
}

.mdi-guy-fawkes-mask:before {
  content: "\\F824";
}

.mdi-hackernews:before {
  content: "\\F624";
}

.mdi-hamburger:before {
  content: "\\F684";
}

.mdi-hammer:before {
  content: "\\F8E9";
}

.mdi-hand-pointing-right:before {
  content: "\\F2C7";
}

.mdi-hanger:before {
  content: "\\F2C8";
}

.mdi-hard-hat:before {
  content: "\\F96E";
}

.mdi-harddisk:before {
  content: "\\F2CA";
}

.mdi-headphones:before {
  content: "\\F2CB";
}

.mdi-headphones-bluetooth:before {
  content: "\\F96F";
}

.mdi-headphones-box:before {
  content: "\\F2CC";
}

.mdi-headphones-off:before {
  content: "\\F7CD";
}

.mdi-headphones-settings:before {
  content: "\\F2CD";
}

.mdi-headset:before {
  content: "\\F2CE";
}

.mdi-headset-dock:before {
  content: "\\F2CF";
}

.mdi-headset-off:before {
  content: "\\F2D0";
}

.mdi-heart:before {
  content: "\\F2D1";
}

.mdi-heart-box:before {
  content: "\\F2D2";
}

.mdi-heart-box-outline:before {
  content: "\\F2D3";
}

.mdi-heart-broken:before {
  content: "\\F2D4";
}

.mdi-heart-circle:before {
  content: "\\F970";
}

.mdi-heart-circle-outline:before {
  content: "\\F971";
}

.mdi-heart-half:before {
  content: "\\F6DE";
}

.mdi-heart-half-full:before {
  content: "\\F6DD";
}

.mdi-heart-half-outline:before {
  content: "\\F6DF";
}

.mdi-heart-off:before {
  content: "\\F758";
}

.mdi-heart-outline:before {
  content: "\\F2D5";
}

.mdi-heart-pulse:before {
  content: "\\F5F6";
}

.mdi-help:before {
  content: "\\F2D6";
}

.mdi-help-box:before {
  content: "\\F78A";
}

.mdi-help-circle:before {
  content: "\\F2D7";
}

.mdi-help-circle-outline:before {
  content: "\\F625";
}

.mdi-help-network:before {
  content: "\\F6F4";
}

.mdi-hexagon:before {
  content: "\\F2D8";
}

.mdi-hexagon-multiple:before {
  content: "\\F6E0";
}

.mdi-hexagon-outline:before {
  content: "\\F2D9";
}

.mdi-high-definition:before {
  content: "\\F7CE";
}

.mdi-high-definition-box:before {
  content: "\\F877";
}

.mdi-highway:before {
  content: "\\F5F7";
}

.mdi-hinduism:before {
  content: "\\F972";
}

.mdi-history:before {
  content: "\\F2DA";
}

.mdi-hockey-puck:before {
  content: "\\F878";
}

.mdi-hockey-sticks:before {
  content: "\\F879";
}

.mdi-hololens:before {
  content: "\\F2DB";
}

.mdi-home:before {
  content: "\\F2DC";
}

.mdi-home-account:before {
  content: "\\F825";
}

.mdi-home-alert:before {
  content: "\\F87A";
}

.mdi-home-assistant:before {
  content: "\\F7CF";
}

.mdi-home-automation:before {
  content: "\\F7D0";
}

.mdi-home-circle:before {
  content: "\\F7D1";
}

.mdi-home-currency-usd:before {
  content: "\\F8AE";
}

.mdi-home-heart:before {
  content: "\\F826";
}

.mdi-home-lock:before {
  content: "\\F8EA";
}

.mdi-home-lock-open:before {
  content: "\\F8EB";
}

.mdi-home-map-marker:before {
  content: "\\F5F8";
}

.mdi-home-minus:before {
  content: "\\F973";
}

.mdi-home-modern:before {
  content: "\\F2DD";
}

.mdi-home-outline:before {
  content: "\\F6A0";
}

.mdi-home-plus:before {
  content: "\\F974";
}

.mdi-home-variant:before {
  content: "\\F2DE";
}

.mdi-hook:before {
  content: "\\F6E1";
}

.mdi-hook-off:before {
  content: "\\F6E2";
}

.mdi-hops:before {
  content: "\\F2DF";
}

.mdi-hospital:before {
  content: "\\F2E0";
}

.mdi-hospital-building:before {
  content: "\\F2E1";
}

.mdi-hospital-marker:before {
  content: "\\F2E2";
}

.mdi-hot-tub:before {
  content: "\\F827";
}

.mdi-hotel:before {
  content: "\\F2E3";
}

.mdi-houzz:before {
  content: "\\F2E4";
}

.mdi-houzz-box:before {
  content: "\\F2E5";
}

.mdi-hulu:before {
  content: "\\F828";
}

.mdi-human:before {
  content: "\\F2E6";
}

.mdi-human-child:before {
  content: "\\F2E7";
}

.mdi-human-female:before {
  content: "\\F649";
}

.mdi-human-greeting:before {
  content: "\\F64A";
}

.mdi-human-handsdown:before {
  content: "\\F64B";
}

.mdi-human-handsup:before {
  content: "\\F64C";
}

.mdi-human-male:before {
  content: "\\F64D";
}

.mdi-human-male-female:before {
  content: "\\F2E8";
}

.mdi-human-pregnant:before {
  content: "\\F5CF";
}

.mdi-humble-bundle:before {
  content: "\\F743";
}

.mdi-ice-cream:before {
  content: "\\F829";
}

.mdi-image:before {
  content: "\\F2E9";
}

.mdi-image-album:before {
  content: "\\F2EA";
}

.mdi-image-area:before {
  content: "\\F2EB";
}

.mdi-image-area-close:before {
  content: "\\F2EC";
}

.mdi-image-broken:before {
  content: "\\F2ED";
}

.mdi-image-broken-variant:before {
  content: "\\F2EE";
}

.mdi-image-filter:before {
  content: "\\F2EF";
}

.mdi-image-filter-black-white:before {
  content: "\\F2F0";
}

.mdi-image-filter-center-focus:before {
  content: "\\F2F1";
}

.mdi-image-filter-center-focus-weak:before {
  content: "\\F2F2";
}

.mdi-image-filter-drama:before {
  content: "\\F2F3";
}

.mdi-image-filter-frames:before {
  content: "\\F2F4";
}

.mdi-image-filter-hdr:before {
  content: "\\F2F5";
}

.mdi-image-filter-none:before {
  content: "\\F2F6";
}

.mdi-image-filter-tilt-shift:before {
  content: "\\F2F7";
}

.mdi-image-filter-vintage:before {
  content: "\\F2F8";
}

.mdi-image-multiple:before {
  content: "\\F2F9";
}

.mdi-image-off:before {
  content: "\\F82A";
}

.mdi-image-outline:before {
  content: "\\F975";
}

.mdi-image-plus:before {
  content: "\\F87B";
}

.mdi-image-search:before {
  content: "\\F976";
}

.mdi-image-search-outline:before {
  content: "\\F977";
}

.mdi-import:before {
  content: "\\F2FA";
}

.mdi-inbox:before {
  content: "\\F686";
}

.mdi-inbox-arrow-down:before {
  content: "\\F2FB";
}

.mdi-inbox-arrow-up:before {
  content: "\\F3D1";
}

.mdi-inbox-multiple:before {
  content: "\\F8AF";
}

.mdi-incognito:before {
  content: "\\F5F9";
}

.mdi-infinity:before {
  content: "\\F6E3";
}

.mdi-information:before {
  content: "\\F2FC";
}

.mdi-information-outline:before {
  content: "\\F2FD";
}

.mdi-information-variant:before {
  content: "\\F64E";
}

.mdi-instagram:before {
  content: "\\F2FE";
}

.mdi-instapaper:before {
  content: "\\F2FF";
}

.mdi-internet-explorer:before {
  content: "\\F300";
}

.mdi-invert-colors:before {
  content: "\\F301";
}

.mdi-islam:before {
  content: "\\F978";
}

.mdi-itunes:before {
  content: "\\F676";
}

.mdi-jeepney:before {
  content: "\\F302";
}

.mdi-jira:before {
  content: "\\F303";
}

.mdi-jquery:before {
  content: "\\F87C";
}

.mdi-jsfiddle:before {
  content: "\\F304";
}

.mdi-json:before {
  content: "\\F626";
}

.mdi-judaism:before {
  content: "\\F979";
}

.mdi-karate:before {
  content: "\\F82B";
}

.mdi-keg:before {
  content: "\\F305";
}

.mdi-kettle:before {
  content: "\\F5FA";
}

.mdi-key:before {
  content: "\\F306";
}

.mdi-key-change:before {
  content: "\\F307";
}

.mdi-key-minus:before {
  content: "\\F308";
}

.mdi-key-plus:before {
  content: "\\F309";
}

.mdi-key-remove:before {
  content: "\\F30A";
}

.mdi-key-variant:before {
  content: "\\F30B";
}

.mdi-keyboard:before {
  content: "\\F30C";
}

.mdi-keyboard-backspace:before {
  content: "\\F30D";
}

.mdi-keyboard-caps:before {
  content: "\\F30E";
}

.mdi-keyboard-close:before {
  content: "\\F30F";
}

.mdi-keyboard-off:before {
  content: "\\F310";
}

.mdi-keyboard-outline:before {
  content: "\\F97A";
}

.mdi-keyboard-return:before {
  content: "\\F311";
}

.mdi-keyboard-tab:before {
  content: "\\F312";
}

.mdi-keyboard-variant:before {
  content: "\\F313";
}

.mdi-kickstarter:before {
  content: "\\F744";
}

.mdi-kodi:before {
  content: "\\F314";
}

.mdi-label:before {
  content: "\\F315";
}

.mdi-label-outline:before {
  content: "\\F316";
}

.mdi-ladybug:before {
  content: "\\F82C";
}

.mdi-lambda:before {
  content: "\\F627";
}

.mdi-lamp:before {
  content: "\\F6B4";
}

.mdi-lan:before {
  content: "\\F317";
}

.mdi-lan-connect:before {
  content: "\\F318";
}

.mdi-lan-disconnect:before {
  content: "\\F319";
}

.mdi-lan-pending:before {
  content: "\\F31A";
}

.mdi-language-c:before {
  content: "\\F671";
}

.mdi-language-cpp:before {
  content: "\\F672";
}

.mdi-language-csharp:before {
  content: "\\F31B";
}

.mdi-language-css3:before {
  content: "\\F31C";
}

.mdi-language-go:before {
  content: "\\F7D2";
}

.mdi-language-html5:before {
  content: "\\F31D";
}

.mdi-language-javascript:before {
  content: "\\F31E";
}

.mdi-language-lua:before {
  content: "\\F8B0";
}

.mdi-language-php:before {
  content: "\\F31F";
}

.mdi-language-python:before {
  content: "\\F320";
}

.mdi-language-python-text:before {
  content: "\\F321";
}

.mdi-language-r:before {
  content: "\\F7D3";
}

.mdi-language-swift:before {
  content: "\\F6E4";
}

.mdi-language-typescript:before {
  content: "\\F6E5";
}

.mdi-laptop:before {
  content: "\\F322";
}

.mdi-laptop-chromebook:before {
  content: "\\F323";
}

.mdi-laptop-mac:before {
  content: "\\F324";
}

.mdi-laptop-off:before {
  content: "\\F6E6";
}

.mdi-laptop-windows:before {
  content: "\\F325";
}

.mdi-lastfm:before {
  content: "\\F326";
}

.mdi-lastpass:before {
  content: "\\F446";
}

.mdi-launch:before {
  content: "\\F327";
}

.mdi-lava-lamp:before {
  content: "\\F7D4";
}

.mdi-layers:before {
  content: "\\F328";
}

.mdi-layers-off:before {
  content: "\\F329";
}

.mdi-lead-pencil:before {
  content: "\\F64F";
}

.mdi-leaf:before {
  content: "\\F32A";
}

.mdi-led-off:before {
  content: "\\F32B";
}

.mdi-led-on:before {
  content: "\\F32C";
}

.mdi-led-outline:before {
  content: "\\F32D";
}

.mdi-led-strip:before {
  content: "\\F7D5";
}

.mdi-led-variant-off:before {
  content: "\\F32E";
}

.mdi-led-variant-on:before {
  content: "\\F32F";
}

.mdi-led-variant-outline:before {
  content: "\\F330";
}

.mdi-less-than:before {
  content: "\\F97B";
}

.mdi-less-than-or-equal:before {
  content: "\\F97C";
}

.mdi-library:before {
  content: "\\F331";
}

.mdi-library-books:before {
  content: "\\F332";
}

.mdi-library-music:before {
  content: "\\F333";
}

.mdi-library-plus:before {
  content: "\\F334";
}

.mdi-lifebuoy:before {
  content: "\\F87D";
}

.mdi-light-switch:before {
  content: "\\F97D";
}

.mdi-lightbulb:before {
  content: "\\F335";
}

.mdi-lightbulb-on:before {
  content: "\\F6E7";
}

.mdi-lightbulb-on-outline:before {
  content: "\\F6E8";
}

.mdi-lightbulb-outline:before {
  content: "\\F336";
}

.mdi-link:before {
  content: "\\F337";
}

.mdi-link-off:before {
  content: "\\F338";
}

.mdi-link-variant:before {
  content: "\\F339";
}

.mdi-link-variant-off:before {
  content: "\\F33A";
}

.mdi-linkedin:before {
  content: "\\F33B";
}

.mdi-linkedin-box:before {
  content: "\\F33C";
}

.mdi-linux:before {
  content: "\\F33D";
}

.mdi-linux-mint:before {
  content: "\\F8EC";
}

.mdi-loading:before {
  content: "\\F771";
}

.mdi-lock:before {
  content: "\\F33E";
}

.mdi-lock-alert:before {
  content: "\\F8ED";
}

.mdi-lock-clock:before {
  content: "\\F97E";
}

.mdi-lock-open:before {
  content: "\\F33F";
}

.mdi-lock-open-outline:before {
  content: "\\F340";
}

.mdi-lock-outline:before {
  content: "\\F341";
}

.mdi-lock-pattern:before {
  content: "\\F6E9";
}

.mdi-lock-plus:before {
  content: "\\F5FB";
}

.mdi-lock-question:before {
  content: "\\F8EE";
}

.mdi-lock-reset:before {
  content: "\\F772";
}

.mdi-lock-smart:before {
  content: "\\F8B1";
}

.mdi-locker:before {
  content: "\\F7D6";
}

.mdi-locker-multiple:before {
  content: "\\F7D7";
}

.mdi-login:before {
  content: "\\F342";
}

.mdi-login-variant:before {
  content: "\\F5FC";
}

.mdi-logout:before {
  content: "\\F343";
}

.mdi-logout-variant:before {
  content: "\\F5FD";
}

.mdi-looks:before {
  content: "\\F344";
}

.mdi-loop:before {
  content: "\\F6EA";
}

.mdi-loupe:before {
  content: "\\F345";
}

.mdi-lumx:before {
  content: "\\F346";
}

.mdi-magnet:before {
  content: "\\F347";
}

.mdi-magnet-on:before {
  content: "\\F348";
}

.mdi-magnify:before {
  content: "\\F349";
}

.mdi-magnify-close:before {
  content: "\\F97F";
}

.mdi-magnify-minus:before {
  content: "\\F34A";
}

.mdi-magnify-minus-outline:before {
  content: "\\F6EB";
}

.mdi-magnify-plus:before {
  content: "\\F34B";
}

.mdi-magnify-plus-outline:before {
  content: "\\F6EC";
}

.mdi-mail-ru:before {
  content: "\\F34C";
}

.mdi-mailbox:before {
  content: "\\F6ED";
}

.mdi-map:before {
  content: "\\F34D";
}

.mdi-map-marker:before {
  content: "\\F34E";
}

.mdi-map-marker-circle:before {
  content: "\\F34F";
}

.mdi-map-marker-distance:before {
  content: "\\F8EF";
}

.mdi-map-marker-minus:before {
  content: "\\F650";
}

.mdi-map-marker-multiple:before {
  content: "\\F350";
}

.mdi-map-marker-off:before {
  content: "\\F351";
}

.mdi-map-marker-outline:before {
  content: "\\F7D8";
}

.mdi-map-marker-plus:before {
  content: "\\F651";
}

.mdi-map-marker-radius:before {
  content: "\\F352";
}

.mdi-map-minus:before {
  content: "\\F980";
}

.mdi-map-outline:before {
  content: "\\F981";
}

.mdi-map-plus:before {
  content: "\\F982";
}

.mdi-map-search:before {
  content: "\\F983";
}

.mdi-map-search-outline:before {
  content: "\\F984";
}

.mdi-margin:before {
  content: "\\F353";
}

.mdi-markdown:before {
  content: "\\F354";
}

.mdi-marker:before {
  content: "\\F652";
}

.mdi-marker-check:before {
  content: "\\F355";
}

.mdi-material-design:before {
  content: "\\F985";
}

.mdi-material-ui:before {
  content: "\\F357";
}

.mdi-math-compass:before {
  content: "\\F358";
}

.mdi-matrix:before {
  content: "\\F628";
}

.mdi-maxcdn:before {
  content: "\\F359";
}

.mdi-medal:before {
  content: "\\F986";
}

.mdi-medical-bag:before {
  content: "\\F6EE";
}

.mdi-medium:before {
  content: "\\F35A";
}

.mdi-memory:before {
  content: "\\F35B";
}

.mdi-menu:before {
  content: "\\F35C";
}

.mdi-menu-down:before {
  content: "\\F35D";
}

.mdi-menu-down-outline:before {
  content: "\\F6B5";
}

.mdi-menu-left:before {
  content: "\\F35E";
}

.mdi-menu-right:before {
  content: "\\F35F";
}

.mdi-menu-up:before {
  content: "\\F360";
}

.mdi-menu-up-outline:before {
  content: "\\F6B6";
}

.mdi-message:before {
  content: "\\F361";
}

.mdi-message-alert:before {
  content: "\\F362";
}

.mdi-message-bulleted:before {
  content: "\\F6A1";
}

.mdi-message-bulleted-off:before {
  content: "\\F6A2";
}

.mdi-message-draw:before {
  content: "\\F363";
}

.mdi-message-image:before {
  content: "\\F364";
}

.mdi-message-outline:before {
  content: "\\F365";
}

.mdi-message-plus:before {
  content: "\\F653";
}

.mdi-message-processing:before {
  content: "\\F366";
}

.mdi-message-reply:before {
  content: "\\F367";
}

.mdi-message-reply-text:before {
  content: "\\F368";
}

.mdi-message-settings:before {
  content: "\\F6EF";
}

.mdi-message-settings-variant:before {
  content: "\\F6F0";
}

.mdi-message-text:before {
  content: "\\F369";
}

.mdi-message-text-outline:before {
  content: "\\F36A";
}

.mdi-message-video:before {
  content: "\\F36B";
}

.mdi-meteor:before {
  content: "\\F629";
}

.mdi-metronome:before {
  content: "\\F7D9";
}

.mdi-metronome-tick:before {
  content: "\\F7DA";
}

.mdi-micro-sd:before {
  content: "\\F7DB";
}

.mdi-microphone:before {
  content: "\\F36C";
}

.mdi-microphone-minus:before {
  content: "\\F8B2";
}

.mdi-microphone-off:before {
  content: "\\F36D";
}

.mdi-microphone-outline:before {
  content: "\\F36E";
}

.mdi-microphone-plus:before {
  content: "\\F8B3";
}

.mdi-microphone-settings:before {
  content: "\\F36F";
}

.mdi-microphone-variant:before {
  content: "\\F370";
}

.mdi-microphone-variant-off:before {
  content: "\\F371";
}

.mdi-microscope:before {
  content: "\\F654";
}

.mdi-microsoft:before {
  content: "\\F372";
}

.mdi-microsoft-dynamics:before {
  content: "\\F987";
}

.mdi-midi:before {
  content: "\\F8F0";
}

.mdi-midi-port:before {
  content: "\\F8F1";
}

.mdi-minecraft:before {
  content: "\\F373";
}

.mdi-minus:before {
  content: "\\F374";
}

.mdi-minus-box:before {
  content: "\\F375";
}

.mdi-minus-box-outline:before {
  content: "\\F6F1";
}

.mdi-minus-circle:before {
  content: "\\F376";
}

.mdi-minus-circle-outline:before {
  content: "\\F377";
}

.mdi-minus-network:before {
  content: "\\F378";
}

.mdi-mixcloud:before {
  content: "\\F62A";
}

.mdi-mixed-reality:before {
  content: "\\F87E";
}

.mdi-mixer:before {
  content: "\\F7DC";
}

.mdi-monitor:before {
  content: "\\F379";
}

.mdi-monitor-cellphone:before {
  content: "\\F988";
}

.mdi-monitor-cellphone-star:before {
  content: "\\F989";
}

.mdi-monitor-multiple:before {
  content: "\\F37A";
}

.mdi-more:before {
  content: "\\F37B";
}

.mdi-motorbike:before {
  content: "\\F37C";
}

.mdi-mouse:before {
  content: "\\F37D";
}

.mdi-mouse-bluetooth:before {
  content: "\\F98A";
}

.mdi-mouse-off:before {
  content: "\\F37E";
}

.mdi-mouse-variant:before {
  content: "\\F37F";
}

.mdi-mouse-variant-off:before {
  content: "\\F380";
}

.mdi-move-resize:before {
  content: "\\F655";
}

.mdi-move-resize-variant:before {
  content: "\\F656";
}

.mdi-movie:before {
  content: "\\F381";
}

.mdi-movie-roll:before {
  content: "\\F7DD";
}

.mdi-muffin:before {
  content: "\\F98B";
}

.mdi-multiplication:before {
  content: "\\F382";
}

.mdi-multiplication-box:before {
  content: "\\F383";
}

.mdi-mushroom:before {
  content: "\\F7DE";
}

.mdi-mushroom-outline:before {
  content: "\\F7DF";
}

.mdi-music:before {
  content: "\\F759";
}

.mdi-music-box:before {
  content: "\\F384";
}

.mdi-music-box-outline:before {
  content: "\\F385";
}

.mdi-music-circle:before {
  content: "\\F386";
}

.mdi-music-note:before {
  content: "\\F387";
}

.mdi-music-note-bluetooth:before {
  content: "\\F5FE";
}

.mdi-music-note-bluetooth-off:before {
  content: "\\F5FF";
}

.mdi-music-note-eighth:before {
  content: "\\F388";
}

.mdi-music-note-half:before {
  content: "\\F389";
}

.mdi-music-note-off:before {
  content: "\\F38A";
}

.mdi-music-note-quarter:before {
  content: "\\F38B";
}

.mdi-music-note-sixteenth:before {
  content: "\\F38C";
}

.mdi-music-note-whole:before {
  content: "\\F38D";
}

.mdi-music-off:before {
  content: "\\F75A";
}

.mdi-nas:before {
  content: "\\F8F2";
}

.mdi-nativescript:before {
  content: "\\F87F";
}

.mdi-nature:before {
  content: "\\F38E";
}

.mdi-nature-people:before {
  content: "\\F38F";
}

.mdi-navigation:before {
  content: "\\F390";
}

.mdi-near-me:before {
  content: "\\F5CD";
}

.mdi-needle:before {
  content: "\\F391";
}

.mdi-netflix:before {
  content: "\\F745";
}

.mdi-network:before {
  content: "\\F6F2";
}

.mdi-network-strength-1:before {
  content: "\\F8F3";
}

.mdi-network-strength-1-alert:before {
  content: "\\F8F4";
}

.mdi-network-strength-2:before {
  content: "\\F8F5";
}

.mdi-network-strength-2-alert:before {
  content: "\\F8F6";
}

.mdi-network-strength-3:before {
  content: "\\F8F7";
}

.mdi-network-strength-3-alert:before {
  content: "\\F8F8";
}

.mdi-network-strength-4:before {
  content: "\\F8F9";
}

.mdi-network-strength-4-alert:before {
  content: "\\F8FA";
}

.mdi-network-strength-off:before {
  content: "\\F8FB";
}

.mdi-network-strength-off-outline:before {
  content: "\\F8FC";
}

.mdi-network-strength-outline:before {
  content: "\\F8FD";
}

.mdi-new-box:before {
  content: "\\F394";
}

.mdi-newspaper:before {
  content: "\\F395";
}

.mdi-nfc:before {
  content: "\\F396";
}

.mdi-nfc-tap:before {
  content: "\\F397";
}

.mdi-nfc-variant:before {
  content: "\\F398";
}

.mdi-ninja:before {
  content: "\\F773";
}

.mdi-nintendo-switch:before {
  content: "\\F7E0";
}

.mdi-nodejs:before {
  content: "\\F399";
}

.mdi-not-equal:before {
  content: "\\F98C";
}

.mdi-not-equal-variant:before {
  content: "\\F98D";
}

.mdi-note:before {
  content: "\\F39A";
}

.mdi-note-multiple:before {
  content: "\\F6B7";
}

.mdi-note-multiple-outline:before {
  content: "\\F6B8";
}

.mdi-note-outline:before {
  content: "\\F39B";
}

.mdi-note-plus:before {
  content: "\\F39C";
}

.mdi-note-plus-outline:before {
  content: "\\F39D";
}

.mdi-note-text:before {
  content: "\\F39E";
}

.mdi-notebook:before {
  content: "\\F82D";
}

.mdi-notification-clear-all:before {
  content: "\\F39F";
}

.mdi-npm:before {
  content: "\\F6F6";
}

.mdi-npm-variant:before {
  content: "\\F98E";
}

.mdi-npm-variant-outline:before {
  content: "\\F98F";
}

.mdi-nuke:before {
  content: "\\F6A3";
}

.mdi-null:before {
  content: "\\F7E1";
}

.mdi-numeric:before {
  content: "\\F3A0";
}

.mdi-numeric-0-box:before {
  content: "\\F3A1";
}

.mdi-numeric-0-box-multiple-outline:before {
  content: "\\F3A2";
}

.mdi-numeric-0-box-outline:before {
  content: "\\F3A3";
}

.mdi-numeric-1-box:before {
  content: "\\F3A4";
}

.mdi-numeric-1-box-multiple-outline:before {
  content: "\\F3A5";
}

.mdi-numeric-1-box-outline:before {
  content: "\\F3A6";
}

.mdi-numeric-2-box:before {
  content: "\\F3A7";
}

.mdi-numeric-2-box-multiple-outline:before {
  content: "\\F3A8";
}

.mdi-numeric-2-box-outline:before {
  content: "\\F3A9";
}

.mdi-numeric-3-box:before {
  content: "\\F3AA";
}

.mdi-numeric-3-box-multiple-outline:before {
  content: "\\F3AB";
}

.mdi-numeric-3-box-outline:before {
  content: "\\F3AC";
}

.mdi-numeric-4-box:before {
  content: "\\F3AD";
}

.mdi-numeric-4-box-multiple-outline:before {
  content: "\\F3AE";
}

.mdi-numeric-4-box-outline:before {
  content: "\\F3AF";
}

.mdi-numeric-5-box:before {
  content: "\\F3B0";
}

.mdi-numeric-5-box-multiple-outline:before {
  content: "\\F3B1";
}

.mdi-numeric-5-box-outline:before {
  content: "\\F3B2";
}

.mdi-numeric-6-box:before {
  content: "\\F3B3";
}

.mdi-numeric-6-box-multiple-outline:before {
  content: "\\F3B4";
}

.mdi-numeric-6-box-outline:before {
  content: "\\F3B5";
}

.mdi-numeric-7-box:before {
  content: "\\F3B6";
}

.mdi-numeric-7-box-multiple-outline:before {
  content: "\\F3B7";
}

.mdi-numeric-7-box-outline:before {
  content: "\\F3B8";
}

.mdi-numeric-8-box:before {
  content: "\\F3B9";
}

.mdi-numeric-8-box-multiple-outline:before {
  content: "\\F3BA";
}

.mdi-numeric-8-box-outline:before {
  content: "\\F3BB";
}

.mdi-numeric-9-box:before {
  content: "\\F3BC";
}

.mdi-numeric-9-box-multiple-outline:before {
  content: "\\F3BD";
}

.mdi-numeric-9-box-outline:before {
  content: "\\F3BE";
}

.mdi-numeric-9-plus-box:before {
  content: "\\F3BF";
}

.mdi-numeric-9-plus-box-multiple-outline:before {
  content: "\\F3C0";
}

.mdi-numeric-9-plus-box-outline:before {
  content: "\\F3C1";
}

.mdi-nut:before {
  content: "\\F6F7";
}

.mdi-nutrition:before {
  content: "\\F3C2";
}

.mdi-oar:before {
  content: "\\F67B";
}

.mdi-octagon:before {
  content: "\\F3C3";
}

.mdi-octagon-outline:before {
  content: "\\F3C4";
}

.mdi-octagram:before {
  content: "\\F6F8";
}

.mdi-octagram-outline:before {
  content: "\\F774";
}

.mdi-odnoklassniki:before {
  content: "\\F3C5";
}

.mdi-office:before {
  content: "\\F3C6";
}

.mdi-office-building:before {
  content: "\\F990";
}

.mdi-oil:before {
  content: "\\F3C7";
}

.mdi-oil-temperature:before {
  content: "\\F3C8";
}

.mdi-omega:before {
  content: "\\F3C9";
}

.mdi-onedrive:before {
  content: "\\F3CA";
}

.mdi-onenote:before {
  content: "\\F746";
}

.mdi-onepassword:before {
  content: "\\F880";
}

.mdi-opacity:before {
  content: "\\F5CC";
}

.mdi-open-in-app:before {
  content: "\\F3CB";
}

.mdi-open-in-new:before {
  content: "\\F3CC";
}

.mdi-openid:before {
  content: "\\F3CD";
}

.mdi-opera:before {
  content: "\\F3CE";
}

.mdi-orbit:before {
  content: "\\F018";
}

.mdi-ornament:before {
  content: "\\F3CF";
}

.mdi-ornament-variant:before {
  content: "\\F3D0";
}

.mdi-owl:before {
  content: "\\F3D2";
}

.mdi-package:before {
  content: "\\F3D3";
}

.mdi-package-down:before {
  content: "\\F3D4";
}

.mdi-package-up:before {
  content: "\\F3D5";
}

.mdi-package-variant:before {
  content: "\\F3D6";
}

.mdi-package-variant-closed:before {
  content: "\\F3D7";
}

.mdi-page-first:before {
  content: "\\F600";
}

.mdi-page-last:before {
  content: "\\F601";
}

.mdi-page-layout-body:before {
  content: "\\F6F9";
}

.mdi-page-layout-footer:before {
  content: "\\F6FA";
}

.mdi-page-layout-header:before {
  content: "\\F6FB";
}

.mdi-page-layout-sidebar-left:before {
  content: "\\F6FC";
}

.mdi-page-layout-sidebar-right:before {
  content: "\\F6FD";
}

.mdi-palette:before {
  content: "\\F3D8";
}

.mdi-palette-advanced:before {
  content: "\\F3D9";
}

.mdi-palette-swatch:before {
  content: "\\F8B4";
}

.mdi-panda:before {
  content: "\\F3DA";
}

.mdi-pandora:before {
  content: "\\F3DB";
}

.mdi-panorama:before {
  content: "\\F3DC";
}

.mdi-panorama-fisheye:before {
  content: "\\F3DD";
}

.mdi-panorama-horizontal:before {
  content: "\\F3DE";
}

.mdi-panorama-vertical:before {
  content: "\\F3DF";
}

.mdi-panorama-wide-angle:before {
  content: "\\F3E0";
}

.mdi-paper-cut-vertical:before {
  content: "\\F3E1";
}

.mdi-paperclip:before {
  content: "\\F3E2";
}

.mdi-parking:before {
  content: "\\F3E3";
}

.mdi-passport:before {
  content: "\\F7E2";
}

.mdi-patreon:before {
  content: "\\F881";
}

.mdi-pause:before {
  content: "\\F3E4";
}

.mdi-pause-circle:before {
  content: "\\F3E5";
}

.mdi-pause-circle-outline:before {
  content: "\\F3E6";
}

.mdi-pause-octagon:before {
  content: "\\F3E7";
}

.mdi-pause-octagon-outline:before {
  content: "\\F3E8";
}

.mdi-paw:before {
  content: "\\F3E9";
}

.mdi-paw-off:before {
  content: "\\F657";
}

.mdi-paypal:before {
  content: "\\F882";
}

.mdi-peace:before {
  content: "\\F883";
}

.mdi-pen:before {
  content: "\\F3EA";
}

.mdi-pencil:before {
  content: "\\F3EB";
}

.mdi-pencil-box:before {
  content: "\\F3EC";
}

.mdi-pencil-box-outline:before {
  content: "\\F3ED";
}

.mdi-pencil-circle:before {
  content: "\\F6FE";
}

.mdi-pencil-circle-outline:before {
  content: "\\F775";
}

.mdi-pencil-lock:before {
  content: "\\F3EE";
}

.mdi-pencil-off:before {
  content: "\\F3EF";
}

.mdi-pentagon:before {
  content: "\\F6FF";
}

.mdi-pentagon-outline:before {
  content: "\\F700";
}

.mdi-percent:before {
  content: "\\F3F0";
}

.mdi-periodic-table:before {
  content: "\\F8B5";
}

.mdi-periodic-table-co2:before {
  content: "\\F7E3";
}

.mdi-periscope:before {
  content: "\\F747";
}

.mdi-pharmacy:before {
  content: "\\F3F1";
}

.mdi-phone:before {
  content: "\\F3F2";
}

.mdi-phone-bluetooth:before {
  content: "\\F3F3";
}

.mdi-phone-classic:before {
  content: "\\F602";
}

.mdi-phone-forward:before {
  content: "\\F3F4";
}

.mdi-phone-hangup:before {
  content: "\\F3F5";
}

.mdi-phone-in-talk:before {
  content: "\\F3F6";
}

.mdi-phone-incoming:before {
  content: "\\F3F7";
}

.mdi-phone-locked:before {
  content: "\\F3F8";
}

.mdi-phone-log:before {
  content: "\\F3F9";
}

.mdi-phone-minus:before {
  content: "\\F658";
}

.mdi-phone-missed:before {
  content: "\\F3FA";
}

.mdi-phone-outgoing:before {
  content: "\\F3FB";
}

.mdi-phone-paused:before {
  content: "\\F3FC";
}

.mdi-phone-plus:before {
  content: "\\F659";
}

.mdi-phone-return:before {
  content: "\\F82E";
}

.mdi-phone-rotate-landscape:before {
  content: "\\F884";
}

.mdi-phone-rotate-portrait:before {
  content: "\\F885";
}

.mdi-phone-settings:before {
  content: "\\F3FD";
}

.mdi-phone-voip:before {
  content: "\\F3FE";
}

.mdi-pi:before {
  content: "\\F3FF";
}

.mdi-pi-box:before {
  content: "\\F400";
}

.mdi-piano:before {
  content: "\\F67C";
}

.mdi-pickaxe:before {
  content: "\\F8B6";
}

.mdi-pier:before {
  content: "\\F886";
}

.mdi-pier-crane:before {
  content: "\\F887";
}

.mdi-pig:before {
  content: "\\F401";
}

.mdi-pill:before {
  content: "\\F402";
}

.mdi-pillar:before {
  content: "\\F701";
}

.mdi-pin:before {
  content: "\\F403";
}

.mdi-pin-off:before {
  content: "\\F404";
}

.mdi-pin-off-outline:before {
  content: "\\F92F";
}

.mdi-pin-outline:before {
  content: "\\F930";
}

.mdi-pine-tree:before {
  content: "\\F405";
}

.mdi-pine-tree-box:before {
  content: "\\F406";
}

.mdi-pinterest:before {
  content: "\\F407";
}

.mdi-pinterest-box:before {
  content: "\\F408";
}

.mdi-pipe:before {
  content: "\\F7E4";
}

.mdi-pipe-disconnected:before {
  content: "\\F7E5";
}

.mdi-pipe-leak:before {
  content: "\\F888";
}

.mdi-pistol:before {
  content: "\\F702";
}

.mdi-piston:before {
  content: "\\F889";
}

.mdi-pizza:before {
  content: "\\F409";
}

.mdi-plane-shield:before {
  content: "\\F6BA";
}

.mdi-play:before {
  content: "\\F40A";
}

.mdi-play-box-outline:before {
  content: "\\F40B";
}

.mdi-play-circle:before {
  content: "\\F40C";
}

.mdi-play-circle-outline:before {
  content: "\\F40D";
}

.mdi-play-network:before {
  content: "\\F88A";
}

.mdi-play-pause:before {
  content: "\\F40E";
}

.mdi-play-protected-content:before {
  content: "\\F40F";
}

.mdi-play-speed:before {
  content: "\\F8FE";
}

.mdi-playlist-check:before {
  content: "\\F5C7";
}

.mdi-playlist-edit:before {
  content: "\\F8FF";
}

.mdi-playlist-minus:before {
  content: "\\F410";
}

.mdi-playlist-play:before {
  content: "\\F411";
}

.mdi-playlist-plus:before {
  content: "\\F412";
}

.mdi-playlist-remove:before {
  content: "\\F413";
}

.mdi-playstation:before {
  content: "\\F414";
}

.mdi-plex:before {
  content: "\\F6B9";
}

.mdi-plus:before {
  content: "\\F415";
}

.mdi-plus-box:before {
  content: "\\F416";
}

.mdi-plus-box-outline:before {
  content: "\\F703";
}

.mdi-plus-circle:before {
  content: "\\F417";
}

.mdi-plus-circle-multiple-outline:before {
  content: "\\F418";
}

.mdi-plus-circle-outline:before {
  content: "\\F419";
}

.mdi-plus-minus:before {
  content: "\\F991";
}

.mdi-plus-minus-box:before {
  content: "\\F992";
}

.mdi-plus-network:before {
  content: "\\F41A";
}

.mdi-plus-one:before {
  content: "\\F41B";
}

.mdi-plus-outline:before {
  content: "\\F704";
}

.mdi-pocket:before {
  content: "\\F41C";
}

.mdi-podcast:before {
  content: "\\F993";
}

.mdi-pokeball:before {
  content: "\\F41D";
}

.mdi-poker-chip:before {
  content: "\\F82F";
}

.mdi-polaroid:before {
  content: "\\F41E";
}

.mdi-poll:before {
  content: "\\F41F";
}

.mdi-poll-box:before {
  content: "\\F420";
}

.mdi-polymer:before {
  content: "\\F421";
}

.mdi-pool:before {
  content: "\\F606";
}

.mdi-popcorn:before {
  content: "\\F422";
}

.mdi-pot:before {
  content: "\\F65A";
}

.mdi-pot-mix:before {
  content: "\\F65B";
}

.mdi-pound:before {
  content: "\\F423";
}

.mdi-pound-box:before {
  content: "\\F424";
}

.mdi-power:before {
  content: "\\F425";
}

.mdi-power-cycle:before {
  content: "\\F900";
}

.mdi-power-off:before {
  content: "\\F901";
}

.mdi-power-on:before {
  content: "\\F902";
}

.mdi-power-plug:before {
  content: "\\F6A4";
}

.mdi-power-plug-off:before {
  content: "\\F6A5";
}

.mdi-power-settings:before {
  content: "\\F426";
}

.mdi-power-sleep:before {
  content: "\\F903";
}

.mdi-power-socket:before {
  content: "\\F427";
}

.mdi-power-socket-au:before {
  content: "\\F904";
}

.mdi-power-socket-eu:before {
  content: "\\F7E6";
}

.mdi-power-socket-uk:before {
  content: "\\F7E7";
}

.mdi-power-socket-us:before {
  content: "\\F7E8";
}

.mdi-power-standby:before {
  content: "\\F905";
}

.mdi-prescription:before {
  content: "\\F705";
}

.mdi-presentation:before {
  content: "\\F428";
}

.mdi-presentation-play:before {
  content: "\\F429";
}

.mdi-printer:before {
  content: "\\F42A";
}

.mdi-printer-3d:before {
  content: "\\F42B";
}

.mdi-printer-alert:before {
  content: "\\F42C";
}

.mdi-printer-settings:before {
  content: "\\F706";
}

.mdi-priority-high:before {
  content: "\\F603";
}

.mdi-priority-low:before {
  content: "\\F604";
}

.mdi-professional-hexagon:before {
  content: "\\F42D";
}

.mdi-progress-check:before {
  content: "\\F994";
}

.mdi-progress-clock:before {
  content: "\\F995";
}

.mdi-progress-download:before {
  content: "\\F996";
}

.mdi-progress-upload:before {
  content: "\\F997";
}

.mdi-projector:before {
  content: "\\F42E";
}

.mdi-projector-screen:before {
  content: "\\F42F";
}

.mdi-publish:before {
  content: "\\F6A6";
}

.mdi-pulse:before {
  content: "\\F430";
}

.mdi-puzzle:before {
  content: "\\F431";
}

.mdi-qi:before {
  content: "\\F998";
}

.mdi-qqchat:before {
  content: "\\F605";
}

.mdi-qrcode:before {
  content: "\\F432";
}

.mdi-qrcode-edit:before {
  content: "\\F8B7";
}

.mdi-qrcode-scan:before {
  content: "\\F433";
}

.mdi-quadcopter:before {
  content: "\\F434";
}

.mdi-quality-high:before {
  content: "\\F435";
}

.mdi-quicktime:before {
  content: "\\F436";
}

.mdi-rabbit:before {
  content: "\\F906";
}

.mdi-radar:before {
  content: "\\F437";
}

.mdi-radiator:before {
  content: "\\F438";
}

.mdi-radio:before {
  content: "\\F439";
}

.mdi-radio-handheld:before {
  content: "\\F43A";
}

.mdi-radio-tower:before {
  content: "\\F43B";
}

.mdi-radioactive:before {
  content: "\\F43C";
}

.mdi-radiobox-blank:before {
  content: "\\F43D";
}

.mdi-radiobox-marked:before {
  content: "\\F43E";
}

.mdi-raspberrypi:before {
  content: "\\F43F";
}

.mdi-ray-end:before {
  content: "\\F440";
}

.mdi-ray-end-arrow:before {
  content: "\\F441";
}

.mdi-ray-start:before {
  content: "\\F442";
}

.mdi-ray-start-arrow:before {
  content: "\\F443";
}

.mdi-ray-start-end:before {
  content: "\\F444";
}

.mdi-ray-vertex:before {
  content: "\\F445";
}

.mdi-react:before {
  content: "\\F707";
}

.mdi-read:before {
  content: "\\F447";
}

.mdi-receipt:before {
  content: "\\F449";
}

.mdi-record:before {
  content: "\\F44A";
}

.mdi-record-player:before {
  content: "\\F999";
}

.mdi-record-rec:before {
  content: "\\F44B";
}

.mdi-recycle:before {
  content: "\\F44C";
}

.mdi-reddit:before {
  content: "\\F44D";
}

.mdi-redo:before {
  content: "\\F44E";
}

.mdi-redo-variant:before {
  content: "\\F44F";
}

.mdi-refresh:before {
  content: "\\F450";
}

.mdi-regex:before {
  content: "\\F451";
}

.mdi-relative-scale:before {
  content: "\\F452";
}

.mdi-reload:before {
  content: "\\F453";
}

.mdi-reminder:before {
  content: "\\F88B";
}

.mdi-remote:before {
  content: "\\F454";
}

.mdi-remote-desktop:before {
  content: "\\F8B8";
}

.mdi-rename-box:before {
  content: "\\F455";
}

.mdi-reorder-horizontal:before {
  content: "\\F687";
}

.mdi-reorder-vertical:before {
  content: "\\F688";
}

.mdi-repeat:before {
  content: "\\F456";
}

.mdi-repeat-off:before {
  content: "\\F457";
}

.mdi-repeat-once:before {
  content: "\\F458";
}

.mdi-replay:before {
  content: "\\F459";
}

.mdi-reply:before {
  content: "\\F45A";
}

.mdi-reply-all:before {
  content: "\\F45B";
}

.mdi-reproduction:before {
  content: "\\F45C";
}

.mdi-resize-bottom-right:before {
  content: "\\F45D";
}

.mdi-responsive:before {
  content: "\\F45E";
}

.mdi-restart:before {
  content: "\\F708";
}

.mdi-restore:before {
  content: "\\F99A";
}

.mdi-restore-clock:before {
  content: "\\F6A7";
}

.mdi-rewind:before {
  content: "\\F45F";
}

.mdi-rewind-outline:before {
  content: "\\F709";
}

.mdi-rhombus:before {
  content: "\\F70A";
}

.mdi-rhombus-outline:before {
  content: "\\F70B";
}

.mdi-ribbon:before {
  content: "\\F460";
}

.mdi-rice:before {
  content: "\\F7E9";
}

.mdi-ring:before {
  content: "\\F7EA";
}

.mdi-road:before {
  content: "\\F461";
}

.mdi-road-variant:before {
  content: "\\F462";
}

.mdi-robot:before {
  content: "\\F6A8";
}

.mdi-robot-vacuum:before {
  content: "\\F70C";
}

.mdi-robot-vacuum-variant:before {
  content: "\\F907";
}

.mdi-rocket:before {
  content: "\\F463";
}

.mdi-room-service:before {
  content: "\\F88C";
}

.mdi-rotate-3d:before {
  content: "\\F464";
}

.mdi-rotate-left:before {
  content: "\\F465";
}

.mdi-rotate-left-variant:before {
  content: "\\F466";
}

.mdi-rotate-right:before {
  content: "\\F467";
}

.mdi-rotate-right-variant:before {
  content: "\\F468";
}

.mdi-rounded-corner:before {
  content: "\\F607";
}

.mdi-router-wireless:before {
  content: "\\F469";
}

.mdi-routes:before {
  content: "\\F46A";
}

.mdi-rowing:before {
  content: "\\F608";
}

.mdi-rss:before {
  content: "\\F46B";
}

.mdi-rss-box:before {
  content: "\\F46C";
}

.mdi-ruler:before {
  content: "\\F46D";
}

.mdi-run:before {
  content: "\\F70D";
}

.mdi-run-fast:before {
  content: "\\F46E";
}

.mdi-sale:before {
  content: "\\F46F";
}

.mdi-salesforce:before {
  content: "\\F88D";
}

.mdi-sass:before {
  content: "\\F7EB";
}

.mdi-satellite:before {
  content: "\\F470";
}

.mdi-satellite-uplink:before {
  content: "\\F908";
}

.mdi-satellite-variant:before {
  content: "\\F471";
}

.mdi-sausage:before {
  content: "\\F8B9";
}

.mdi-saxophone:before {
  content: "\\F609";
}

.mdi-scale:before {
  content: "\\F472";
}

.mdi-scale-balance:before {
  content: "\\F5D1";
}

.mdi-scale-bathroom:before {
  content: "\\F473";
}

.mdi-scanner:before {
  content: "\\F6AA";
}

.mdi-scanner-off:before {
  content: "\\F909";
}

.mdi-school:before {
  content: "\\F474";
}

.mdi-screen-rotation:before {
  content: "\\F475";
}

.mdi-screen-rotation-lock:before {
  content: "\\F476";
}

.mdi-screwdriver:before {
  content: "\\F477";
}

.mdi-script:before {
  content: "\\F478";
}

.mdi-sd:before {
  content: "\\F479";
}

.mdi-seal:before {
  content: "\\F47A";
}

.mdi-search-web:before {
  content: "\\F70E";
}

.mdi-seat-flat:before {
  content: "\\F47B";
}

.mdi-seat-flat-angled:before {
  content: "\\F47C";
}

.mdi-seat-individual-suite:before {
  content: "\\F47D";
}

.mdi-seat-legroom-extra:before {
  content: "\\F47E";
}

.mdi-seat-legroom-normal:before {
  content: "\\F47F";
}

.mdi-seat-legroom-reduced:before {
  content: "\\F480";
}

.mdi-seat-recline-extra:before {
  content: "\\F481";
}

.mdi-seat-recline-normal:before {
  content: "\\F482";
}

.mdi-security:before {
  content: "\\F483";
}

.mdi-security-account:before {
  content: "\\F88E";
}

.mdi-security-close:before {
  content: "\\F99B";
}

.mdi-security-home:before {
  content: "\\F689";
}

.mdi-security-lock:before {
  content: "\\F99C";
}

.mdi-security-network:before {
  content: "\\F484";
}

.mdi-security-off:before {
  content: "\\F99D";
}

.mdi-select:before {
  content: "\\F485";
}

.mdi-select-all:before {
  content: "\\F486";
}

.mdi-select-inverse:before {
  content: "\\F487";
}

.mdi-select-off:before {
  content: "\\F488";
}

.mdi-selection:before {
  content: "\\F489";
}

.mdi-selection-off:before {
  content: "\\F776";
}

.mdi-send:before {
  content: "\\F48A";
}

.mdi-send-secure:before {
  content: "\\F7EC";
}

.mdi-serial-port:before {
  content: "\\F65C";
}

.mdi-server:before {
  content: "\\F48B";
}

.mdi-server-minus:before {
  content: "\\F48C";
}

.mdi-server-network:before {
  content: "\\F48D";
}

.mdi-server-network-off:before {
  content: "\\F48E";
}

.mdi-server-off:before {
  content: "\\F48F";
}

.mdi-server-plus:before {
  content: "\\F490";
}

.mdi-server-remove:before {
  content: "\\F491";
}

.mdi-server-security:before {
  content: "\\F492";
}

.mdi-set-all:before {
  content: "\\F777";
}

.mdi-set-center:before {
  content: "\\F778";
}

.mdi-set-center-right:before {
  content: "\\F779";
}

.mdi-set-left:before {
  content: "\\F77A";
}

.mdi-set-left-center:before {
  content: "\\F77B";
}

.mdi-set-left-right:before {
  content: "\\F77C";
}

.mdi-set-none:before {
  content: "\\F77D";
}

.mdi-set-right:before {
  content: "\\F77E";
}

.mdi-set-top-box:before {
  content: "\\F99E";
}

.mdi-settings:before {
  content: "\\F493";
}

.mdi-settings-box:before {
  content: "\\F494";
}

.mdi-settings-outline:before {
  content: "\\F8BA";
}

.mdi-shape:before {
  content: "\\F830";
}

.mdi-shape-circle-plus:before {
  content: "\\F65D";
}

.mdi-shape-outline:before {
  content: "\\F831";
}

.mdi-shape-plus:before {
  content: "\\F495";
}

.mdi-shape-polygon-plus:before {
  content: "\\F65E";
}

.mdi-shape-rectangle-plus:before {
  content: "\\F65F";
}

.mdi-shape-square-plus:before {
  content: "\\F660";
}

.mdi-share:before {
  content: "\\F496";
}

.mdi-share-outline:before {
  content: "\\F931";
}

.mdi-share-variant:before {
  content: "\\F497";
}

.mdi-shield:before {
  content: "\\F498";
}

.mdi-shield-half-full:before {
  content: "\\F77F";
}

.mdi-shield-outline:before {
  content: "\\F499";
}

.mdi-ship-wheel:before {
  content: "\\F832";
}

.mdi-shopping:before {
  content: "\\F49A";
}

.mdi-shopping-music:before {
  content: "\\F49B";
}

.mdi-shovel:before {
  content: "\\F70F";
}

.mdi-shovel-off:before {
  content: "\\F710";
}

.mdi-shower:before {
  content: "\\F99F";
}

.mdi-shower-head:before {
  content: "\\F9A0";
}

.mdi-shredder:before {
  content: "\\F49C";
}

.mdi-shuffle:before {
  content: "\\F49D";
}

.mdi-shuffle-disabled:before {
  content: "\\F49E";
}

.mdi-shuffle-variant:before {
  content: "\\F49F";
}

.mdi-sigma:before {
  content: "\\F4A0";
}

.mdi-sigma-lower:before {
  content: "\\F62B";
}

.mdi-sign-caution:before {
  content: "\\F4A1";
}

.mdi-sign-direction:before {
  content: "\\F780";
}

.mdi-sign-text:before {
  content: "\\F781";
}

.mdi-signal:before {
  content: "\\F4A2";
}

.mdi-signal-2g:before {
  content: "\\F711";
}

.mdi-signal-3g:before {
  content: "\\F712";
}

.mdi-signal-4g:before {
  content: "\\F713";
}

.mdi-signal-cellular-1:before {
  content: "\\F8BB";
}

.mdi-signal-cellular-2:before {
  content: "\\F8BC";
}

.mdi-signal-cellular-3:before {
  content: "\\F8BD";
}

.mdi-signal-cellular-outline:before {
  content: "\\F8BE";
}

.mdi-signal-hspa:before {
  content: "\\F714";
}

.mdi-signal-hspa-plus:before {
  content: "\\F715";
}

.mdi-signal-off:before {
  content: "\\F782";
}

.mdi-signal-variant:before {
  content: "\\F60A";
}

.mdi-silverware:before {
  content: "\\F4A3";
}

.mdi-silverware-fork:before {
  content: "\\F4A4";
}

.mdi-silverware-spoon:before {
  content: "\\F4A5";
}

.mdi-silverware-variant:before {
  content: "\\F4A6";
}

.mdi-sim:before {
  content: "\\F4A7";
}

.mdi-sim-alert:before {
  content: "\\F4A8";
}

.mdi-sim-off:before {
  content: "\\F4A9";
}

.mdi-sitemap:before {
  content: "\\F4AA";
}

.mdi-skip-backward:before {
  content: "\\F4AB";
}

.mdi-skip-forward:before {
  content: "\\F4AC";
}

.mdi-skip-next:before {
  content: "\\F4AD";
}

.mdi-skip-next-circle:before {
  content: "\\F661";
}

.mdi-skip-next-circle-outline:before {
  content: "\\F662";
}

.mdi-skip-previous:before {
  content: "\\F4AE";
}

.mdi-skip-previous-circle:before {
  content: "\\F663";
}

.mdi-skip-previous-circle-outline:before {
  content: "\\F664";
}

.mdi-skull:before {
  content: "\\F68B";
}

.mdi-skype:before {
  content: "\\F4AF";
}

.mdi-skype-business:before {
  content: "\\F4B0";
}

.mdi-slack:before {
  content: "\\F4B1";
}

.mdi-slackware:before {
  content: "\\F90A";
}

.mdi-sleep:before {
  content: "\\F4B2";
}

.mdi-sleep-off:before {
  content: "\\F4B3";
}

.mdi-smoke-detector:before {
  content: "\\F392";
}

.mdi-smoking:before {
  content: "\\F4B4";
}

.mdi-smoking-off:before {
  content: "\\F4B5";
}

.mdi-snapchat:before {
  content: "\\F4B6";
}

.mdi-snowflake:before {
  content: "\\F716";
}

.mdi-snowman:before {
  content: "\\F4B7";
}

.mdi-soccer:before {
  content: "\\F4B8";
}

.mdi-soccer-field:before {
  content: "\\F833";
}

.mdi-sofa:before {
  content: "\\F4B9";
}

.mdi-solid:before {
  content: "\\F68C";
}

.mdi-sort:before {
  content: "\\F4BA";
}

.mdi-sort-alphabetical:before {
  content: "\\F4BB";
}

.mdi-sort-ascending:before {
  content: "\\F4BC";
}

.mdi-sort-descending:before {
  content: "\\F4BD";
}

.mdi-sort-numeric:before {
  content: "\\F4BE";
}

.mdi-sort-variant:before {
  content: "\\F4BF";
}

.mdi-soundcloud:before {
  content: "\\F4C0";
}

.mdi-source-branch:before {
  content: "\\F62C";
}

.mdi-source-commit:before {
  content: "\\F717";
}

.mdi-source-commit-end:before {
  content: "\\F718";
}

.mdi-source-commit-end-local:before {
  content: "\\F719";
}

.mdi-source-commit-local:before {
  content: "\\F71A";
}

.mdi-source-commit-next-local:before {
  content: "\\F71B";
}

.mdi-source-commit-start:before {
  content: "\\F71C";
}

.mdi-source-commit-start-next-local:before {
  content: "\\F71D";
}

.mdi-source-fork:before {
  content: "\\F4C1";
}

.mdi-source-merge:before {
  content: "\\F62D";
}

.mdi-source-pull:before {
  content: "\\F4C2";
}

.mdi-soy-sauce:before {
  content: "\\F7ED";
}

.mdi-speaker:before {
  content: "\\F4C3";
}

.mdi-speaker-bluetooth:before {
  content: "\\F9A1";
}

.mdi-speaker-off:before {
  content: "\\F4C4";
}

.mdi-speaker-wireless:before {
  content: "\\F71E";
}

.mdi-speedometer:before {
  content: "\\F4C5";
}

.mdi-spellcheck:before {
  content: "\\F4C6";
}

.mdi-spotify:before {
  content: "\\F4C7";
}

.mdi-spotlight:before {
  content: "\\F4C8";
}

.mdi-spotlight-beam:before {
  content: "\\F4C9";
}

.mdi-spray:before {
  content: "\\F665";
}

.mdi-square:before {
  content: "\\F763";
}

.mdi-square-edit-outline:before {
  content: "\\F90B";
}

.mdi-square-inc:before {
  content: "\\F4CA";
}

.mdi-square-inc-cash:before {
  content: "\\F4CB";
}

.mdi-square-outline:before {
  content: "\\F762";
}

.mdi-square-root:before {
  content: "\\F783";
}

.mdi-square-root-box:before {
  content: "\\F9A2";
}

.mdi-ssh:before {
  content: "\\F8BF";
}

.mdi-stack-exchange:before {
  content: "\\F60B";
}

.mdi-stack-overflow:before {
  content: "\\F4CC";
}

.mdi-stadium:before {
  content: "\\F71F";
}

.mdi-stairs:before {
  content: "\\F4CD";
}

.mdi-standard-definition:before {
  content: "\\F7EE";
}

.mdi-star:before {
  content: "\\F4CE";
}

.mdi-star-circle:before {
  content: "\\F4CF";
}

.mdi-star-circle-outline:before {
  content: "\\F9A3";
}

.mdi-star-face:before {
  content: "\\F9A4";
}

.mdi-star-half:before {
  content: "\\F4D0";
}

.mdi-star-off:before {
  content: "\\F4D1";
}

.mdi-star-outline:before {
  content: "\\F4D2";
}

.mdi-steam:before {
  content: "\\F4D3";
}

.mdi-steam-box:before {
  content: "\\F90C";
}

.mdi-steering:before {
  content: "\\F4D4";
}

.mdi-steering-off:before {
  content: "\\F90D";
}

.mdi-step-backward:before {
  content: "\\F4D5";
}

.mdi-step-backward-2:before {
  content: "\\F4D6";
}

.mdi-step-forward:before {
  content: "\\F4D7";
}

.mdi-step-forward-2:before {
  content: "\\F4D8";
}

.mdi-stethoscope:before {
  content: "\\F4D9";
}

.mdi-sticker:before {
  content: "\\F5D0";
}

.mdi-sticker-emoji:before {
  content: "\\F784";
}

.mdi-stocking:before {
  content: "\\F4DA";
}

.mdi-stop:before {
  content: "\\F4DB";
}

.mdi-stop-circle:before {
  content: "\\F666";
}

.mdi-stop-circle-outline:before {
  content: "\\F667";
}

.mdi-store:before {
  content: "\\F4DC";
}

.mdi-store-24-hour:before {
  content: "\\F4DD";
}

.mdi-stove:before {
  content: "\\F4DE";
}

.mdi-subdirectory-arrow-left:before {
  content: "\\F60C";
}

.mdi-subdirectory-arrow-right:before {
  content: "\\F60D";
}

.mdi-subway:before {
  content: "\\F6AB";
}

.mdi-subway-variant:before {
  content: "\\F4DF";
}

.mdi-summit:before {
  content: "\\F785";
}

.mdi-sunglasses:before {
  content: "\\F4E0";
}

.mdi-surround-sound:before {
  content: "\\F5C5";
}

.mdi-surround-sound-2-0:before {
  content: "\\F7EF";
}

.mdi-surround-sound-3-1:before {
  content: "\\F7F0";
}

.mdi-surround-sound-5-1:before {
  content: "\\F7F1";
}

.mdi-surround-sound-7-1:before {
  content: "\\F7F2";
}

.mdi-svg:before {
  content: "\\F720";
}

.mdi-swap-horizontal:before {
  content: "\\F4E1";
}

.mdi-swap-horizontal-variant:before {
  content: "\\F8C0";
}

.mdi-swap-vertical:before {
  content: "\\F4E2";
}

.mdi-swap-vertical-variant:before {
  content: "\\F8C1";
}

.mdi-swim:before {
  content: "\\F4E3";
}

.mdi-switch:before {
  content: "\\F4E4";
}

.mdi-sword:before {
  content: "\\F4E5";
}

.mdi-sword-cross:before {
  content: "\\F786";
}

.mdi-sync:before {
  content: "\\F4E6";
}

.mdi-sync-alert:before {
  content: "\\F4E7";
}

.mdi-sync-off:before {
  content: "\\F4E8";
}

.mdi-tab:before {
  content: "\\F4E9";
}

.mdi-tab-plus:before {
  content: "\\F75B";
}

.mdi-tab-unselected:before {
  content: "\\F4EA";
}

.mdi-table:before {
  content: "\\F4EB";
}

.mdi-table-column:before {
  content: "\\F834";
}

.mdi-table-column-plus-after:before {
  content: "\\F4EC";
}

.mdi-table-column-plus-before:before {
  content: "\\F4ED";
}

.mdi-table-column-remove:before {
  content: "\\F4EE";
}

.mdi-table-column-width:before {
  content: "\\F4EF";
}

.mdi-table-edit:before {
  content: "\\F4F0";
}

.mdi-table-large:before {
  content: "\\F4F1";
}

.mdi-table-merge-cells:before {
  content: "\\F9A5";
}

.mdi-table-of-contents:before {
  content: "\\F835";
}

.mdi-table-row:before {
  content: "\\F836";
}

.mdi-table-row-height:before {
  content: "\\F4F2";
}

.mdi-table-row-plus-after:before {
  content: "\\F4F3";
}

.mdi-table-row-plus-before:before {
  content: "\\F4F4";
}

.mdi-table-row-remove:before {
  content: "\\F4F5";
}

.mdi-table-search:before {
  content: "\\F90E";
}

.mdi-table-settings:before {
  content: "\\F837";
}

.mdi-tablet:before {
  content: "\\F4F6";
}

.mdi-tablet-android:before {
  content: "\\F4F7";
}

.mdi-tablet-cellphone:before {
  content: "\\F9A6";
}

.mdi-tablet-ipad:before {
  content: "\\F4F8";
}

.mdi-taco:before {
  content: "\\F761";
}

.mdi-tag:before {
  content: "\\F4F9";
}

.mdi-tag-faces:before {
  content: "\\F4FA";
}

.mdi-tag-heart:before {
  content: "\\F68A";
}

.mdi-tag-minus:before {
  content: "\\F90F";
}

.mdi-tag-multiple:before {
  content: "\\F4FB";
}

.mdi-tag-outline:before {
  content: "\\F4FC";
}

.mdi-tag-plus:before {
  content: "\\F721";
}

.mdi-tag-remove:before {
  content: "\\F722";
}

.mdi-tag-text-outline:before {
  content: "\\F4FD";
}

.mdi-target:before {
  content: "\\F4FE";
}

.mdi-taxi:before {
  content: "\\F4FF";
}

.mdi-teach:before {
  content: "\\F88F";
}

.mdi-teamviewer:before {
  content: "\\F500";
}

.mdi-telegram:before {
  content: "\\F501";
}

.mdi-television:before {
  content: "\\F502";
}

.mdi-television-box:before {
  content: "\\F838";
}

.mdi-television-classic:before {
  content: "\\F7F3";
}

.mdi-television-classic-off:before {
  content: "\\F839";
}

.mdi-television-guide:before {
  content: "\\F503";
}

.mdi-television-off:before {
  content: "\\F83A";
}

.mdi-temperature-celsius:before {
  content: "\\F504";
}

.mdi-temperature-fahrenheit:before {
  content: "\\F505";
}

.mdi-temperature-kelvin:before {
  content: "\\F506";
}

.mdi-tennis:before {
  content: "\\F507";
}

.mdi-tent:before {
  content: "\\F508";
}

.mdi-terrain:before {
  content: "\\F509";
}

.mdi-test-tube:before {
  content: "\\F668";
}

.mdi-test-tube-empty:before {
  content: "\\F910";
}

.mdi-test-tube-off:before {
  content: "\\F911";
}

.mdi-text:before {
  content: "\\F9A7";
}

.mdi-text-shadow:before {
  content: "\\F669";
}

.mdi-text-short:before {
  content: "\\F9A8";
}

.mdi-text-subject:before {
  content: "\\F9A9";
}

.mdi-text-to-speech:before {
  content: "\\F50A";
}

.mdi-text-to-speech-off:before {
  content: "\\F50B";
}

.mdi-textbox:before {
  content: "\\F60E";
}

.mdi-textbox-password:before {
  content: "\\F7F4";
}

.mdi-texture:before {
  content: "\\F50C";
}

.mdi-theater:before {
  content: "\\F50D";
}

.mdi-theme-light-dark:before {
  content: "\\F50E";
}

.mdi-thermometer:before {
  content: "\\F50F";
}

.mdi-thermometer-lines:before {
  content: "\\F510";
}

.mdi-thermostat:before {
  content: "\\F393";
}

.mdi-thermostat-box:before {
  content: "\\F890";
}

.mdi-thought-bubble:before {
  content: "\\F7F5";
}

.mdi-thought-bubble-outline:before {
  content: "\\F7F6";
}

.mdi-thumb-down:before {
  content: "\\F511";
}

.mdi-thumb-down-outline:before {
  content: "\\F512";
}

.mdi-thumb-up:before {
  content: "\\F513";
}

.mdi-thumb-up-outline:before {
  content: "\\F514";
}

.mdi-thumbs-up-down:before {
  content: "\\F515";
}

.mdi-ticket:before {
  content: "\\F516";
}

.mdi-ticket-account:before {
  content: "\\F517";
}

.mdi-ticket-confirmation:before {
  content: "\\F518";
}

.mdi-ticket-outline:before {
  content: "\\F912";
}

.mdi-ticket-percent:before {
  content: "\\F723";
}

.mdi-tie:before {
  content: "\\F519";
}

.mdi-tilde:before {
  content: "\\F724";
}

.mdi-timelapse:before {
  content: "\\F51A";
}

.mdi-timer:before {
  content: "\\F51B";
}

.mdi-timer-10:before {
  content: "\\F51C";
}

.mdi-timer-3:before {
  content: "\\F51D";
}

.mdi-timer-off:before {
  content: "\\F51E";
}

.mdi-timer-sand:before {
  content: "\\F51F";
}

.mdi-timer-sand-empty:before {
  content: "\\F6AC";
}

.mdi-timer-sand-full:before {
  content: "\\F78B";
}

.mdi-timetable:before {
  content: "\\F520";
}

.mdi-toggle-switch:before {
  content: "\\F521";
}

.mdi-toggle-switch-off:before {
  content: "\\F522";
}

.mdi-toilet:before {
  content: "\\F9AA";
}

.mdi-toolbox:before {
  content: "\\F9AB";
}

.mdi-toolbox-outline:before {
  content: "\\F9AC";
}

.mdi-tooltip:before {
  content: "\\F523";
}

.mdi-tooltip-edit:before {
  content: "\\F524";
}

.mdi-tooltip-image:before {
  content: "\\F525";
}

.mdi-tooltip-outline:before {
  content: "\\F526";
}

.mdi-tooltip-outline-plus:before {
  content: "\\F527";
}

.mdi-tooltip-text:before {
  content: "\\F528";
}

.mdi-tooth:before {
  content: "\\F8C2";
}

.mdi-tooth-outline:before {
  content: "\\F529";
}

.mdi-tor:before {
  content: "\\F52A";
}

.mdi-tournament:before {
  content: "\\F9AD";
}

.mdi-tower-beach:before {
  content: "\\F680";
}

.mdi-tower-fire:before {
  content: "\\F681";
}

.mdi-towing:before {
  content: "\\F83B";
}

.mdi-track-light:before {
  content: "\\F913";
}

.mdi-trackpad:before {
  content: "\\F7F7";
}

.mdi-trackpad-lock:before {
  content: "\\F932";
}

.mdi-tractor:before {
  content: "\\F891";
}

.mdi-traffic-light:before {
  content: "\\F52B";
}

.mdi-train:before {
  content: "\\F52C";
}

.mdi-train-variant:before {
  content: "\\F8C3";
}

.mdi-tram:before {
  content: "\\F52D";
}

.mdi-transcribe:before {
  content: "\\F52E";
}

.mdi-transcribe-close:before {
  content: "\\F52F";
}

.mdi-transfer:before {
  content: "\\F530";
}

.mdi-transit-transfer:before {
  content: "\\F6AD";
}

.mdi-transition:before {
  content: "\\F914";
}

.mdi-transition-masked:before {
  content: "\\F915";
}

.mdi-translate:before {
  content: "\\F5CA";
}

.mdi-treasure-chest:before {
  content: "\\F725";
}

.mdi-tree:before {
  content: "\\F531";
}

.mdi-trello:before {
  content: "\\F532";
}

.mdi-trending-down:before {
  content: "\\F533";
}

.mdi-trending-neutral:before {
  content: "\\F534";
}

.mdi-trending-up:before {
  content: "\\F535";
}

.mdi-triangle:before {
  content: "\\F536";
}

.mdi-triangle-outline:before {
  content: "\\F537";
}

.mdi-trophy:before {
  content: "\\F538";
}

.mdi-trophy-award:before {
  content: "\\F539";
}

.mdi-trophy-outline:before {
  content: "\\F53A";
}

.mdi-trophy-variant:before {
  content: "\\F53B";
}

.mdi-trophy-variant-outline:before {
  content: "\\F53C";
}

.mdi-truck:before {
  content: "\\F53D";
}

.mdi-truck-delivery:before {
  content: "\\F53E";
}

.mdi-truck-fast:before {
  content: "\\F787";
}

.mdi-truck-trailer:before {
  content: "\\F726";
}

.mdi-tshirt-crew:before {
  content: "\\F53F";
}

.mdi-tshirt-v:before {
  content: "\\F540";
}

.mdi-tumble-dryer:before {
  content: "\\F916";
}

.mdi-tumblr:before {
  content: "\\F541";
}

.mdi-tumblr-box:before {
  content: "\\F917";
}

.mdi-tumblr-reblog:before {
  content: "\\F542";
}

.mdi-tune:before {
  content: "\\F62E";
}

.mdi-tune-vertical:before {
  content: "\\F66A";
}

.mdi-twitch:before {
  content: "\\F543";
}

.mdi-twitter:before {
  content: "\\F544";
}

.mdi-twitter-box:before {
  content: "\\F545";
}

.mdi-twitter-circle:before {
  content: "\\F546";
}

.mdi-twitter-retweet:before {
  content: "\\F547";
}

.mdi-two-factor-authentication:before {
  content: "\\F9AE";
}

.mdi-uber:before {
  content: "\\F748";
}

.mdi-ubuntu:before {
  content: "\\F548";
}

.mdi-ultra-high-definition:before {
  content: "\\F7F8";
}

.mdi-umbraco:before {
  content: "\\F549";
}

.mdi-umbrella:before {
  content: "\\F54A";
}

.mdi-umbrella-closed:before {
  content: "\\F9AF";
}

.mdi-umbrella-outline:before {
  content: "\\F54B";
}

.mdi-undo:before {
  content: "\\F54C";
}

.mdi-undo-variant:before {
  content: "\\F54D";
}

.mdi-unfold-less-horizontal:before {
  content: "\\F54E";
}

.mdi-unfold-less-vertical:before {
  content: "\\F75F";
}

.mdi-unfold-more-horizontal:before {
  content: "\\F54F";
}

.mdi-unfold-more-vertical:before {
  content: "\\F760";
}

.mdi-ungroup:before {
  content: "\\F550";
}

.mdi-unity:before {
  content: "\\F6AE";
}

.mdi-unreal:before {
  content: "\\F9B0";
}

.mdi-untappd:before {
  content: "\\F551";
}

.mdi-update:before {
  content: "\\F6AF";
}

.mdi-upload:before {
  content: "\\F552";
}

.mdi-upload-multiple:before {
  content: "\\F83C";
}

.mdi-upload-network:before {
  content: "\\F6F5";
}

.mdi-usb:before {
  content: "\\F553";
}

.mdi-van-passenger:before {
  content: "\\F7F9";
}

.mdi-van-utility:before {
  content: "\\F7FA";
}

.mdi-vanish:before {
  content: "\\F7FB";
}

.mdi-vector-arrange-above:before {
  content: "\\F554";
}

.mdi-vector-arrange-below:before {
  content: "\\F555";
}

.mdi-vector-circle:before {
  content: "\\F556";
}

.mdi-vector-circle-variant:before {
  content: "\\F557";
}

.mdi-vector-combine:before {
  content: "\\F558";
}

.mdi-vector-curve:before {
  content: "\\F559";
}

.mdi-vector-difference:before {
  content: "\\F55A";
}

.mdi-vector-difference-ab:before {
  content: "\\F55B";
}

.mdi-vector-difference-ba:before {
  content: "\\F55C";
}

.mdi-vector-ellipse:before {
  content: "\\F892";
}

.mdi-vector-intersection:before {
  content: "\\F55D";
}

.mdi-vector-line:before {
  content: "\\F55E";
}

.mdi-vector-point:before {
  content: "\\F55F";
}

.mdi-vector-polygon:before {
  content: "\\F560";
}

.mdi-vector-polyline:before {
  content: "\\F561";
}

.mdi-vector-radius:before {
  content: "\\F749";
}

.mdi-vector-rectangle:before {
  content: "\\F5C6";
}

.mdi-vector-selection:before {
  content: "\\F562";
}

.mdi-vector-square:before {
  content: "\\F001";
}

.mdi-vector-triangle:before {
  content: "\\F563";
}

.mdi-vector-union:before {
  content: "\\F564";
}

.mdi-venmo:before {
  content: "\\F578";
}

.mdi-verified:before {
  content: "\\F565";
}

.mdi-vibrate:before {
  content: "\\F566";
}

.mdi-video:before {
  content: "\\F567";
}

.mdi-video-3d:before {
  content: "\\F7FC";
}

.mdi-video-4k-box:before {
  content: "\\F83D";
}

.mdi-video-account:before {
  content: "\\F918";
}

.mdi-video-image:before {
  content: "\\F919";
}

.mdi-video-input-antenna:before {
  content: "\\F83E";
}

.mdi-video-input-component:before {
  content: "\\F83F";
}

.mdi-video-input-hdmi:before {
  content: "\\F840";
}

.mdi-video-input-svideo:before {
  content: "\\F841";
}

.mdi-video-minus:before {
  content: "\\F9B1";
}

.mdi-video-off:before {
  content: "\\F568";
}

.mdi-video-plus:before {
  content: "\\F9B2";
}

.mdi-video-stabilization:before {
  content: "\\F91A";
}

.mdi-video-switch:before {
  content: "\\F569";
}

.mdi-view-agenda:before {
  content: "\\F56A";
}

.mdi-view-array:before {
  content: "\\F56B";
}

.mdi-view-carousel:before {
  content: "\\F56C";
}

.mdi-view-column:before {
  content: "\\F56D";
}

.mdi-view-dashboard:before {
  content: "\\F56E";
}

.mdi-view-dashboard-variant:before {
  content: "\\F842";
}

.mdi-view-day:before {
  content: "\\F56F";
}

.mdi-view-grid:before {
  content: "\\F570";
}

.mdi-view-headline:before {
  content: "\\F571";
}

.mdi-view-list:before {
  content: "\\F572";
}

.mdi-view-module:before {
  content: "\\F573";
}

.mdi-view-parallel:before {
  content: "\\F727";
}

.mdi-view-quilt:before {
  content: "\\F574";
}

.mdi-view-sequential:before {
  content: "\\F728";
}

.mdi-view-stream:before {
  content: "\\F575";
}

.mdi-view-week:before {
  content: "\\F576";
}

.mdi-vimeo:before {
  content: "\\F577";
}

.mdi-violin:before {
  content: "\\F60F";
}

.mdi-virtual-reality:before {
  content: "\\F893";
}

.mdi-visualstudio:before {
  content: "\\F610";
}

.mdi-vk:before {
  content: "\\F579";
}

.mdi-vk-box:before {
  content: "\\F57A";
}

.mdi-vk-circle:before {
  content: "\\F57B";
}

.mdi-vlc:before {
  content: "\\F57C";
}

.mdi-voice:before {
  content: "\\F5CB";
}

.mdi-voicemail:before {
  content: "\\F57D";
}

.mdi-volleyball:before {
  content: "\\F9B3";
}

.mdi-volume-high:before {
  content: "\\F57E";
}

.mdi-volume-low:before {
  content: "\\F57F";
}

.mdi-volume-medium:before {
  content: "\\F580";
}

.mdi-volume-minus:before {
  content: "\\F75D";
}

.mdi-volume-mute:before {
  content: "\\F75E";
}

.mdi-volume-off:before {
  content: "\\F581";
}

.mdi-volume-plus:before {
  content: "\\F75C";
}

.mdi-vpn:before {
  content: "\\F582";
}

.mdi-vuejs:before {
  content: "\\F843";
}

.mdi-walk:before {
  content: "\\F583";
}

.mdi-wall:before {
  content: "\\F7FD";
}

.mdi-wall-sconce:before {
  content: "\\F91B";
}

.mdi-wall-sconce-flat:before {
  content: "\\F91C";
}

.mdi-wall-sconce-variant:before {
  content: "\\F91D";
}

.mdi-wallet:before {
  content: "\\F584";
}

.mdi-wallet-giftcard:before {
  content: "\\F585";
}

.mdi-wallet-membership:before {
  content: "\\F586";
}

.mdi-wallet-travel:before {
  content: "\\F587";
}

.mdi-wan:before {
  content: "\\F588";
}

.mdi-washing-machine:before {
  content: "\\F729";
}

.mdi-watch:before {
  content: "\\F589";
}

.mdi-watch-export:before {
  content: "\\F58A";
}

.mdi-watch-export-variant:before {
  content: "\\F894";
}

.mdi-watch-import:before {
  content: "\\F58B";
}

.mdi-watch-import-variant:before {
  content: "\\F895";
}

.mdi-watch-variant:before {
  content: "\\F896";
}

.mdi-watch-vibrate:before {
  content: "\\F6B0";
}

.mdi-water:before {
  content: "\\F58C";
}

.mdi-water-off:before {
  content: "\\F58D";
}

.mdi-water-percent:before {
  content: "\\F58E";
}

.mdi-water-pump:before {
  content: "\\F58F";
}

.mdi-watermark:before {
  content: "\\F612";
}

.mdi-waves:before {
  content: "\\F78C";
}

.mdi-weather-cloudy:before {
  content: "\\F590";
}

.mdi-weather-fog:before {
  content: "\\F591";
}

.mdi-weather-hail:before {
  content: "\\F592";
}

.mdi-weather-hurricane:before {
  content: "\\F897";
}

.mdi-weather-lightning:before {
  content: "\\F593";
}

.mdi-weather-lightning-rainy:before {
  content: "\\F67D";
}

.mdi-weather-night:before {
  content: "\\F594";
}

.mdi-weather-partlycloudy:before {
  content: "\\F595";
}

.mdi-weather-pouring:before {
  content: "\\F596";
}

.mdi-weather-rainy:before {
  content: "\\F597";
}

.mdi-weather-snowy:before {
  content: "\\F598";
}

.mdi-weather-snowy-rainy:before {
  content: "\\F67E";
}

.mdi-weather-sunny:before {
  content: "\\F599";
}

.mdi-weather-sunset:before {
  content: "\\F59A";
}

.mdi-weather-sunset-down:before {
  content: "\\F59B";
}

.mdi-weather-sunset-up:before {
  content: "\\F59C";
}

.mdi-weather-windy:before {
  content: "\\F59D";
}

.mdi-weather-windy-variant:before {
  content: "\\F59E";
}

.mdi-web:before {
  content: "\\F59F";
}

.mdi-webcam:before {
  content: "\\F5A0";
}

.mdi-webhook:before {
  content: "\\F62F";
}

.mdi-webpack:before {
  content: "\\F72A";
}

.mdi-wechat:before {
  content: "\\F611";
}

.mdi-weight:before {
  content: "\\F5A1";
}

.mdi-weight-kilogram:before {
  content: "\\F5A2";
}

.mdi-weight-pound:before {
  content: "\\F9B4";
}

.mdi-whatsapp:before {
  content: "\\F5A3";
}

.mdi-wheelchair-accessibility:before {
  content: "\\F5A4";
}

.mdi-whistle:before {
  content: "\\F9B5";
}

.mdi-white-balance-auto:before {
  content: "\\F5A5";
}

.mdi-white-balance-incandescent:before {
  content: "\\F5A6";
}

.mdi-white-balance-iridescent:before {
  content: "\\F5A7";
}

.mdi-white-balance-sunny:before {
  content: "\\F5A8";
}

.mdi-widgets:before {
  content: "\\F72B";
}

.mdi-wifi:before {
  content: "\\F5A9";
}

.mdi-wifi-off:before {
  content: "\\F5AA";
}

.mdi-wifi-strength-1:before {
  content: "\\F91E";
}

.mdi-wifi-strength-1-alert:before {
  content: "\\F91F";
}

.mdi-wifi-strength-1-lock:before {
  content: "\\F920";
}

.mdi-wifi-strength-2:before {
  content: "\\F921";
}

.mdi-wifi-strength-2-alert:before {
  content: "\\F922";
}

.mdi-wifi-strength-2-lock:before {
  content: "\\F923";
}

.mdi-wifi-strength-3:before {
  content: "\\F924";
}

.mdi-wifi-strength-3-alert:before {
  content: "\\F925";
}

.mdi-wifi-strength-3-lock:before {
  content: "\\F926";
}

.mdi-wifi-strength-4:before {
  content: "\\F927";
}

.mdi-wifi-strength-4-alert:before {
  content: "\\F928";
}

.mdi-wifi-strength-4-lock:before {
  content: "\\F929";
}

.mdi-wifi-strength-alert-outline:before {
  content: "\\F92A";
}

.mdi-wifi-strength-lock-outline:before {
  content: "\\F92B";
}

.mdi-wifi-strength-off:before {
  content: "\\F92C";
}

.mdi-wifi-strength-off-outline:before {
  content: "\\F92D";
}

.mdi-wifi-strength-outline:before {
  content: "\\F92E";
}

.mdi-wii:before {
  content: "\\F5AB";
}

.mdi-wiiu:before {
  content: "\\F72C";
}

.mdi-wikipedia:before {
  content: "\\F5AC";
}

.mdi-window-close:before {
  content: "\\F5AD";
}

.mdi-window-closed:before {
  content: "\\F5AE";
}

.mdi-window-maximize:before {
  content: "\\F5AF";
}

.mdi-window-minimize:before {
  content: "\\F5B0";
}

.mdi-window-open:before {
  content: "\\F5B1";
}

.mdi-window-restore:before {
  content: "\\F5B2";
}

.mdi-windows:before {
  content: "\\F5B3";
}

.mdi-wordpress:before {
  content: "\\F5B4";
}

.mdi-worker:before {
  content: "\\F5B5";
}

.mdi-wrap:before {
  content: "\\F5B6";
}

.mdi-wrench:before {
  content: "\\F5B7";
}

.mdi-wunderlist:before {
  content: "\\F5B8";
}

.mdi-xamarin:before {
  content: "\\F844";
}

.mdi-xamarin-outline:before {
  content: "\\F845";
}

.mdi-xaml:before {
  content: "\\F673";
}

.mdi-xbox:before {
  content: "\\F5B9";
}

.mdi-xbox-controller:before {
  content: "\\F5BA";
}

.mdi-xbox-controller-battery-alert:before {
  content: "\\F74A";
}

.mdi-xbox-controller-battery-empty:before {
  content: "\\F74B";
}

.mdi-xbox-controller-battery-full:before {
  content: "\\F74C";
}

.mdi-xbox-controller-battery-low:before {
  content: "\\F74D";
}

.mdi-xbox-controller-battery-medium:before {
  content: "\\F74E";
}

.mdi-xbox-controller-battery-unknown:before {
  content: "\\F74F";
}

.mdi-xbox-controller-off:before {
  content: "\\F5BB";
}

.mdi-xda:before {
  content: "\\F5BC";
}

.mdi-xing:before {
  content: "\\F5BD";
}

.mdi-xing-box:before {
  content: "\\F5BE";
}

.mdi-xing-circle:before {
  content: "\\F5BF";
}

.mdi-xml:before {
  content: "\\F5C0";
}

.mdi-xmpp:before {
  content: "\\F7FE";
}

.mdi-yammer:before {
  content: "\\F788";
}

.mdi-yeast:before {
  content: "\\F5C1";
}

.mdi-yelp:before {
  content: "\\F5C2";
}

.mdi-yin-yang:before {
  content: "\\F67F";
}

.mdi-youtube:before {
  content: "\\F5C3";
}

.mdi-youtube-creator-studio:before {
  content: "\\F846";
}

.mdi-youtube-gaming:before {
  content: "\\F847";
}

.mdi-youtube-tv:before {
  content: "\\F448";
}

.mdi-zip-box:before {
  content: "\\F5C4";
}

.mdi-blank:before {
  content: "\\F68C";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}
.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}
.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(45deg);
      transform: scaleX(-1) rotate(45deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: scaleY(-1) rotate(45deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(90deg);
      transform: scaleX(-1) rotate(90deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: scaleY(-1) rotate(90deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(135deg);
      transform: scaleX(-1) rotate(135deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(135deg);
      -ms-transform: rotate(135deg);
      transform: scaleY(-1) rotate(135deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(180deg);
      transform: scaleX(-1) rotate(180deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: scaleY(-1) rotate(180deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(225deg);
      transform: scaleX(-1) rotate(225deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(225deg);
      -ms-transform: rotate(225deg);
      transform: scaleY(-1) rotate(225deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(270deg);
      transform: scaleX(-1) rotate(270deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(270deg);
      -ms-transform: rotate(270deg);
      transform: scaleY(-1) rotate(270deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(315deg);
      transform: scaleX(-1) rotate(315deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(315deg);
      -ms-transform: rotate(315deg);
      transform: scaleY(-1) rotate(315deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/icons/material-design-iconic-font/css/materialdesignicons.min.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,4CAA6D;EAC7D,4SAAsa;EACta,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,wBAAwB;AAC1B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,wBAAwB;AAC1B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;;;;;;GAeC;AACH;AACA;EAGE,yBAAyB;AAC3B;;AAEA;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,sCAAsC;AACxC;AAYA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF","sourcesContent":["/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../fonts/materialdesignicons-webfont.eot?v=2.4.85\");\n  src: url(\"../fonts/materialdesignicons-webfont.eot?#iefix&v=2.4.85\") format(\"embedded-opentype\"), url(\"../fonts/materialdesignicons-webfont.woff2?v=2.4.85\") format(\"woff2\"), url(\"../fonts/materialdesignicons-webfont.woff?v=2.4.85\") format(\"woff\"), url(\"../fonts/materialdesignicons-webfont.ttf?v=2.4.85\") format(\"truetype\"), url(\"../fonts/materialdesignicons-webfont.svg?v=2.4.85#materialdesigniconsregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-access-point:before {\n  content: \"\\F002\";\n}\n\n.mdi-access-point-network:before {\n  content: \"\\F003\";\n}\n\n.mdi-account:before {\n  content: \"\\F004\";\n}\n\n.mdi-account-alert:before {\n  content: \"\\F005\";\n}\n\n.mdi-account-box:before {\n  content: \"\\F006\";\n}\n\n.mdi-account-box-multiple:before {\n  content: \"\\F933\";\n}\n\n.mdi-account-box-outline:before {\n  content: \"\\F007\";\n}\n\n.mdi-account-card-details:before {\n  content: \"\\F5D2\";\n}\n\n.mdi-account-check:before {\n  content: \"\\F008\";\n}\n\n.mdi-account-circle:before {\n  content: \"\\F009\";\n}\n\n.mdi-account-convert:before {\n  content: \"\\F00A\";\n}\n\n.mdi-account-edit:before {\n  content: \"\\F6BB\";\n}\n\n.mdi-account-group:before {\n  content: \"\\F848\";\n}\n\n.mdi-account-heart:before {\n  content: \"\\F898\";\n}\n\n.mdi-account-key:before {\n  content: \"\\F00B\";\n}\n\n.mdi-account-location:before {\n  content: \"\\F00C\";\n}\n\n.mdi-account-minus:before {\n  content: \"\\F00D\";\n}\n\n.mdi-account-multiple:before {\n  content: \"\\F00E\";\n}\n\n.mdi-account-multiple-check:before {\n  content: \"\\F8C4\";\n}\n\n.mdi-account-multiple-minus:before {\n  content: \"\\F5D3\";\n}\n\n.mdi-account-multiple-outline:before {\n  content: \"\\F00F\";\n}\n\n.mdi-account-multiple-plus:before {\n  content: \"\\F010\";\n}\n\n.mdi-account-multiple-plus-outline:before {\n  content: \"\\F7FF\";\n}\n\n.mdi-account-network:before {\n  content: \"\\F011\";\n}\n\n.mdi-account-off:before {\n  content: \"\\F012\";\n}\n\n.mdi-account-outline:before {\n  content: \"\\F013\";\n}\n\n.mdi-account-plus:before {\n  content: \"\\F014\";\n}\n\n.mdi-account-plus-outline:before {\n  content: \"\\F800\";\n}\n\n.mdi-account-remove:before {\n  content: \"\\F015\";\n}\n\n.mdi-account-search:before {\n  content: \"\\F016\";\n}\n\n.mdi-account-search-outline:before {\n  content: \"\\F934\";\n}\n\n.mdi-account-settings:before {\n  content: \"\\F630\";\n}\n\n.mdi-account-settings-variant:before {\n  content: \"\\F631\";\n}\n\n.mdi-account-star:before {\n  content: \"\\F017\";\n}\n\n.mdi-account-switch:before {\n  content: \"\\F019\";\n}\n\n.mdi-accusoft:before {\n  content: \"\\F849\";\n}\n\n.mdi-adjust:before {\n  content: \"\\F01A\";\n}\n\n.mdi-adobe:before {\n  content: \"\\F935\";\n}\n\n.mdi-air-conditioner:before {\n  content: \"\\F01B\";\n}\n\n.mdi-airballoon:before {\n  content: \"\\F01C\";\n}\n\n.mdi-airplane:before {\n  content: \"\\F01D\";\n}\n\n.mdi-airplane-landing:before {\n  content: \"\\F5D4\";\n}\n\n.mdi-airplane-off:before {\n  content: \"\\F01E\";\n}\n\n.mdi-airplane-takeoff:before {\n  content: \"\\F5D5\";\n}\n\n.mdi-airplay:before {\n  content: \"\\F01F\";\n}\n\n.mdi-airport:before {\n  content: \"\\F84A\";\n}\n\n.mdi-alarm:before {\n  content: \"\\F020\";\n}\n\n.mdi-alarm-bell:before {\n  content: \"\\F78D\";\n}\n\n.mdi-alarm-check:before {\n  content: \"\\F021\";\n}\n\n.mdi-alarm-light:before {\n  content: \"\\F78E\";\n}\n\n.mdi-alarm-multiple:before {\n  content: \"\\F022\";\n}\n\n.mdi-alarm-off:before {\n  content: \"\\F023\";\n}\n\n.mdi-alarm-plus:before {\n  content: \"\\F024\";\n}\n\n.mdi-alarm-snooze:before {\n  content: \"\\F68D\";\n}\n\n.mdi-album:before {\n  content: \"\\F025\";\n}\n\n.mdi-alert:before {\n  content: \"\\F026\";\n}\n\n.mdi-alert-box:before {\n  content: \"\\F027\";\n}\n\n.mdi-alert-circle:before {\n  content: \"\\F028\";\n}\n\n.mdi-alert-circle-outline:before {\n  content: \"\\F5D6\";\n}\n\n.mdi-alert-decagram:before {\n  content: \"\\F6BC\";\n}\n\n.mdi-alert-octagon:before {\n  content: \"\\F029\";\n}\n\n.mdi-alert-octagram:before {\n  content: \"\\F766\";\n}\n\n.mdi-alert-outline:before {\n  content: \"\\F02A\";\n}\n\n.mdi-alien:before {\n  content: \"\\F899\";\n}\n\n.mdi-all-inclusive:before {\n  content: \"\\F6BD\";\n}\n\n.mdi-alpha:before {\n  content: \"\\F02B\";\n}\n\n.mdi-alphabetical:before {\n  content: \"\\F02C\";\n}\n\n.mdi-altimeter:before {\n  content: \"\\F5D7\";\n}\n\n.mdi-amazon:before {\n  content: \"\\F02D\";\n}\n\n.mdi-amazon-alexa:before {\n  content: \"\\F8C5\";\n}\n\n.mdi-amazon-drive:before {\n  content: \"\\F02E\";\n}\n\n.mdi-ambulance:before {\n  content: \"\\F02F\";\n}\n\n.mdi-amplifier:before {\n  content: \"\\F030\";\n}\n\n.mdi-anchor:before {\n  content: \"\\F031\";\n}\n\n.mdi-android:before {\n  content: \"\\F032\";\n}\n\n.mdi-android-debug-bridge:before {\n  content: \"\\F033\";\n}\n\n.mdi-android-head:before {\n  content: \"\\F78F\";\n}\n\n.mdi-android-studio:before {\n  content: \"\\F034\";\n}\n\n.mdi-angle-acute:before {\n  content: \"\\F936\";\n}\n\n.mdi-angle-obtuse:before {\n  content: \"\\F937\";\n}\n\n.mdi-angle-right:before {\n  content: \"\\F938\";\n}\n\n.mdi-angular:before {\n  content: \"\\F6B1\";\n}\n\n.mdi-angularjs:before {\n  content: \"\\F6BE\";\n}\n\n.mdi-animation:before {\n  content: \"\\F5D8\";\n}\n\n.mdi-animation-play:before {\n  content: \"\\F939\";\n}\n\n.mdi-anvil:before {\n  content: \"\\F89A\";\n}\n\n.mdi-apple:before {\n  content: \"\\F035\";\n}\n\n.mdi-apple-finder:before {\n  content: \"\\F036\";\n}\n\n.mdi-apple-icloud:before {\n  content: \"\\F038\";\n}\n\n.mdi-apple-ios:before {\n  content: \"\\F037\";\n}\n\n.mdi-apple-keyboard-caps:before {\n  content: \"\\F632\";\n}\n\n.mdi-apple-keyboard-command:before {\n  content: \"\\F633\";\n}\n\n.mdi-apple-keyboard-control:before {\n  content: \"\\F634\";\n}\n\n.mdi-apple-keyboard-option:before {\n  content: \"\\F635\";\n}\n\n.mdi-apple-keyboard-shift:before {\n  content: \"\\F636\";\n}\n\n.mdi-apple-safari:before {\n  content: \"\\F039\";\n}\n\n.mdi-application:before {\n  content: \"\\F614\";\n}\n\n.mdi-approval:before {\n  content: \"\\F790\";\n}\n\n.mdi-apps:before {\n  content: \"\\F03B\";\n}\n\n.mdi-arch:before {\n  content: \"\\F8C6\";\n}\n\n.mdi-archive:before {\n  content: \"\\F03C\";\n}\n\n.mdi-arrange-bring-forward:before {\n  content: \"\\F03D\";\n}\n\n.mdi-arrange-bring-to-front:before {\n  content: \"\\F03E\";\n}\n\n.mdi-arrange-send-backward:before {\n  content: \"\\F03F\";\n}\n\n.mdi-arrange-send-to-back:before {\n  content: \"\\F040\";\n}\n\n.mdi-arrow-all:before {\n  content: \"\\F041\";\n}\n\n.mdi-arrow-bottom-left:before {\n  content: \"\\F042\";\n}\n\n.mdi-arrow-bottom-right:before {\n  content: \"\\F043\";\n}\n\n.mdi-arrow-collapse:before {\n  content: \"\\F615\";\n}\n\n.mdi-arrow-collapse-all:before {\n  content: \"\\F044\";\n}\n\n.mdi-arrow-collapse-down:before {\n  content: \"\\F791\";\n}\n\n.mdi-arrow-collapse-horizontal:before {\n  content: \"\\F84B\";\n}\n\n.mdi-arrow-collapse-left:before {\n  content: \"\\F792\";\n}\n\n.mdi-arrow-collapse-right:before {\n  content: \"\\F793\";\n}\n\n.mdi-arrow-collapse-up:before {\n  content: \"\\F794\";\n}\n\n.mdi-arrow-collapse-vertical:before {\n  content: \"\\F84C\";\n}\n\n.mdi-arrow-down:before {\n  content: \"\\F045\";\n}\n\n.mdi-arrow-down-bold:before {\n  content: \"\\F72D\";\n}\n\n.mdi-arrow-down-bold-box:before {\n  content: \"\\F72E\";\n}\n\n.mdi-arrow-down-bold-box-outline:before {\n  content: \"\\F72F\";\n}\n\n.mdi-arrow-down-bold-circle:before {\n  content: \"\\F047\";\n}\n\n.mdi-arrow-down-bold-circle-outline:before {\n  content: \"\\F048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline:before {\n  content: \"\\F049\";\n}\n\n.mdi-arrow-down-box:before {\n  content: \"\\F6BF\";\n}\n\n.mdi-arrow-down-drop-circle:before {\n  content: \"\\F04A\";\n}\n\n.mdi-arrow-down-drop-circle-outline:before {\n  content: \"\\F04B\";\n}\n\n.mdi-arrow-down-thick:before {\n  content: \"\\F046\";\n}\n\n.mdi-arrow-expand:before {\n  content: \"\\F616\";\n}\n\n.mdi-arrow-expand-all:before {\n  content: \"\\F04C\";\n}\n\n.mdi-arrow-expand-down:before {\n  content: \"\\F795\";\n}\n\n.mdi-arrow-expand-horizontal:before {\n  content: \"\\F84D\";\n}\n\n.mdi-arrow-expand-left:before {\n  content: \"\\F796\";\n}\n\n.mdi-arrow-expand-right:before {\n  content: \"\\F797\";\n}\n\n.mdi-arrow-expand-up:before {\n  content: \"\\F798\";\n}\n\n.mdi-arrow-expand-vertical:before {\n  content: \"\\F84E\";\n}\n\n.mdi-arrow-left:before {\n  content: \"\\F04D\";\n}\n\n.mdi-arrow-left-bold:before {\n  content: \"\\F730\";\n}\n\n.mdi-arrow-left-bold-box:before {\n  content: \"\\F731\";\n}\n\n.mdi-arrow-left-bold-box-outline:before {\n  content: \"\\F732\";\n}\n\n.mdi-arrow-left-bold-circle:before {\n  content: \"\\F04F\";\n}\n\n.mdi-arrow-left-bold-circle-outline:before {\n  content: \"\\F050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline:before {\n  content: \"\\F051\";\n}\n\n.mdi-arrow-left-box:before {\n  content: \"\\F6C0\";\n}\n\n.mdi-arrow-left-drop-circle:before {\n  content: \"\\F052\";\n}\n\n.mdi-arrow-left-drop-circle-outline:before {\n  content: \"\\F053\";\n}\n\n.mdi-arrow-left-thick:before {\n  content: \"\\F04E\";\n}\n\n.mdi-arrow-right:before {\n  content: \"\\F054\";\n}\n\n.mdi-arrow-right-bold:before {\n  content: \"\\F733\";\n}\n\n.mdi-arrow-right-bold-box:before {\n  content: \"\\F734\";\n}\n\n.mdi-arrow-right-bold-box-outline:before {\n  content: \"\\F735\";\n}\n\n.mdi-arrow-right-bold-circle:before {\n  content: \"\\F056\";\n}\n\n.mdi-arrow-right-bold-circle-outline:before {\n  content: \"\\F057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline:before {\n  content: \"\\F058\";\n}\n\n.mdi-arrow-right-box:before {\n  content: \"\\F6C1\";\n}\n\n.mdi-arrow-right-drop-circle:before {\n  content: \"\\F059\";\n}\n\n.mdi-arrow-right-drop-circle-outline:before {\n  content: \"\\F05A\";\n}\n\n.mdi-arrow-right-thick:before {\n  content: \"\\F055\";\n}\n\n.mdi-arrow-split-horizontal:before {\n  content: \"\\F93A\";\n}\n\n.mdi-arrow-split-vertical:before {\n  content: \"\\F93B\";\n}\n\n.mdi-arrow-top-left:before {\n  content: \"\\F05B\";\n}\n\n.mdi-arrow-top-right:before {\n  content: \"\\F05C\";\n}\n\n.mdi-arrow-up:before {\n  content: \"\\F05D\";\n}\n\n.mdi-arrow-up-bold:before {\n  content: \"\\F736\";\n}\n\n.mdi-arrow-up-bold-box:before {\n  content: \"\\F737\";\n}\n\n.mdi-arrow-up-bold-box-outline:before {\n  content: \"\\F738\";\n}\n\n.mdi-arrow-up-bold-circle:before {\n  content: \"\\F05F\";\n}\n\n.mdi-arrow-up-bold-circle-outline:before {\n  content: \"\\F060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline:before {\n  content: \"\\F061\";\n}\n\n.mdi-arrow-up-box:before {\n  content: \"\\F6C2\";\n}\n\n.mdi-arrow-up-drop-circle:before {\n  content: \"\\F062\";\n}\n\n.mdi-arrow-up-drop-circle-outline:before {\n  content: \"\\F063\";\n}\n\n.mdi-arrow-up-thick:before {\n  content: \"\\F05E\";\n}\n\n.mdi-artist:before {\n  content: \"\\F802\";\n}\n\n.mdi-assistant:before {\n  content: \"\\F064\";\n}\n\n.mdi-asterisk:before {\n  content: \"\\F6C3\";\n}\n\n.mdi-at:before {\n  content: \"\\F065\";\n}\n\n.mdi-atlassian:before {\n  content: \"\\F803\";\n}\n\n.mdi-atom:before {\n  content: \"\\F767\";\n}\n\n.mdi-attachment:before {\n  content: \"\\F066\";\n}\n\n.mdi-audio-video:before {\n  content: \"\\F93C\";\n}\n\n.mdi-audiobook:before {\n  content: \"\\F067\";\n}\n\n.mdi-augmented-reality:before {\n  content: \"\\F84F\";\n}\n\n.mdi-auto-fix:before {\n  content: \"\\F068\";\n}\n\n.mdi-auto-upload:before {\n  content: \"\\F069\";\n}\n\n.mdi-autorenew:before {\n  content: \"\\F06A\";\n}\n\n.mdi-av-timer:before {\n  content: \"\\F06B\";\n}\n\n.mdi-axe:before {\n  content: \"\\F8C7\";\n}\n\n.mdi-azure:before {\n  content: \"\\F804\";\n}\n\n.mdi-baby:before {\n  content: \"\\F06C\";\n}\n\n.mdi-baby-buggy:before {\n  content: \"\\F68E\";\n}\n\n.mdi-backburger:before {\n  content: \"\\F06D\";\n}\n\n.mdi-backspace:before {\n  content: \"\\F06E\";\n}\n\n.mdi-backup-restore:before {\n  content: \"\\F06F\";\n}\n\n.mdi-badminton:before {\n  content: \"\\F850\";\n}\n\n.mdi-bandcamp:before {\n  content: \"\\F674\";\n}\n\n.mdi-bank:before {\n  content: \"\\F070\";\n}\n\n.mdi-barcode:before {\n  content: \"\\F071\";\n}\n\n.mdi-barcode-scan:before {\n  content: \"\\F072\";\n}\n\n.mdi-barley:before {\n  content: \"\\F073\";\n}\n\n.mdi-barrel:before {\n  content: \"\\F074\";\n}\n\n.mdi-baseball:before {\n  content: \"\\F851\";\n}\n\n.mdi-baseball-bat:before {\n  content: \"\\F852\";\n}\n\n.mdi-basecamp:before {\n  content: \"\\F075\";\n}\n\n.mdi-basket:before {\n  content: \"\\F076\";\n}\n\n.mdi-basket-fill:before {\n  content: \"\\F077\";\n}\n\n.mdi-basket-unfill:before {\n  content: \"\\F078\";\n}\n\n.mdi-basketball:before {\n  content: \"\\F805\";\n}\n\n.mdi-battery:before {\n  content: \"\\F079\";\n}\n\n.mdi-battery-10:before {\n  content: \"\\F07A\";\n}\n\n.mdi-battery-10-bluetooth:before {\n  content: \"\\F93D\";\n}\n\n.mdi-battery-20:before {\n  content: \"\\F07B\";\n}\n\n.mdi-battery-20-bluetooth:before {\n  content: \"\\F93E\";\n}\n\n.mdi-battery-30:before {\n  content: \"\\F07C\";\n}\n\n.mdi-battery-30-bluetooth:before {\n  content: \"\\F93F\";\n}\n\n.mdi-battery-40:before {\n  content: \"\\F07D\";\n}\n\n.mdi-battery-40-bluetooth:before {\n  content: \"\\F940\";\n}\n\n.mdi-battery-50:before {\n  content: \"\\F07E\";\n}\n\n.mdi-battery-50-bluetooth:before {\n  content: \"\\F941\";\n}\n\n.mdi-battery-60:before {\n  content: \"\\F07F\";\n}\n\n.mdi-battery-60-bluetooth:before {\n  content: \"\\F942\";\n}\n\n.mdi-battery-70:before {\n  content: \"\\F080\";\n}\n\n.mdi-battery-70-bluetooth:before {\n  content: \"\\F943\";\n}\n\n.mdi-battery-80:before {\n  content: \"\\F081\";\n}\n\n.mdi-battery-80-bluetooth:before {\n  content: \"\\F944\";\n}\n\n.mdi-battery-90:before {\n  content: \"\\F082\";\n}\n\n.mdi-battery-90-bluetooth:before {\n  content: \"\\F945\";\n}\n\n.mdi-battery-alert:before {\n  content: \"\\F083\";\n}\n\n.mdi-battery-alert-bluetooth:before {\n  content: \"\\F946\";\n}\n\n.mdi-battery-bluetooth:before {\n  content: \"\\F947\";\n}\n\n.mdi-battery-bluetooth-variant:before {\n  content: \"\\F948\";\n}\n\n.mdi-battery-charging:before {\n  content: \"\\F084\";\n}\n\n.mdi-battery-charging-10:before {\n  content: \"\\F89B\";\n}\n\n.mdi-battery-charging-100:before {\n  content: \"\\F085\";\n}\n\n.mdi-battery-charging-20:before {\n  content: \"\\F086\";\n}\n\n.mdi-battery-charging-30:before {\n  content: \"\\F087\";\n}\n\n.mdi-battery-charging-40:before {\n  content: \"\\F088\";\n}\n\n.mdi-battery-charging-50:before {\n  content: \"\\F89C\";\n}\n\n.mdi-battery-charging-60:before {\n  content: \"\\F089\";\n}\n\n.mdi-battery-charging-70:before {\n  content: \"\\F89D\";\n}\n\n.mdi-battery-charging-80:before {\n  content: \"\\F08A\";\n}\n\n.mdi-battery-charging-90:before {\n  content: \"\\F08B\";\n}\n\n.mdi-battery-charging-outline:before {\n  content: \"\\F89E\";\n}\n\n.mdi-battery-charging-wireless:before {\n  content: \"\\F806\";\n}\n\n.mdi-battery-charging-wireless-10:before {\n  content: \"\\F807\";\n}\n\n.mdi-battery-charging-wireless-20:before {\n  content: \"\\F808\";\n}\n\n.mdi-battery-charging-wireless-30:before {\n  content: \"\\F809\";\n}\n\n.mdi-battery-charging-wireless-40:before {\n  content: \"\\F80A\";\n}\n\n.mdi-battery-charging-wireless-50:before {\n  content: \"\\F80B\";\n}\n\n.mdi-battery-charging-wireless-60:before {\n  content: \"\\F80C\";\n}\n\n.mdi-battery-charging-wireless-70:before {\n  content: \"\\F80D\";\n}\n\n.mdi-battery-charging-wireless-80:before {\n  content: \"\\F80E\";\n}\n\n.mdi-battery-charging-wireless-90:before {\n  content: \"\\F80F\";\n}\n\n.mdi-battery-charging-wireless-alert:before {\n  content: \"\\F810\";\n}\n\n.mdi-battery-charging-wireless-outline:before {\n  content: \"\\F811\";\n}\n\n.mdi-battery-minus:before {\n  content: \"\\F08C\";\n}\n\n.mdi-battery-negative:before {\n  content: \"\\F08D\";\n}\n\n.mdi-battery-outline:before {\n  content: \"\\F08E\";\n}\n\n.mdi-battery-plus:before {\n  content: \"\\F08F\";\n}\n\n.mdi-battery-positive:before {\n  content: \"\\F090\";\n}\n\n.mdi-battery-unknown:before {\n  content: \"\\F091\";\n}\n\n.mdi-battery-unknown-bluetooth:before {\n  content: \"\\F949\";\n}\n\n.mdi-beach:before {\n  content: \"\\F092\";\n}\n\n.mdi-beaker:before {\n  content: \"\\F68F\";\n}\n\n.mdi-beats:before {\n  content: \"\\F097\";\n}\n\n.mdi-bed-empty:before {\n  content: \"\\F89F\";\n}\n\n.mdi-beer:before {\n  content: \"\\F098\";\n}\n\n.mdi-behance:before {\n  content: \"\\F099\";\n}\n\n.mdi-bell:before {\n  content: \"\\F09A\";\n}\n\n.mdi-bell-off:before {\n  content: \"\\F09B\";\n}\n\n.mdi-bell-outline:before {\n  content: \"\\F09C\";\n}\n\n.mdi-bell-plus:before {\n  content: \"\\F09D\";\n}\n\n.mdi-bell-ring:before {\n  content: \"\\F09E\";\n}\n\n.mdi-bell-ring-outline:before {\n  content: \"\\F09F\";\n}\n\n.mdi-bell-sleep:before {\n  content: \"\\F0A0\";\n}\n\n.mdi-beta:before {\n  content: \"\\F0A1\";\n}\n\n.mdi-bible:before {\n  content: \"\\F0A2\";\n}\n\n.mdi-bike:before {\n  content: \"\\F0A3\";\n}\n\n.mdi-bing:before {\n  content: \"\\F0A4\";\n}\n\n.mdi-binoculars:before {\n  content: \"\\F0A5\";\n}\n\n.mdi-bio:before {\n  content: \"\\F0A6\";\n}\n\n.mdi-biohazard:before {\n  content: \"\\F0A7\";\n}\n\n.mdi-bitbucket:before {\n  content: \"\\F0A8\";\n}\n\n.mdi-bitcoin:before {\n  content: \"\\F812\";\n}\n\n.mdi-black-mesa:before {\n  content: \"\\F0A9\";\n}\n\n.mdi-blackberry:before {\n  content: \"\\F0AA\";\n}\n\n.mdi-blender:before {\n  content: \"\\F0AB\";\n}\n\n.mdi-blinds:before {\n  content: \"\\F0AC\";\n}\n\n.mdi-block-helper:before {\n  content: \"\\F0AD\";\n}\n\n.mdi-blogger:before {\n  content: \"\\F0AE\";\n}\n\n.mdi-bluetooth:before {\n  content: \"\\F0AF\";\n}\n\n.mdi-bluetooth-audio:before {\n  content: \"\\F0B0\";\n}\n\n.mdi-bluetooth-connect:before {\n  content: \"\\F0B1\";\n}\n\n.mdi-bluetooth-off:before {\n  content: \"\\F0B2\";\n}\n\n.mdi-bluetooth-settings:before {\n  content: \"\\F0B3\";\n}\n\n.mdi-bluetooth-transfer:before {\n  content: \"\\F0B4\";\n}\n\n.mdi-blur:before {\n  content: \"\\F0B5\";\n}\n\n.mdi-blur-linear:before {\n  content: \"\\F0B6\";\n}\n\n.mdi-blur-off:before {\n  content: \"\\F0B7\";\n}\n\n.mdi-blur-radial:before {\n  content: \"\\F0B8\";\n}\n\n.mdi-bomb:before {\n  content: \"\\F690\";\n}\n\n.mdi-bomb-off:before {\n  content: \"\\F6C4\";\n}\n\n.mdi-bone:before {\n  content: \"\\F0B9\";\n}\n\n.mdi-book:before {\n  content: \"\\F0BA\";\n}\n\n.mdi-book-minus:before {\n  content: \"\\F5D9\";\n}\n\n.mdi-book-multiple:before {\n  content: \"\\F0BB\";\n}\n\n.mdi-book-multiple-variant:before {\n  content: \"\\F0BC\";\n}\n\n.mdi-book-open:before {\n  content: \"\\F0BD\";\n}\n\n.mdi-book-open-page-variant:before {\n  content: \"\\F5DA\";\n}\n\n.mdi-book-open-variant:before {\n  content: \"\\F0BE\";\n}\n\n.mdi-book-plus:before {\n  content: \"\\F5DB\";\n}\n\n.mdi-book-secure:before {\n  content: \"\\F799\";\n}\n\n.mdi-book-unsecure:before {\n  content: \"\\F79A\";\n}\n\n.mdi-book-variant:before {\n  content: \"\\F0BF\";\n}\n\n.mdi-bookmark:before {\n  content: \"\\F0C0\";\n}\n\n.mdi-bookmark-check:before {\n  content: \"\\F0C1\";\n}\n\n.mdi-bookmark-music:before {\n  content: \"\\F0C2\";\n}\n\n.mdi-bookmark-outline:before {\n  content: \"\\F0C3\";\n}\n\n.mdi-bookmark-plus:before {\n  content: \"\\F0C5\";\n}\n\n.mdi-bookmark-plus-outline:before {\n  content: \"\\F0C4\";\n}\n\n.mdi-bookmark-remove:before {\n  content: \"\\F0C6\";\n}\n\n.mdi-boombox:before {\n  content: \"\\F5DC\";\n}\n\n.mdi-bootstrap:before {\n  content: \"\\F6C5\";\n}\n\n.mdi-border-all:before {\n  content: \"\\F0C7\";\n}\n\n.mdi-border-all-variant:before {\n  content: \"\\F8A0\";\n}\n\n.mdi-border-bottom:before {\n  content: \"\\F0C8\";\n}\n\n.mdi-border-bottom-variant:before {\n  content: \"\\F8A1\";\n}\n\n.mdi-border-color:before {\n  content: \"\\F0C9\";\n}\n\n.mdi-border-horizontal:before {\n  content: \"\\F0CA\";\n}\n\n.mdi-border-inside:before {\n  content: \"\\F0CB\";\n}\n\n.mdi-border-left:before {\n  content: \"\\F0CC\";\n}\n\n.mdi-border-left-variant:before {\n  content: \"\\F8A2\";\n}\n\n.mdi-border-none:before {\n  content: \"\\F0CD\";\n}\n\n.mdi-border-none-variant:before {\n  content: \"\\F8A3\";\n}\n\n.mdi-border-outside:before {\n  content: \"\\F0CE\";\n}\n\n.mdi-border-right:before {\n  content: \"\\F0CF\";\n}\n\n.mdi-border-right-variant:before {\n  content: \"\\F8A4\";\n}\n\n.mdi-border-style:before {\n  content: \"\\F0D0\";\n}\n\n.mdi-border-top:before {\n  content: \"\\F0D1\";\n}\n\n.mdi-border-top-variant:before {\n  content: \"\\F8A5\";\n}\n\n.mdi-border-vertical:before {\n  content: \"\\F0D2\";\n}\n\n.mdi-bottle-wine:before {\n  content: \"\\F853\";\n}\n\n.mdi-bow-tie:before {\n  content: \"\\F677\";\n}\n\n.mdi-bowl:before {\n  content: \"\\F617\";\n}\n\n.mdi-bowling:before {\n  content: \"\\F0D3\";\n}\n\n.mdi-box:before {\n  content: \"\\F0D4\";\n}\n\n.mdi-box-cutter:before {\n  content: \"\\F0D5\";\n}\n\n.mdi-box-shadow:before {\n  content: \"\\F637\";\n}\n\n.mdi-bridge:before {\n  content: \"\\F618\";\n}\n\n.mdi-briefcase:before {\n  content: \"\\F0D6\";\n}\n\n.mdi-briefcase-check:before {\n  content: \"\\F0D7\";\n}\n\n.mdi-briefcase-download:before {\n  content: \"\\F0D8\";\n}\n\n.mdi-briefcase-outline:before {\n  content: \"\\F813\";\n}\n\n.mdi-briefcase-upload:before {\n  content: \"\\F0D9\";\n}\n\n.mdi-brightness-1:before {\n  content: \"\\F0DA\";\n}\n\n.mdi-brightness-2:before {\n  content: \"\\F0DB\";\n}\n\n.mdi-brightness-3:before {\n  content: \"\\F0DC\";\n}\n\n.mdi-brightness-4:before {\n  content: \"\\F0DD\";\n}\n\n.mdi-brightness-5:before {\n  content: \"\\F0DE\";\n}\n\n.mdi-brightness-6:before {\n  content: \"\\F0DF\";\n}\n\n.mdi-brightness-7:before {\n  content: \"\\F0E0\";\n}\n\n.mdi-brightness-auto:before {\n  content: \"\\F0E1\";\n}\n\n.mdi-broom:before {\n  content: \"\\F0E2\";\n}\n\n.mdi-brush:before {\n  content: \"\\F0E3\";\n}\n\n.mdi-buddhism:before {\n  content: \"\\F94A\";\n}\n\n.mdi-buffer:before {\n  content: \"\\F619\";\n}\n\n.mdi-bug:before {\n  content: \"\\F0E4\";\n}\n\n.mdi-bulletin-board:before {\n  content: \"\\F0E5\";\n}\n\n.mdi-bullhorn:before {\n  content: \"\\F0E6\";\n}\n\n.mdi-bullseye:before {\n  content: \"\\F5DD\";\n}\n\n.mdi-bullseye-arrow:before {\n  content: \"\\F8C8\";\n}\n\n.mdi-bus:before {\n  content: \"\\F0E7\";\n}\n\n.mdi-bus-articulated-end:before {\n  content: \"\\F79B\";\n}\n\n.mdi-bus-articulated-front:before {\n  content: \"\\F79C\";\n}\n\n.mdi-bus-clock:before {\n  content: \"\\F8C9\";\n}\n\n.mdi-bus-double-decker:before {\n  content: \"\\F79D\";\n}\n\n.mdi-bus-school:before {\n  content: \"\\F79E\";\n}\n\n.mdi-bus-side:before {\n  content: \"\\F79F\";\n}\n\n.mdi-cached:before {\n  content: \"\\F0E8\";\n}\n\n.mdi-cake:before {\n  content: \"\\F0E9\";\n}\n\n.mdi-cake-layered:before {\n  content: \"\\F0EA\";\n}\n\n.mdi-cake-variant:before {\n  content: \"\\F0EB\";\n}\n\n.mdi-calculator:before {\n  content: \"\\F0EC\";\n}\n\n.mdi-calendar:before {\n  content: \"\\F0ED\";\n}\n\n.mdi-calendar-blank:before {\n  content: \"\\F0EE\";\n}\n\n.mdi-calendar-check:before {\n  content: \"\\F0EF\";\n}\n\n.mdi-calendar-clock:before {\n  content: \"\\F0F0\";\n}\n\n.mdi-calendar-edit:before {\n  content: \"\\F8A6\";\n}\n\n.mdi-calendar-multiple:before {\n  content: \"\\F0F1\";\n}\n\n.mdi-calendar-multiple-check:before {\n  content: \"\\F0F2\";\n}\n\n.mdi-calendar-plus:before {\n  content: \"\\F0F3\";\n}\n\n.mdi-calendar-question:before {\n  content: \"\\F691\";\n}\n\n.mdi-calendar-range:before {\n  content: \"\\F678\";\n}\n\n.mdi-calendar-remove:before {\n  content: \"\\F0F4\";\n}\n\n.mdi-calendar-search:before {\n  content: \"\\F94B\";\n}\n\n.mdi-calendar-text:before {\n  content: \"\\F0F5\";\n}\n\n.mdi-calendar-today:before {\n  content: \"\\F0F6\";\n}\n\n.mdi-call-made:before {\n  content: \"\\F0F7\";\n}\n\n.mdi-call-merge:before {\n  content: \"\\F0F8\";\n}\n\n.mdi-call-missed:before {\n  content: \"\\F0F9\";\n}\n\n.mdi-call-received:before {\n  content: \"\\F0FA\";\n}\n\n.mdi-call-split:before {\n  content: \"\\F0FB\";\n}\n\n.mdi-camcorder:before {\n  content: \"\\F0FC\";\n}\n\n.mdi-camcorder-box:before {\n  content: \"\\F0FD\";\n}\n\n.mdi-camcorder-box-off:before {\n  content: \"\\F0FE\";\n}\n\n.mdi-camcorder-off:before {\n  content: \"\\F0FF\";\n}\n\n.mdi-camera:before {\n  content: \"\\F100\";\n}\n\n.mdi-camera-account:before {\n  content: \"\\F8CA\";\n}\n\n.mdi-camera-burst:before {\n  content: \"\\F692\";\n}\n\n.mdi-camera-enhance:before {\n  content: \"\\F101\";\n}\n\n.mdi-camera-front:before {\n  content: \"\\F102\";\n}\n\n.mdi-camera-front-variant:before {\n  content: \"\\F103\";\n}\n\n.mdi-camera-gopro:before {\n  content: \"\\F7A0\";\n}\n\n.mdi-camera-image:before {\n  content: \"\\F8CB\";\n}\n\n.mdi-camera-iris:before {\n  content: \"\\F104\";\n}\n\n.mdi-camera-metering-center:before {\n  content: \"\\F7A1\";\n}\n\n.mdi-camera-metering-matrix:before {\n  content: \"\\F7A2\";\n}\n\n.mdi-camera-metering-partial:before {\n  content: \"\\F7A3\";\n}\n\n.mdi-camera-metering-spot:before {\n  content: \"\\F7A4\";\n}\n\n.mdi-camera-off:before {\n  content: \"\\F5DF\";\n}\n\n.mdi-camera-party-mode:before {\n  content: \"\\F105\";\n}\n\n.mdi-camera-rear:before {\n  content: \"\\F106\";\n}\n\n.mdi-camera-rear-variant:before {\n  content: \"\\F107\";\n}\n\n.mdi-camera-switch:before {\n  content: \"\\F108\";\n}\n\n.mdi-camera-timer:before {\n  content: \"\\F109\";\n}\n\n.mdi-cancel:before {\n  content: \"\\F739\";\n}\n\n.mdi-candle:before {\n  content: \"\\F5E2\";\n}\n\n.mdi-candycane:before {\n  content: \"\\F10A\";\n}\n\n.mdi-cannabis:before {\n  content: \"\\F7A5\";\n}\n\n.mdi-car:before {\n  content: \"\\F10B\";\n}\n\n.mdi-car-battery:before {\n  content: \"\\F10C\";\n}\n\n.mdi-car-connected:before {\n  content: \"\\F10D\";\n}\n\n.mdi-car-convertible:before {\n  content: \"\\F7A6\";\n}\n\n.mdi-car-estate:before {\n  content: \"\\F7A7\";\n}\n\n.mdi-car-hatchback:before {\n  content: \"\\F7A8\";\n}\n\n.mdi-car-limousine:before {\n  content: \"\\F8CC\";\n}\n\n.mdi-car-pickup:before {\n  content: \"\\F7A9\";\n}\n\n.mdi-car-side:before {\n  content: \"\\F7AA\";\n}\n\n.mdi-car-sports:before {\n  content: \"\\F7AB\";\n}\n\n.mdi-car-wash:before {\n  content: \"\\F10E\";\n}\n\n.mdi-caravan:before {\n  content: \"\\F7AC\";\n}\n\n.mdi-cards:before {\n  content: \"\\F638\";\n}\n\n.mdi-cards-club:before {\n  content: \"\\F8CD\";\n}\n\n.mdi-cards-diamond:before {\n  content: \"\\F8CE\";\n}\n\n.mdi-cards-heart:before {\n  content: \"\\F8CF\";\n}\n\n.mdi-cards-outline:before {\n  content: \"\\F639\";\n}\n\n.mdi-cards-playing-outline:before {\n  content: \"\\F63A\";\n}\n\n.mdi-cards-spade:before {\n  content: \"\\F8D0\";\n}\n\n.mdi-cards-variant:before {\n  content: \"\\F6C6\";\n}\n\n.mdi-carrot:before {\n  content: \"\\F10F\";\n}\n\n.mdi-cart:before {\n  content: \"\\F110\";\n}\n\n.mdi-cart-off:before {\n  content: \"\\F66B\";\n}\n\n.mdi-cart-outline:before {\n  content: \"\\F111\";\n}\n\n.mdi-cart-plus:before {\n  content: \"\\F112\";\n}\n\n.mdi-case-sensitive-alt:before {\n  content: \"\\F113\";\n}\n\n.mdi-cash:before {\n  content: \"\\F114\";\n}\n\n.mdi-cash-100:before {\n  content: \"\\F115\";\n}\n\n.mdi-cash-multiple:before {\n  content: \"\\F116\";\n}\n\n.mdi-cash-usd:before {\n  content: \"\\F117\";\n}\n\n.mdi-cast:before {\n  content: \"\\F118\";\n}\n\n.mdi-cast-connected:before {\n  content: \"\\F119\";\n}\n\n.mdi-cast-off:before {\n  content: \"\\F789\";\n}\n\n.mdi-castle:before {\n  content: \"\\F11A\";\n}\n\n.mdi-cat:before {\n  content: \"\\F11B\";\n}\n\n.mdi-cctv:before {\n  content: \"\\F7AD\";\n}\n\n.mdi-ceiling-light:before {\n  content: \"\\F768\";\n}\n\n.mdi-cellphone:before {\n  content: \"\\F11C\";\n}\n\n.mdi-cellphone-android:before {\n  content: \"\\F11D\";\n}\n\n.mdi-cellphone-basic:before {\n  content: \"\\F11E\";\n}\n\n.mdi-cellphone-dock:before {\n  content: \"\\F11F\";\n}\n\n.mdi-cellphone-erase:before {\n  content: \"\\F94C\";\n}\n\n.mdi-cellphone-iphone:before {\n  content: \"\\F120\";\n}\n\n.mdi-cellphone-key:before {\n  content: \"\\F94D\";\n}\n\n.mdi-cellphone-link:before {\n  content: \"\\F121\";\n}\n\n.mdi-cellphone-link-off:before {\n  content: \"\\F122\";\n}\n\n.mdi-cellphone-lock:before {\n  content: \"\\F94E\";\n}\n\n.mdi-cellphone-message:before {\n  content: \"\\F8D2\";\n}\n\n.mdi-cellphone-off:before {\n  content: \"\\F94F\";\n}\n\n.mdi-cellphone-settings:before {\n  content: \"\\F123\";\n}\n\n.mdi-cellphone-settings-variant:before {\n  content: \"\\F950\";\n}\n\n.mdi-cellphone-sound:before {\n  content: \"\\F951\";\n}\n\n.mdi-cellphone-text:before {\n  content: \"\\F8D1\";\n}\n\n.mdi-cellphone-wireless:before {\n  content: \"\\F814\";\n}\n\n.mdi-certificate:before {\n  content: \"\\F124\";\n}\n\n.mdi-chair-school:before {\n  content: \"\\F125\";\n}\n\n.mdi-chart-arc:before {\n  content: \"\\F126\";\n}\n\n.mdi-chart-areaspline:before {\n  content: \"\\F127\";\n}\n\n.mdi-chart-bar:before {\n  content: \"\\F128\";\n}\n\n.mdi-chart-bar-stacked:before {\n  content: \"\\F769\";\n}\n\n.mdi-chart-bubble:before {\n  content: \"\\F5E3\";\n}\n\n.mdi-chart-donut:before {\n  content: \"\\F7AE\";\n}\n\n.mdi-chart-donut-variant:before {\n  content: \"\\F7AF\";\n}\n\n.mdi-chart-gantt:before {\n  content: \"\\F66C\";\n}\n\n.mdi-chart-histogram:before {\n  content: \"\\F129\";\n}\n\n.mdi-chart-line:before {\n  content: \"\\F12A\";\n}\n\n.mdi-chart-line-stacked:before {\n  content: \"\\F76A\";\n}\n\n.mdi-chart-line-variant:before {\n  content: \"\\F7B0\";\n}\n\n.mdi-chart-multiline:before {\n  content: \"\\F8D3\";\n}\n\n.mdi-chart-pie:before {\n  content: \"\\F12B\";\n}\n\n.mdi-chart-scatterplot-hexbin:before {\n  content: \"\\F66D\";\n}\n\n.mdi-chart-timeline:before {\n  content: \"\\F66E\";\n}\n\n.mdi-check:before {\n  content: \"\\F12C\";\n}\n\n.mdi-check-all:before {\n  content: \"\\F12D\";\n}\n\n.mdi-check-circle:before {\n  content: \"\\F5E0\";\n}\n\n.mdi-check-circle-outline:before {\n  content: \"\\F5E1\";\n}\n\n.mdi-check-outline:before {\n  content: \"\\F854\";\n}\n\n.mdi-checkbox-blank:before {\n  content: \"\\F12E\";\n}\n\n.mdi-checkbox-blank-circle:before {\n  content: \"\\F12F\";\n}\n\n.mdi-checkbox-blank-circle-outline:before {\n  content: \"\\F130\";\n}\n\n.mdi-checkbox-blank-outline:before {\n  content: \"\\F131\";\n}\n\n.mdi-checkbox-intermediate:before {\n  content: \"\\F855\";\n}\n\n.mdi-checkbox-marked:before {\n  content: \"\\F132\";\n}\n\n.mdi-checkbox-marked-circle:before {\n  content: \"\\F133\";\n}\n\n.mdi-checkbox-marked-circle-outline:before {\n  content: \"\\F134\";\n}\n\n.mdi-checkbox-marked-outline:before {\n  content: \"\\F135\";\n}\n\n.mdi-checkbox-multiple-blank:before {\n  content: \"\\F136\";\n}\n\n.mdi-checkbox-multiple-blank-circle:before {\n  content: \"\\F63B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline:before {\n  content: \"\\F63C\";\n}\n\n.mdi-checkbox-multiple-blank-outline:before {\n  content: \"\\F137\";\n}\n\n.mdi-checkbox-multiple-marked:before {\n  content: \"\\F138\";\n}\n\n.mdi-checkbox-multiple-marked-circle:before {\n  content: \"\\F63D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline:before {\n  content: \"\\F63E\";\n}\n\n.mdi-checkbox-multiple-marked-outline:before {\n  content: \"\\F139\";\n}\n\n.mdi-checkerboard:before {\n  content: \"\\F13A\";\n}\n\n.mdi-chemical-weapon:before {\n  content: \"\\F13B\";\n}\n\n.mdi-chess-bishop:before {\n  content: \"\\F85B\";\n}\n\n.mdi-chess-king:before {\n  content: \"\\F856\";\n}\n\n.mdi-chess-knight:before {\n  content: \"\\F857\";\n}\n\n.mdi-chess-pawn:before {\n  content: \"\\F858\";\n}\n\n.mdi-chess-queen:before {\n  content: \"\\F859\";\n}\n\n.mdi-chess-rook:before {\n  content: \"\\F85A\";\n}\n\n.mdi-chevron-double-down:before {\n  content: \"\\F13C\";\n}\n\n.mdi-chevron-double-left:before {\n  content: \"\\F13D\";\n}\n\n.mdi-chevron-double-right:before {\n  content: \"\\F13E\";\n}\n\n.mdi-chevron-double-up:before {\n  content: \"\\F13F\";\n}\n\n.mdi-chevron-down:before {\n  content: \"\\F140\";\n}\n\n.mdi-chevron-left:before {\n  content: \"\\F141\";\n}\n\n.mdi-chevron-right:before {\n  content: \"\\F142\";\n}\n\n.mdi-chevron-up:before {\n  content: \"\\F143\";\n}\n\n.mdi-chili-hot:before {\n  content: \"\\F7B1\";\n}\n\n.mdi-chili-medium:before {\n  content: \"\\F7B2\";\n}\n\n.mdi-chili-mild:before {\n  content: \"\\F7B3\";\n}\n\n.mdi-chip:before {\n  content: \"\\F61A\";\n}\n\n.mdi-christiantiy:before {\n  content: \"\\F952\";\n}\n\n.mdi-church:before {\n  content: \"\\F144\";\n}\n\n.mdi-circle:before {\n  content: \"\\F764\";\n}\n\n.mdi-circle-edit-outline:before {\n  content: \"\\F8D4\";\n}\n\n.mdi-circle-outline:before {\n  content: \"\\F765\";\n}\n\n.mdi-cisco-webex:before {\n  content: \"\\F145\";\n}\n\n.mdi-city:before {\n  content: \"\\F146\";\n}\n\n.mdi-clipboard:before {\n  content: \"\\F147\";\n}\n\n.mdi-clipboard-account:before {\n  content: \"\\F148\";\n}\n\n.mdi-clipboard-alert:before {\n  content: \"\\F149\";\n}\n\n.mdi-clipboard-arrow-down:before {\n  content: \"\\F14A\";\n}\n\n.mdi-clipboard-arrow-left:before {\n  content: \"\\F14B\";\n}\n\n.mdi-clipboard-check:before {\n  content: \"\\F14C\";\n}\n\n.mdi-clipboard-check-outline:before {\n  content: \"\\F8A7\";\n}\n\n.mdi-clipboard-flow:before {\n  content: \"\\F6C7\";\n}\n\n.mdi-clipboard-outline:before {\n  content: \"\\F14D\";\n}\n\n.mdi-clipboard-plus:before {\n  content: \"\\F750\";\n}\n\n.mdi-clipboard-pulse:before {\n  content: \"\\F85C\";\n}\n\n.mdi-clipboard-pulse-outline:before {\n  content: \"\\F85D\";\n}\n\n.mdi-clipboard-text:before {\n  content: \"\\F14E\";\n}\n\n.mdi-clippy:before {\n  content: \"\\F14F\";\n}\n\n.mdi-clock:before {\n  content: \"\\F953\";\n}\n\n.mdi-clock-alert:before {\n  content: \"\\F954\";\n}\n\n.mdi-clock-alert-outline:before {\n  content: \"\\F5CE\";\n}\n\n.mdi-clock-end:before {\n  content: \"\\F151\";\n}\n\n.mdi-clock-fast:before {\n  content: \"\\F152\";\n}\n\n.mdi-clock-in:before {\n  content: \"\\F153\";\n}\n\n.mdi-clock-out:before {\n  content: \"\\F154\";\n}\n\n.mdi-clock-outline:before {\n  content: \"\\F150\";\n}\n\n.mdi-clock-start:before {\n  content: \"\\F155\";\n}\n\n.mdi-close:before {\n  content: \"\\F156\";\n}\n\n.mdi-close-box:before {\n  content: \"\\F157\";\n}\n\n.mdi-close-box-outline:before {\n  content: \"\\F158\";\n}\n\n.mdi-close-circle:before {\n  content: \"\\F159\";\n}\n\n.mdi-close-circle-outline:before {\n  content: \"\\F15A\";\n}\n\n.mdi-close-network:before {\n  content: \"\\F15B\";\n}\n\n.mdi-close-octagon:before {\n  content: \"\\F15C\";\n}\n\n.mdi-close-octagon-outline:before {\n  content: \"\\F15D\";\n}\n\n.mdi-close-outline:before {\n  content: \"\\F6C8\";\n}\n\n.mdi-closed-caption:before {\n  content: \"\\F15E\";\n}\n\n.mdi-cloud:before {\n  content: \"\\F15F\";\n}\n\n.mdi-cloud-braces:before {\n  content: \"\\F7B4\";\n}\n\n.mdi-cloud-check:before {\n  content: \"\\F160\";\n}\n\n.mdi-cloud-circle:before {\n  content: \"\\F161\";\n}\n\n.mdi-cloud-download:before {\n  content: \"\\F162\";\n}\n\n.mdi-cloud-off-outline:before {\n  content: \"\\F164\";\n}\n\n.mdi-cloud-outline:before {\n  content: \"\\F163\";\n}\n\n.mdi-cloud-print:before {\n  content: \"\\F165\";\n}\n\n.mdi-cloud-print-outline:before {\n  content: \"\\F166\";\n}\n\n.mdi-cloud-search:before {\n  content: \"\\F955\";\n}\n\n.mdi-cloud-search-outline:before {\n  content: \"\\F956\";\n}\n\n.mdi-cloud-sync:before {\n  content: \"\\F63F\";\n}\n\n.mdi-cloud-tags:before {\n  content: \"\\F7B5\";\n}\n\n.mdi-cloud-upload:before {\n  content: \"\\F167\";\n}\n\n.mdi-clover:before {\n  content: \"\\F815\";\n}\n\n.mdi-code-array:before {\n  content: \"\\F168\";\n}\n\n.mdi-code-braces:before {\n  content: \"\\F169\";\n}\n\n.mdi-code-brackets:before {\n  content: \"\\F16A\";\n}\n\n.mdi-code-equal:before {\n  content: \"\\F16B\";\n}\n\n.mdi-code-greater-than:before {\n  content: \"\\F16C\";\n}\n\n.mdi-code-greater-than-or-equal:before {\n  content: \"\\F16D\";\n}\n\n.mdi-code-less-than:before {\n  content: \"\\F16E\";\n}\n\n.mdi-code-less-than-or-equal:before {\n  content: \"\\F16F\";\n}\n\n.mdi-code-not-equal:before {\n  content: \"\\F170\";\n}\n\n.mdi-code-not-equal-variant:before {\n  content: \"\\F171\";\n}\n\n.mdi-code-parentheses:before {\n  content: \"\\F172\";\n}\n\n.mdi-code-string:before {\n  content: \"\\F173\";\n}\n\n.mdi-code-tags:before {\n  content: \"\\F174\";\n}\n\n.mdi-code-tags-check:before {\n  content: \"\\F693\";\n}\n\n.mdi-codepen:before {\n  content: \"\\F175\";\n}\n\n.mdi-coffee:before {\n  content: \"\\F176\";\n}\n\n.mdi-coffee-outline:before {\n  content: \"\\F6C9\";\n}\n\n.mdi-coffee-to-go:before {\n  content: \"\\F177\";\n}\n\n.mdi-cogs:before {\n  content: \"\\F8D5\";\n}\n\n.mdi-coin:before {\n  content: \"\\F178\";\n}\n\n.mdi-coins:before {\n  content: \"\\F694\";\n}\n\n.mdi-collage:before {\n  content: \"\\F640\";\n}\n\n.mdi-color-helper:before {\n  content: \"\\F179\";\n}\n\n.mdi-comment:before {\n  content: \"\\F17A\";\n}\n\n.mdi-comment-account:before {\n  content: \"\\F17B\";\n}\n\n.mdi-comment-account-outline:before {\n  content: \"\\F17C\";\n}\n\n.mdi-comment-alert:before {\n  content: \"\\F17D\";\n}\n\n.mdi-comment-alert-outline:before {\n  content: \"\\F17E\";\n}\n\n.mdi-comment-check:before {\n  content: \"\\F17F\";\n}\n\n.mdi-comment-check-outline:before {\n  content: \"\\F180\";\n}\n\n.mdi-comment-multiple:before {\n  content: \"\\F85E\";\n}\n\n.mdi-comment-multiple-outline:before {\n  content: \"\\F181\";\n}\n\n.mdi-comment-outline:before {\n  content: \"\\F182\";\n}\n\n.mdi-comment-plus-outline:before {\n  content: \"\\F183\";\n}\n\n.mdi-comment-processing:before {\n  content: \"\\F184\";\n}\n\n.mdi-comment-processing-outline:before {\n  content: \"\\F185\";\n}\n\n.mdi-comment-question:before {\n  content: \"\\F816\";\n}\n\n.mdi-comment-question-outline:before {\n  content: \"\\F186\";\n}\n\n.mdi-comment-remove:before {\n  content: \"\\F5DE\";\n}\n\n.mdi-comment-remove-outline:before {\n  content: \"\\F187\";\n}\n\n.mdi-comment-text:before {\n  content: \"\\F188\";\n}\n\n.mdi-comment-text-multiple:before {\n  content: \"\\F85F\";\n}\n\n.mdi-comment-text-multiple-outline:before {\n  content: \"\\F860\";\n}\n\n.mdi-comment-text-outline:before {\n  content: \"\\F189\";\n}\n\n.mdi-compare:before {\n  content: \"\\F18A\";\n}\n\n.mdi-compass:before {\n  content: \"\\F18B\";\n}\n\n.mdi-compass-outline:before {\n  content: \"\\F18C\";\n}\n\n.mdi-console:before {\n  content: \"\\F18D\";\n}\n\n.mdi-console-line:before {\n  content: \"\\F7B6\";\n}\n\n.mdi-console-network:before {\n  content: \"\\F8A8\";\n}\n\n.mdi-contact-mail:before {\n  content: \"\\F18E\";\n}\n\n.mdi-contacts:before {\n  content: \"\\F6CA\";\n}\n\n.mdi-content-copy:before {\n  content: \"\\F18F\";\n}\n\n.mdi-content-cut:before {\n  content: \"\\F190\";\n}\n\n.mdi-content-duplicate:before {\n  content: \"\\F191\";\n}\n\n.mdi-content-paste:before {\n  content: \"\\F192\";\n}\n\n.mdi-content-save:before {\n  content: \"\\F193\";\n}\n\n.mdi-content-save-all:before {\n  content: \"\\F194\";\n}\n\n.mdi-content-save-outline:before {\n  content: \"\\F817\";\n}\n\n.mdi-content-save-settings:before {\n  content: \"\\F61B\";\n}\n\n.mdi-contrast:before {\n  content: \"\\F195\";\n}\n\n.mdi-contrast-box:before {\n  content: \"\\F196\";\n}\n\n.mdi-contrast-circle:before {\n  content: \"\\F197\";\n}\n\n.mdi-cookie:before {\n  content: \"\\F198\";\n}\n\n.mdi-copyright:before {\n  content: \"\\F5E6\";\n}\n\n.mdi-cordova:before {\n  content: \"\\F957\";\n}\n\n.mdi-corn:before {\n  content: \"\\F7B7\";\n}\n\n.mdi-counter:before {\n  content: \"\\F199\";\n}\n\n.mdi-cow:before {\n  content: \"\\F19A\";\n}\n\n.mdi-crane:before {\n  content: \"\\F861\";\n}\n\n.mdi-creation:before {\n  content: \"\\F1C9\";\n}\n\n.mdi-credit-card:before {\n  content: \"\\F19B\";\n}\n\n.mdi-credit-card-multiple:before {\n  content: \"\\F19C\";\n}\n\n.mdi-credit-card-off:before {\n  content: \"\\F5E4\";\n}\n\n.mdi-credit-card-plus:before {\n  content: \"\\F675\";\n}\n\n.mdi-credit-card-scan:before {\n  content: \"\\F19D\";\n}\n\n.mdi-credit-card-settings:before {\n  content: \"\\F8D6\";\n}\n\n.mdi-crop:before {\n  content: \"\\F19E\";\n}\n\n.mdi-crop-free:before {\n  content: \"\\F19F\";\n}\n\n.mdi-crop-landscape:before {\n  content: \"\\F1A0\";\n}\n\n.mdi-crop-portrait:before {\n  content: \"\\F1A1\";\n}\n\n.mdi-crop-rotate:before {\n  content: \"\\F695\";\n}\n\n.mdi-crop-square:before {\n  content: \"\\F1A2\";\n}\n\n.mdi-crosshairs:before {\n  content: \"\\F1A3\";\n}\n\n.mdi-crosshairs-gps:before {\n  content: \"\\F1A4\";\n}\n\n.mdi-crown:before {\n  content: \"\\F1A5\";\n}\n\n.mdi-cryengine:before {\n  content: \"\\F958\";\n}\n\n.mdi-cube:before {\n  content: \"\\F1A6\";\n}\n\n.mdi-cube-outline:before {\n  content: \"\\F1A7\";\n}\n\n.mdi-cube-send:before {\n  content: \"\\F1A8\";\n}\n\n.mdi-cube-unfolded:before {\n  content: \"\\F1A9\";\n}\n\n.mdi-cup:before {\n  content: \"\\F1AA\";\n}\n\n.mdi-cup-off:before {\n  content: \"\\F5E5\";\n}\n\n.mdi-cup-water:before {\n  content: \"\\F1AB\";\n}\n\n.mdi-cupcake:before {\n  content: \"\\F959\";\n}\n\n.mdi-curling:before {\n  content: \"\\F862\";\n}\n\n.mdi-currency-bdt:before {\n  content: \"\\F863\";\n}\n\n.mdi-currency-btc:before {\n  content: \"\\F1AC\";\n}\n\n.mdi-currency-chf:before {\n  content: \"\\F7B8\";\n}\n\n.mdi-currency-cny:before {\n  content: \"\\F7B9\";\n}\n\n.mdi-currency-eth:before {\n  content: \"\\F7BA\";\n}\n\n.mdi-currency-eur:before {\n  content: \"\\F1AD\";\n}\n\n.mdi-currency-gbp:before {\n  content: \"\\F1AE\";\n}\n\n.mdi-currency-inr:before {\n  content: \"\\F1AF\";\n}\n\n.mdi-currency-jpy:before {\n  content: \"\\F7BB\";\n}\n\n.mdi-currency-krw:before {\n  content: \"\\F7BC\";\n}\n\n.mdi-currency-kzt:before {\n  content: \"\\F864\";\n}\n\n.mdi-currency-ngn:before {\n  content: \"\\F1B0\";\n}\n\n.mdi-currency-rub:before {\n  content: \"\\F1B1\";\n}\n\n.mdi-currency-sign:before {\n  content: \"\\F7BD\";\n}\n\n.mdi-currency-try:before {\n  content: \"\\F1B2\";\n}\n\n.mdi-currency-twd:before {\n  content: \"\\F7BE\";\n}\n\n.mdi-currency-usd:before {\n  content: \"\\F1B3\";\n}\n\n.mdi-currency-usd-off:before {\n  content: \"\\F679\";\n}\n\n.mdi-current-ac:before {\n  content: \"\\F95A\";\n}\n\n.mdi-current-dc:before {\n  content: \"\\F95B\";\n}\n\n.mdi-cursor-default:before {\n  content: \"\\F1B4\";\n}\n\n.mdi-cursor-default-outline:before {\n  content: \"\\F1B5\";\n}\n\n.mdi-cursor-move:before {\n  content: \"\\F1B6\";\n}\n\n.mdi-cursor-pointer:before {\n  content: \"\\F1B7\";\n}\n\n.mdi-cursor-text:before {\n  content: \"\\F5E7\";\n}\n\n.mdi-database:before {\n  content: \"\\F1B8\";\n}\n\n.mdi-database-export:before {\n  content: \"\\F95D\";\n}\n\n.mdi-database-import:before {\n  content: \"\\F95C\";\n}\n\n.mdi-database-minus:before {\n  content: \"\\F1B9\";\n}\n\n.mdi-database-plus:before {\n  content: \"\\F1BA\";\n}\n\n.mdi-database-search:before {\n  content: \"\\F865\";\n}\n\n.mdi-death-star:before {\n  content: \"\\F8D7\";\n}\n\n.mdi-death-star-variant:before {\n  content: \"\\F8D8\";\n}\n\n.mdi-debian:before {\n  content: \"\\F8D9\";\n}\n\n.mdi-debug-step-into:before {\n  content: \"\\F1BB\";\n}\n\n.mdi-debug-step-out:before {\n  content: \"\\F1BC\";\n}\n\n.mdi-debug-step-over:before {\n  content: \"\\F1BD\";\n}\n\n.mdi-decagram:before {\n  content: \"\\F76B\";\n}\n\n.mdi-decagram-outline:before {\n  content: \"\\F76C\";\n}\n\n.mdi-decimal-decrease:before {\n  content: \"\\F1BE\";\n}\n\n.mdi-decimal-increase:before {\n  content: \"\\F1BF\";\n}\n\n.mdi-delete:before {\n  content: \"\\F1C0\";\n}\n\n.mdi-delete-circle:before {\n  content: \"\\F682\";\n}\n\n.mdi-delete-empty:before {\n  content: \"\\F6CB\";\n}\n\n.mdi-delete-forever:before {\n  content: \"\\F5E8\";\n}\n\n.mdi-delete-restore:before {\n  content: \"\\F818\";\n}\n\n.mdi-delete-sweep:before {\n  content: \"\\F5E9\";\n}\n\n.mdi-delete-variant:before {\n  content: \"\\F1C1\";\n}\n\n.mdi-delta:before {\n  content: \"\\F1C2\";\n}\n\n.mdi-desk-lamp:before {\n  content: \"\\F95E\";\n}\n\n.mdi-deskphone:before {\n  content: \"\\F1C3\";\n}\n\n.mdi-desktop-classic:before {\n  content: \"\\F7BF\";\n}\n\n.mdi-desktop-mac:before {\n  content: \"\\F1C4\";\n}\n\n.mdi-desktop-tower:before {\n  content: \"\\F1C5\";\n}\n\n.mdi-details:before {\n  content: \"\\F1C6\";\n}\n\n.mdi-developer-board:before {\n  content: \"\\F696\";\n}\n\n.mdi-deviantart:before {\n  content: \"\\F1C7\";\n}\n\n.mdi-dialpad:before {\n  content: \"\\F61C\";\n}\n\n.mdi-diamond:before {\n  content: \"\\F1C8\";\n}\n\n.mdi-dice-1:before {\n  content: \"\\F1CA\";\n}\n\n.mdi-dice-2:before {\n  content: \"\\F1CB\";\n}\n\n.mdi-dice-3:before {\n  content: \"\\F1CC\";\n}\n\n.mdi-dice-4:before {\n  content: \"\\F1CD\";\n}\n\n.mdi-dice-5:before {\n  content: \"\\F1CE\";\n}\n\n.mdi-dice-6:before {\n  content: \"\\F1CF\";\n}\n\n.mdi-dice-d10:before {\n  content: \"\\F76E\";\n}\n\n.mdi-dice-d12:before {\n  content: \"\\F866\";\n}\n\n.mdi-dice-d20:before {\n  content: \"\\F5EA\";\n}\n\n.mdi-dice-d4:before {\n  content: \"\\F5EB\";\n}\n\n.mdi-dice-d6:before {\n  content: \"\\F5EC\";\n}\n\n.mdi-dice-d8:before {\n  content: \"\\F5ED\";\n}\n\n.mdi-dice-multiple:before {\n  content: \"\\F76D\";\n}\n\n.mdi-dictionary:before {\n  content: \"\\F61D\";\n}\n\n.mdi-dip-switch:before {\n  content: \"\\F7C0\";\n}\n\n.mdi-directions:before {\n  content: \"\\F1D0\";\n}\n\n.mdi-directions-fork:before {\n  content: \"\\F641\";\n}\n\n.mdi-discord:before {\n  content: \"\\F66F\";\n}\n\n.mdi-disk:before {\n  content: \"\\F5EE\";\n}\n\n.mdi-disk-alert:before {\n  content: \"\\F1D1\";\n}\n\n.mdi-disk-player:before {\n  content: \"\\F95F\";\n}\n\n.mdi-disqus:before {\n  content: \"\\F1D2\";\n}\n\n.mdi-disqus-outline:before {\n  content: \"\\F1D3\";\n}\n\n.mdi-division:before {\n  content: \"\\F1D4\";\n}\n\n.mdi-division-box:before {\n  content: \"\\F1D5\";\n}\n\n.mdi-dna:before {\n  content: \"\\F683\";\n}\n\n.mdi-dns:before {\n  content: \"\\F1D6\";\n}\n\n.mdi-do-not-disturb:before {\n  content: \"\\F697\";\n}\n\n.mdi-do-not-disturb-off:before {\n  content: \"\\F698\";\n}\n\n.mdi-docker:before {\n  content: \"\\F867\";\n}\n\n.mdi-dolby:before {\n  content: \"\\F6B2\";\n}\n\n.mdi-domain:before {\n  content: \"\\F1D7\";\n}\n\n.mdi-donkey:before {\n  content: \"\\F7C1\";\n}\n\n.mdi-door:before {\n  content: \"\\F819\";\n}\n\n.mdi-door-closed:before {\n  content: \"\\F81A\";\n}\n\n.mdi-door-open:before {\n  content: \"\\F81B\";\n}\n\n.mdi-doorbell-video:before {\n  content: \"\\F868\";\n}\n\n.mdi-dots-horizontal:before {\n  content: \"\\F1D8\";\n}\n\n.mdi-dots-horizontal-circle:before {\n  content: \"\\F7C2\";\n}\n\n.mdi-dots-vertical:before {\n  content: \"\\F1D9\";\n}\n\n.mdi-dots-vertical-circle:before {\n  content: \"\\F7C3\";\n}\n\n.mdi-douban:before {\n  content: \"\\F699\";\n}\n\n.mdi-download:before {\n  content: \"\\F1DA\";\n}\n\n.mdi-download-network:before {\n  content: \"\\F6F3\";\n}\n\n.mdi-drag:before {\n  content: \"\\F1DB\";\n}\n\n.mdi-drag-horizontal:before {\n  content: \"\\F1DC\";\n}\n\n.mdi-drag-vertical:before {\n  content: \"\\F1DD\";\n}\n\n.mdi-drawing:before {\n  content: \"\\F1DE\";\n}\n\n.mdi-drawing-box:before {\n  content: \"\\F1DF\";\n}\n\n.mdi-dribbble:before {\n  content: \"\\F1E0\";\n}\n\n.mdi-dribbble-box:before {\n  content: \"\\F1E1\";\n}\n\n.mdi-drone:before {\n  content: \"\\F1E2\";\n}\n\n.mdi-dropbox:before {\n  content: \"\\F1E3\";\n}\n\n.mdi-drupal:before {\n  content: \"\\F1E4\";\n}\n\n.mdi-duck:before {\n  content: \"\\F1E5\";\n}\n\n.mdi-dumbbell:before {\n  content: \"\\F1E6\";\n}\n\n.mdi-ear-hearing:before {\n  content: \"\\F7C4\";\n}\n\n.mdi-earth:before {\n  content: \"\\F1E7\";\n}\n\n.mdi-earth-box:before {\n  content: \"\\F6CC\";\n}\n\n.mdi-earth-box-off:before {\n  content: \"\\F6CD\";\n}\n\n.mdi-earth-off:before {\n  content: \"\\F1E8\";\n}\n\n.mdi-edge:before {\n  content: \"\\F1E9\";\n}\n\n.mdi-eject:before {\n  content: \"\\F1EA\";\n}\n\n.mdi-elephant:before {\n  content: \"\\F7C5\";\n}\n\n.mdi-elevation-decline:before {\n  content: \"\\F1EB\";\n}\n\n.mdi-elevation-rise:before {\n  content: \"\\F1EC\";\n}\n\n.mdi-elevator:before {\n  content: \"\\F1ED\";\n}\n\n.mdi-email:before {\n  content: \"\\F1EE\";\n}\n\n.mdi-email-alert:before {\n  content: \"\\F6CE\";\n}\n\n.mdi-email-open:before {\n  content: \"\\F1EF\";\n}\n\n.mdi-email-open-outline:before {\n  content: \"\\F5EF\";\n}\n\n.mdi-email-outline:before {\n  content: \"\\F1F0\";\n}\n\n.mdi-email-search:before {\n  content: \"\\F960\";\n}\n\n.mdi-email-search-outline:before {\n  content: \"\\F961\";\n}\n\n.mdi-email-secure:before {\n  content: \"\\F1F1\";\n}\n\n.mdi-email-variant:before {\n  content: \"\\F5F0\";\n}\n\n.mdi-emby:before {\n  content: \"\\F6B3\";\n}\n\n.mdi-emoticon:before {\n  content: \"\\F1F2\";\n}\n\n.mdi-emoticon-cool:before {\n  content: \"\\F1F3\";\n}\n\n.mdi-emoticon-dead:before {\n  content: \"\\F69A\";\n}\n\n.mdi-emoticon-devil:before {\n  content: \"\\F1F4\";\n}\n\n.mdi-emoticon-excited:before {\n  content: \"\\F69B\";\n}\n\n.mdi-emoticon-happy:before {\n  content: \"\\F1F5\";\n}\n\n.mdi-emoticon-neutral:before {\n  content: \"\\F1F6\";\n}\n\n.mdi-emoticon-poop:before {\n  content: \"\\F1F7\";\n}\n\n.mdi-emoticon-sad:before {\n  content: \"\\F1F8\";\n}\n\n.mdi-emoticon-tongue:before {\n  content: \"\\F1F9\";\n}\n\n.mdi-engine:before {\n  content: \"\\F1FA\";\n}\n\n.mdi-engine-outline:before {\n  content: \"\\F1FB\";\n}\n\n.mdi-equal:before {\n  content: \"\\F1FC\";\n}\n\n.mdi-equal-box:before {\n  content: \"\\F1FD\";\n}\n\n.mdi-eraser:before {\n  content: \"\\F1FE\";\n}\n\n.mdi-eraser-variant:before {\n  content: \"\\F642\";\n}\n\n.mdi-escalator:before {\n  content: \"\\F1FF\";\n}\n\n.mdi-ethereum:before {\n  content: \"\\F869\";\n}\n\n.mdi-ethernet:before {\n  content: \"\\F200\";\n}\n\n.mdi-ethernet-cable:before {\n  content: \"\\F201\";\n}\n\n.mdi-ethernet-cable-off:before {\n  content: \"\\F202\";\n}\n\n.mdi-etsy:before {\n  content: \"\\F203\";\n}\n\n.mdi-ev-station:before {\n  content: \"\\F5F1\";\n}\n\n.mdi-eventbrite:before {\n  content: \"\\F7C6\";\n}\n\n.mdi-evernote:before {\n  content: \"\\F204\";\n}\n\n.mdi-exclamation:before {\n  content: \"\\F205\";\n}\n\n.mdi-exit-to-app:before {\n  content: \"\\F206\";\n}\n\n.mdi-exponent:before {\n  content: \"\\F962\";\n}\n\n.mdi-exponent-box:before {\n  content: \"\\F963\";\n}\n\n.mdi-export:before {\n  content: \"\\F207\";\n}\n\n.mdi-eye:before {\n  content: \"\\F208\";\n}\n\n.mdi-eye-off:before {\n  content: \"\\F209\";\n}\n\n.mdi-eye-off-outline:before {\n  content: \"\\F6D0\";\n}\n\n.mdi-eye-outline:before {\n  content: \"\\F6CF\";\n}\n\n.mdi-eye-plus:before {\n  content: \"\\F86A\";\n}\n\n.mdi-eye-plus-outline:before {\n  content: \"\\F86B\";\n}\n\n.mdi-eye-settings:before {\n  content: \"\\F86C\";\n}\n\n.mdi-eye-settings-outline:before {\n  content: \"\\F86D\";\n}\n\n.mdi-eyedropper:before {\n  content: \"\\F20A\";\n}\n\n.mdi-eyedropper-variant:before {\n  content: \"\\F20B\";\n}\n\n.mdi-face:before {\n  content: \"\\F643\";\n}\n\n.mdi-face-profile:before {\n  content: \"\\F644\";\n}\n\n.mdi-facebook:before {\n  content: \"\\F20C\";\n}\n\n.mdi-facebook-box:before {\n  content: \"\\F20D\";\n}\n\n.mdi-facebook-messenger:before {\n  content: \"\\F20E\";\n}\n\n.mdi-factory:before {\n  content: \"\\F20F\";\n}\n\n.mdi-fan:before {\n  content: \"\\F210\";\n}\n\n.mdi-fan-off:before {\n  content: \"\\F81C\";\n}\n\n.mdi-fast-forward:before {\n  content: \"\\F211\";\n}\n\n.mdi-fast-forward-outline:before {\n  content: \"\\F6D1\";\n}\n\n.mdi-fax:before {\n  content: \"\\F212\";\n}\n\n.mdi-feather:before {\n  content: \"\\F6D2\";\n}\n\n.mdi-fedora:before {\n  content: \"\\F8DA\";\n}\n\n.mdi-ferry:before {\n  content: \"\\F213\";\n}\n\n.mdi-file:before {\n  content: \"\\F214\";\n}\n\n.mdi-file-account:before {\n  content: \"\\F73A\";\n}\n\n.mdi-file-chart:before {\n  content: \"\\F215\";\n}\n\n.mdi-file-check:before {\n  content: \"\\F216\";\n}\n\n.mdi-file-cloud:before {\n  content: \"\\F217\";\n}\n\n.mdi-file-compare:before {\n  content: \"\\F8A9\";\n}\n\n.mdi-file-delimited:before {\n  content: \"\\F218\";\n}\n\n.mdi-file-document:before {\n  content: \"\\F219\";\n}\n\n.mdi-file-document-box:before {\n  content: \"\\F21A\";\n}\n\n.mdi-file-download:before {\n  content: \"\\F964\";\n}\n\n.mdi-file-download-outline:before {\n  content: \"\\F965\";\n}\n\n.mdi-file-excel:before {\n  content: \"\\F21B\";\n}\n\n.mdi-file-excel-box:before {\n  content: \"\\F21C\";\n}\n\n.mdi-file-export:before {\n  content: \"\\F21D\";\n}\n\n.mdi-file-find:before {\n  content: \"\\F21E\";\n}\n\n.mdi-file-hidden:before {\n  content: \"\\F613\";\n}\n\n.mdi-file-image:before {\n  content: \"\\F21F\";\n}\n\n.mdi-file-import:before {\n  content: \"\\F220\";\n}\n\n.mdi-file-lock:before {\n  content: \"\\F221\";\n}\n\n.mdi-file-multiple:before {\n  content: \"\\F222\";\n}\n\n.mdi-file-music:before {\n  content: \"\\F223\";\n}\n\n.mdi-file-outline:before {\n  content: \"\\F224\";\n}\n\n.mdi-file-pdf:before {\n  content: \"\\F225\";\n}\n\n.mdi-file-pdf-box:before {\n  content: \"\\F226\";\n}\n\n.mdi-file-percent:before {\n  content: \"\\F81D\";\n}\n\n.mdi-file-plus:before {\n  content: \"\\F751\";\n}\n\n.mdi-file-powerpoint:before {\n  content: \"\\F227\";\n}\n\n.mdi-file-powerpoint-box:before {\n  content: \"\\F228\";\n}\n\n.mdi-file-presentation-box:before {\n  content: \"\\F229\";\n}\n\n.mdi-file-question:before {\n  content: \"\\F86E\";\n}\n\n.mdi-file-restore:before {\n  content: \"\\F670\";\n}\n\n.mdi-file-send:before {\n  content: \"\\F22A\";\n}\n\n.mdi-file-tree:before {\n  content: \"\\F645\";\n}\n\n.mdi-file-undo:before {\n  content: \"\\F8DB\";\n}\n\n.mdi-file-video:before {\n  content: \"\\F22B\";\n}\n\n.mdi-file-word:before {\n  content: \"\\F22C\";\n}\n\n.mdi-file-word-box:before {\n  content: \"\\F22D\";\n}\n\n.mdi-file-xml:before {\n  content: \"\\F22E\";\n}\n\n.mdi-film:before {\n  content: \"\\F22F\";\n}\n\n.mdi-filmstrip:before {\n  content: \"\\F230\";\n}\n\n.mdi-filmstrip-off:before {\n  content: \"\\F231\";\n}\n\n.mdi-filter:before {\n  content: \"\\F232\";\n}\n\n.mdi-filter-outline:before {\n  content: \"\\F233\";\n}\n\n.mdi-filter-remove:before {\n  content: \"\\F234\";\n}\n\n.mdi-filter-remove-outline:before {\n  content: \"\\F235\";\n}\n\n.mdi-filter-variant:before {\n  content: \"\\F236\";\n}\n\n.mdi-finance:before {\n  content: \"\\F81E\";\n}\n\n.mdi-find-replace:before {\n  content: \"\\F6D3\";\n}\n\n.mdi-fingerprint:before {\n  content: \"\\F237\";\n}\n\n.mdi-fire:before {\n  content: \"\\F238\";\n}\n\n.mdi-fire-truck:before {\n  content: \"\\F8AA\";\n}\n\n.mdi-firebase:before {\n  content: \"\\F966\";\n}\n\n.mdi-firefox:before {\n  content: \"\\F239\";\n}\n\n.mdi-fish:before {\n  content: \"\\F23A\";\n}\n\n.mdi-flag:before {\n  content: \"\\F23B\";\n}\n\n.mdi-flag-checkered:before {\n  content: \"\\F23C\";\n}\n\n.mdi-flag-outline:before {\n  content: \"\\F23D\";\n}\n\n.mdi-flag-triangle:before {\n  content: \"\\F23F\";\n}\n\n.mdi-flag-variant:before {\n  content: \"\\F240\";\n}\n\n.mdi-flag-variant-outline:before {\n  content: \"\\F23E\";\n}\n\n.mdi-flash:before {\n  content: \"\\F241\";\n}\n\n.mdi-flash-auto:before {\n  content: \"\\F242\";\n}\n\n.mdi-flash-circle:before {\n  content: \"\\F81F\";\n}\n\n.mdi-flash-off:before {\n  content: \"\\F243\";\n}\n\n.mdi-flash-outline:before {\n  content: \"\\F6D4\";\n}\n\n.mdi-flash-red-eye:before {\n  content: \"\\F67A\";\n}\n\n.mdi-flashlight:before {\n  content: \"\\F244\";\n}\n\n.mdi-flashlight-off:before {\n  content: \"\\F245\";\n}\n\n.mdi-flask:before {\n  content: \"\\F093\";\n}\n\n.mdi-flask-empty:before {\n  content: \"\\F094\";\n}\n\n.mdi-flask-empty-outline:before {\n  content: \"\\F095\";\n}\n\n.mdi-flask-outline:before {\n  content: \"\\F096\";\n}\n\n.mdi-flattr:before {\n  content: \"\\F246\";\n}\n\n.mdi-flip-to-back:before {\n  content: \"\\F247\";\n}\n\n.mdi-flip-to-front:before {\n  content: \"\\F248\";\n}\n\n.mdi-floor-lamp:before {\n  content: \"\\F8DC\";\n}\n\n.mdi-floor-plan:before {\n  content: \"\\F820\";\n}\n\n.mdi-floppy:before {\n  content: \"\\F249\";\n}\n\n.mdi-flower:before {\n  content: \"\\F24A\";\n}\n\n.mdi-folder:before {\n  content: \"\\F24B\";\n}\n\n.mdi-folder-account:before {\n  content: \"\\F24C\";\n}\n\n.mdi-folder-download:before {\n  content: \"\\F24D\";\n}\n\n.mdi-folder-edit:before {\n  content: \"\\F8DD\";\n}\n\n.mdi-folder-google-drive:before {\n  content: \"\\F24E\";\n}\n\n.mdi-folder-image:before {\n  content: \"\\F24F\";\n}\n\n.mdi-folder-key:before {\n  content: \"\\F8AB\";\n}\n\n.mdi-folder-key-network:before {\n  content: \"\\F8AC\";\n}\n\n.mdi-folder-lock:before {\n  content: \"\\F250\";\n}\n\n.mdi-folder-lock-open:before {\n  content: \"\\F251\";\n}\n\n.mdi-folder-move:before {\n  content: \"\\F252\";\n}\n\n.mdi-folder-multiple:before {\n  content: \"\\F253\";\n}\n\n.mdi-folder-multiple-image:before {\n  content: \"\\F254\";\n}\n\n.mdi-folder-multiple-outline:before {\n  content: \"\\F255\";\n}\n\n.mdi-folder-network:before {\n  content: \"\\F86F\";\n}\n\n.mdi-folder-open:before {\n  content: \"\\F76F\";\n}\n\n.mdi-folder-outline:before {\n  content: \"\\F256\";\n}\n\n.mdi-folder-plus:before {\n  content: \"\\F257\";\n}\n\n.mdi-folder-remove:before {\n  content: \"\\F258\";\n}\n\n.mdi-folder-search:before {\n  content: \"\\F967\";\n}\n\n.mdi-folder-search-outline:before {\n  content: \"\\F968\";\n}\n\n.mdi-folder-star:before {\n  content: \"\\F69C\";\n}\n\n.mdi-folder-upload:before {\n  content: \"\\F259\";\n}\n\n.mdi-font-awesome:before {\n  content: \"\\F03A\";\n}\n\n.mdi-food:before {\n  content: \"\\F25A\";\n}\n\n.mdi-food-apple:before {\n  content: \"\\F25B\";\n}\n\n.mdi-food-croissant:before {\n  content: \"\\F7C7\";\n}\n\n.mdi-food-fork-drink:before {\n  content: \"\\F5F2\";\n}\n\n.mdi-food-off:before {\n  content: \"\\F5F3\";\n}\n\n.mdi-food-variant:before {\n  content: \"\\F25C\";\n}\n\n.mdi-football:before {\n  content: \"\\F25D\";\n}\n\n.mdi-football-australian:before {\n  content: \"\\F25E\";\n}\n\n.mdi-football-helmet:before {\n  content: \"\\F25F\";\n}\n\n.mdi-forklift:before {\n  content: \"\\F7C8\";\n}\n\n.mdi-format-align-bottom:before {\n  content: \"\\F752\";\n}\n\n.mdi-format-align-center:before {\n  content: \"\\F260\";\n}\n\n.mdi-format-align-justify:before {\n  content: \"\\F261\";\n}\n\n.mdi-format-align-left:before {\n  content: \"\\F262\";\n}\n\n.mdi-format-align-middle:before {\n  content: \"\\F753\";\n}\n\n.mdi-format-align-right:before {\n  content: \"\\F263\";\n}\n\n.mdi-format-align-top:before {\n  content: \"\\F754\";\n}\n\n.mdi-format-annotation-plus:before {\n  content: \"\\F646\";\n}\n\n.mdi-format-bold:before {\n  content: \"\\F264\";\n}\n\n.mdi-format-clear:before {\n  content: \"\\F265\";\n}\n\n.mdi-format-color-fill:before {\n  content: \"\\F266\";\n}\n\n.mdi-format-color-text:before {\n  content: \"\\F69D\";\n}\n\n.mdi-format-columns:before {\n  content: \"\\F8DE\";\n}\n\n.mdi-format-float-center:before {\n  content: \"\\F267\";\n}\n\n.mdi-format-float-left:before {\n  content: \"\\F268\";\n}\n\n.mdi-format-float-none:before {\n  content: \"\\F269\";\n}\n\n.mdi-format-float-right:before {\n  content: \"\\F26A\";\n}\n\n.mdi-format-font:before {\n  content: \"\\F6D5\";\n}\n\n.mdi-format-header-1:before {\n  content: \"\\F26B\";\n}\n\n.mdi-format-header-2:before {\n  content: \"\\F26C\";\n}\n\n.mdi-format-header-3:before {\n  content: \"\\F26D\";\n}\n\n.mdi-format-header-4:before {\n  content: \"\\F26E\";\n}\n\n.mdi-format-header-5:before {\n  content: \"\\F26F\";\n}\n\n.mdi-format-header-6:before {\n  content: \"\\F270\";\n}\n\n.mdi-format-header-decrease:before {\n  content: \"\\F271\";\n}\n\n.mdi-format-header-equal:before {\n  content: \"\\F272\";\n}\n\n.mdi-format-header-increase:before {\n  content: \"\\F273\";\n}\n\n.mdi-format-header-pound:before {\n  content: \"\\F274\";\n}\n\n.mdi-format-horizontal-align-center:before {\n  content: \"\\F61E\";\n}\n\n.mdi-format-horizontal-align-left:before {\n  content: \"\\F61F\";\n}\n\n.mdi-format-horizontal-align-right:before {\n  content: \"\\F620\";\n}\n\n.mdi-format-indent-decrease:before {\n  content: \"\\F275\";\n}\n\n.mdi-format-indent-increase:before {\n  content: \"\\F276\";\n}\n\n.mdi-format-italic:before {\n  content: \"\\F277\";\n}\n\n.mdi-format-line-spacing:before {\n  content: \"\\F278\";\n}\n\n.mdi-format-line-style:before {\n  content: \"\\F5C8\";\n}\n\n.mdi-format-line-weight:before {\n  content: \"\\F5C9\";\n}\n\n.mdi-format-list-bulleted:before {\n  content: \"\\F279\";\n}\n\n.mdi-format-list-bulleted-type:before {\n  content: \"\\F27A\";\n}\n\n.mdi-format-list-checkbox:before {\n  content: \"\\F969\";\n}\n\n.mdi-format-list-checks:before {\n  content: \"\\F755\";\n}\n\n.mdi-format-list-numbers:before {\n  content: \"\\F27B\";\n}\n\n.mdi-format-page-break:before {\n  content: \"\\F6D6\";\n}\n\n.mdi-format-paint:before {\n  content: \"\\F27C\";\n}\n\n.mdi-format-paragraph:before {\n  content: \"\\F27D\";\n}\n\n.mdi-format-pilcrow:before {\n  content: \"\\F6D7\";\n}\n\n.mdi-format-quote-close:before {\n  content: \"\\F27E\";\n}\n\n.mdi-format-quote-open:before {\n  content: \"\\F756\";\n}\n\n.mdi-format-rotate-90:before {\n  content: \"\\F6A9\";\n}\n\n.mdi-format-section:before {\n  content: \"\\F69E\";\n}\n\n.mdi-format-size:before {\n  content: \"\\F27F\";\n}\n\n.mdi-format-strikethrough:before {\n  content: \"\\F280\";\n}\n\n.mdi-format-strikethrough-variant:before {\n  content: \"\\F281\";\n}\n\n.mdi-format-subscript:before {\n  content: \"\\F282\";\n}\n\n.mdi-format-superscript:before {\n  content: \"\\F283\";\n}\n\n.mdi-format-text:before {\n  content: \"\\F284\";\n}\n\n.mdi-format-textdirection-l-to-r:before {\n  content: \"\\F285\";\n}\n\n.mdi-format-textdirection-r-to-l:before {\n  content: \"\\F286\";\n}\n\n.mdi-format-title:before {\n  content: \"\\F5F4\";\n}\n\n.mdi-format-underline:before {\n  content: \"\\F287\";\n}\n\n.mdi-format-vertical-align-bottom:before {\n  content: \"\\F621\";\n}\n\n.mdi-format-vertical-align-center:before {\n  content: \"\\F622\";\n}\n\n.mdi-format-vertical-align-top:before {\n  content: \"\\F623\";\n}\n\n.mdi-format-wrap-inline:before {\n  content: \"\\F288\";\n}\n\n.mdi-format-wrap-square:before {\n  content: \"\\F289\";\n}\n\n.mdi-format-wrap-tight:before {\n  content: \"\\F28A\";\n}\n\n.mdi-format-wrap-top-bottom:before {\n  content: \"\\F28B\";\n}\n\n.mdi-forum:before {\n  content: \"\\F28C\";\n}\n\n.mdi-forum-outline:before {\n  content: \"\\F821\";\n}\n\n.mdi-forward:before {\n  content: \"\\F28D\";\n}\n\n.mdi-fountain:before {\n  content: \"\\F96A\";\n}\n\n.mdi-foursquare:before {\n  content: \"\\F28E\";\n}\n\n.mdi-freebsd:before {\n  content: \"\\F8DF\";\n}\n\n.mdi-fridge:before {\n  content: \"\\F28F\";\n}\n\n.mdi-fridge-filled:before {\n  content: \"\\F290\";\n}\n\n.mdi-fridge-filled-bottom:before {\n  content: \"\\F291\";\n}\n\n.mdi-fridge-filled-top:before {\n  content: \"\\F292\";\n}\n\n.mdi-fuel:before {\n  content: \"\\F7C9\";\n}\n\n.mdi-fullscreen:before {\n  content: \"\\F293\";\n}\n\n.mdi-fullscreen-exit:before {\n  content: \"\\F294\";\n}\n\n.mdi-function:before {\n  content: \"\\F295\";\n}\n\n.mdi-function-variant:before {\n  content: \"\\F870\";\n}\n\n.mdi-gamepad:before {\n  content: \"\\F296\";\n}\n\n.mdi-gamepad-variant:before {\n  content: \"\\F297\";\n}\n\n.mdi-garage:before {\n  content: \"\\F6D8\";\n}\n\n.mdi-garage-alert:before {\n  content: \"\\F871\";\n}\n\n.mdi-garage-open:before {\n  content: \"\\F6D9\";\n}\n\n.mdi-gas-cylinder:before {\n  content: \"\\F647\";\n}\n\n.mdi-gas-station:before {\n  content: \"\\F298\";\n}\n\n.mdi-gate:before {\n  content: \"\\F299\";\n}\n\n.mdi-gate-and:before {\n  content: \"\\F8E0\";\n}\n\n.mdi-gate-nand:before {\n  content: \"\\F8E1\";\n}\n\n.mdi-gate-nor:before {\n  content: \"\\F8E2\";\n}\n\n.mdi-gate-not:before {\n  content: \"\\F8E3\";\n}\n\n.mdi-gate-or:before {\n  content: \"\\F8E4\";\n}\n\n.mdi-gate-xnor:before {\n  content: \"\\F8E5\";\n}\n\n.mdi-gate-xor:before {\n  content: \"\\F8E6\";\n}\n\n.mdi-gauge:before {\n  content: \"\\F29A\";\n}\n\n.mdi-gauge-empty:before {\n  content: \"\\F872\";\n}\n\n.mdi-gauge-full:before {\n  content: \"\\F873\";\n}\n\n.mdi-gauge-low:before {\n  content: \"\\F874\";\n}\n\n.mdi-gavel:before {\n  content: \"\\F29B\";\n}\n\n.mdi-gender-female:before {\n  content: \"\\F29C\";\n}\n\n.mdi-gender-male:before {\n  content: \"\\F29D\";\n}\n\n.mdi-gender-male-female:before {\n  content: \"\\F29E\";\n}\n\n.mdi-gender-transgender:before {\n  content: \"\\F29F\";\n}\n\n.mdi-gentoo:before {\n  content: \"\\F8E7\";\n}\n\n.mdi-gesture:before {\n  content: \"\\F7CA\";\n}\n\n.mdi-gesture-double-tap:before {\n  content: \"\\F73B\";\n}\n\n.mdi-gesture-swipe-down:before {\n  content: \"\\F73C\";\n}\n\n.mdi-gesture-swipe-left:before {\n  content: \"\\F73D\";\n}\n\n.mdi-gesture-swipe-right:before {\n  content: \"\\F73E\";\n}\n\n.mdi-gesture-swipe-up:before {\n  content: \"\\F73F\";\n}\n\n.mdi-gesture-tap:before {\n  content: \"\\F740\";\n}\n\n.mdi-gesture-two-double-tap:before {\n  content: \"\\F741\";\n}\n\n.mdi-gesture-two-tap:before {\n  content: \"\\F742\";\n}\n\n.mdi-ghost:before {\n  content: \"\\F2A0\";\n}\n\n.mdi-gift:before {\n  content: \"\\F2A1\";\n}\n\n.mdi-git:before {\n  content: \"\\F2A2\";\n}\n\n.mdi-github-box:before {\n  content: \"\\F2A3\";\n}\n\n.mdi-github-circle:before {\n  content: \"\\F2A4\";\n}\n\n.mdi-github-face:before {\n  content: \"\\F6DA\";\n}\n\n.mdi-glass-cocktail:before {\n  content: \"\\F356\";\n}\n\n.mdi-glass-flute:before {\n  content: \"\\F2A5\";\n}\n\n.mdi-glass-mug:before {\n  content: \"\\F2A6\";\n}\n\n.mdi-glass-stange:before {\n  content: \"\\F2A7\";\n}\n\n.mdi-glass-tulip:before {\n  content: \"\\F2A8\";\n}\n\n.mdi-glass-wine:before {\n  content: \"\\F875\";\n}\n\n.mdi-glassdoor:before {\n  content: \"\\F2A9\";\n}\n\n.mdi-glasses:before {\n  content: \"\\F2AA\";\n}\n\n.mdi-globe-model:before {\n  content: \"\\F8E8\";\n}\n\n.mdi-gmail:before {\n  content: \"\\F2AB\";\n}\n\n.mdi-gnome:before {\n  content: \"\\F2AC\";\n}\n\n.mdi-golf:before {\n  content: \"\\F822\";\n}\n\n.mdi-gondola:before {\n  content: \"\\F685\";\n}\n\n.mdi-google:before {\n  content: \"\\F2AD\";\n}\n\n.mdi-google-allo:before {\n  content: \"\\F801\";\n}\n\n.mdi-google-analytics:before {\n  content: \"\\F7CB\";\n}\n\n.mdi-google-assistant:before {\n  content: \"\\F7CC\";\n}\n\n.mdi-google-cardboard:before {\n  content: \"\\F2AE\";\n}\n\n.mdi-google-chrome:before {\n  content: \"\\F2AF\";\n}\n\n.mdi-google-circles:before {\n  content: \"\\F2B0\";\n}\n\n.mdi-google-circles-communities:before {\n  content: \"\\F2B1\";\n}\n\n.mdi-google-circles-extended:before {\n  content: \"\\F2B2\";\n}\n\n.mdi-google-circles-group:before {\n  content: \"\\F2B3\";\n}\n\n.mdi-google-controller:before {\n  content: \"\\F2B4\";\n}\n\n.mdi-google-controller-off:before {\n  content: \"\\F2B5\";\n}\n\n.mdi-google-drive:before {\n  content: \"\\F2B6\";\n}\n\n.mdi-google-earth:before {\n  content: \"\\F2B7\";\n}\n\n.mdi-google-fit:before {\n  content: \"\\F96B\";\n}\n\n.mdi-google-glass:before {\n  content: \"\\F2B8\";\n}\n\n.mdi-google-hangouts:before {\n  content: \"\\F2C9\";\n}\n\n.mdi-google-home:before {\n  content: \"\\F823\";\n}\n\n.mdi-google-keep:before {\n  content: \"\\F6DB\";\n}\n\n.mdi-google-maps:before {\n  content: \"\\F5F5\";\n}\n\n.mdi-google-nearby:before {\n  content: \"\\F2B9\";\n}\n\n.mdi-google-pages:before {\n  content: \"\\F2BA\";\n}\n\n.mdi-google-photos:before {\n  content: \"\\F6DC\";\n}\n\n.mdi-google-physical-web:before {\n  content: \"\\F2BB\";\n}\n\n.mdi-google-play:before {\n  content: \"\\F2BC\";\n}\n\n.mdi-google-plus:before {\n  content: \"\\F2BD\";\n}\n\n.mdi-google-plus-box:before {\n  content: \"\\F2BE\";\n}\n\n.mdi-google-translate:before {\n  content: \"\\F2BF\";\n}\n\n.mdi-google-wallet:before {\n  content: \"\\F2C0\";\n}\n\n.mdi-gpu:before {\n  content: \"\\F8AD\";\n}\n\n.mdi-gradient:before {\n  content: \"\\F69F\";\n}\n\n.mdi-graphql:before {\n  content: \"\\F876\";\n}\n\n.mdi-grease-pencil:before {\n  content: \"\\F648\";\n}\n\n.mdi-greater-than:before {\n  content: \"\\F96C\";\n}\n\n.mdi-greater-than-or-equal:before {\n  content: \"\\F96D\";\n}\n\n.mdi-grid:before {\n  content: \"\\F2C1\";\n}\n\n.mdi-grid-large:before {\n  content: \"\\F757\";\n}\n\n.mdi-grid-off:before {\n  content: \"\\F2C2\";\n}\n\n.mdi-group:before {\n  content: \"\\F2C3\";\n}\n\n.mdi-guitar-acoustic:before {\n  content: \"\\F770\";\n}\n\n.mdi-guitar-electric:before {\n  content: \"\\F2C4\";\n}\n\n.mdi-guitar-pick:before {\n  content: \"\\F2C5\";\n}\n\n.mdi-guitar-pick-outline:before {\n  content: \"\\F2C6\";\n}\n\n.mdi-guy-fawkes-mask:before {\n  content: \"\\F824\";\n}\n\n.mdi-hackernews:before {\n  content: \"\\F624\";\n}\n\n.mdi-hamburger:before {\n  content: \"\\F684\";\n}\n\n.mdi-hammer:before {\n  content: \"\\F8E9\";\n}\n\n.mdi-hand-pointing-right:before {\n  content: \"\\F2C7\";\n}\n\n.mdi-hanger:before {\n  content: \"\\F2C8\";\n}\n\n.mdi-hard-hat:before {\n  content: \"\\F96E\";\n}\n\n.mdi-harddisk:before {\n  content: \"\\F2CA\";\n}\n\n.mdi-headphones:before {\n  content: \"\\F2CB\";\n}\n\n.mdi-headphones-bluetooth:before {\n  content: \"\\F96F\";\n}\n\n.mdi-headphones-box:before {\n  content: \"\\F2CC\";\n}\n\n.mdi-headphones-off:before {\n  content: \"\\F7CD\";\n}\n\n.mdi-headphones-settings:before {\n  content: \"\\F2CD\";\n}\n\n.mdi-headset:before {\n  content: \"\\F2CE\";\n}\n\n.mdi-headset-dock:before {\n  content: \"\\F2CF\";\n}\n\n.mdi-headset-off:before {\n  content: \"\\F2D0\";\n}\n\n.mdi-heart:before {\n  content: \"\\F2D1\";\n}\n\n.mdi-heart-box:before {\n  content: \"\\F2D2\";\n}\n\n.mdi-heart-box-outline:before {\n  content: \"\\F2D3\";\n}\n\n.mdi-heart-broken:before {\n  content: \"\\F2D4\";\n}\n\n.mdi-heart-circle:before {\n  content: \"\\F970\";\n}\n\n.mdi-heart-circle-outline:before {\n  content: \"\\F971\";\n}\n\n.mdi-heart-half:before {\n  content: \"\\F6DE\";\n}\n\n.mdi-heart-half-full:before {\n  content: \"\\F6DD\";\n}\n\n.mdi-heart-half-outline:before {\n  content: \"\\F6DF\";\n}\n\n.mdi-heart-off:before {\n  content: \"\\F758\";\n}\n\n.mdi-heart-outline:before {\n  content: \"\\F2D5\";\n}\n\n.mdi-heart-pulse:before {\n  content: \"\\F5F6\";\n}\n\n.mdi-help:before {\n  content: \"\\F2D6\";\n}\n\n.mdi-help-box:before {\n  content: \"\\F78A\";\n}\n\n.mdi-help-circle:before {\n  content: \"\\F2D7\";\n}\n\n.mdi-help-circle-outline:before {\n  content: \"\\F625\";\n}\n\n.mdi-help-network:before {\n  content: \"\\F6F4\";\n}\n\n.mdi-hexagon:before {\n  content: \"\\F2D8\";\n}\n\n.mdi-hexagon-multiple:before {\n  content: \"\\F6E0\";\n}\n\n.mdi-hexagon-outline:before {\n  content: \"\\F2D9\";\n}\n\n.mdi-high-definition:before {\n  content: \"\\F7CE\";\n}\n\n.mdi-high-definition-box:before {\n  content: \"\\F877\";\n}\n\n.mdi-highway:before {\n  content: \"\\F5F7\";\n}\n\n.mdi-hinduism:before {\n  content: \"\\F972\";\n}\n\n.mdi-history:before {\n  content: \"\\F2DA\";\n}\n\n.mdi-hockey-puck:before {\n  content: \"\\F878\";\n}\n\n.mdi-hockey-sticks:before {\n  content: \"\\F879\";\n}\n\n.mdi-hololens:before {\n  content: \"\\F2DB\";\n}\n\n.mdi-home:before {\n  content: \"\\F2DC\";\n}\n\n.mdi-home-account:before {\n  content: \"\\F825\";\n}\n\n.mdi-home-alert:before {\n  content: \"\\F87A\";\n}\n\n.mdi-home-assistant:before {\n  content: \"\\F7CF\";\n}\n\n.mdi-home-automation:before {\n  content: \"\\F7D0\";\n}\n\n.mdi-home-circle:before {\n  content: \"\\F7D1\";\n}\n\n.mdi-home-currency-usd:before {\n  content: \"\\F8AE\";\n}\n\n.mdi-home-heart:before {\n  content: \"\\F826\";\n}\n\n.mdi-home-lock:before {\n  content: \"\\F8EA\";\n}\n\n.mdi-home-lock-open:before {\n  content: \"\\F8EB\";\n}\n\n.mdi-home-map-marker:before {\n  content: \"\\F5F8\";\n}\n\n.mdi-home-minus:before {\n  content: \"\\F973\";\n}\n\n.mdi-home-modern:before {\n  content: \"\\F2DD\";\n}\n\n.mdi-home-outline:before {\n  content: \"\\F6A0\";\n}\n\n.mdi-home-plus:before {\n  content: \"\\F974\";\n}\n\n.mdi-home-variant:before {\n  content: \"\\F2DE\";\n}\n\n.mdi-hook:before {\n  content: \"\\F6E1\";\n}\n\n.mdi-hook-off:before {\n  content: \"\\F6E2\";\n}\n\n.mdi-hops:before {\n  content: \"\\F2DF\";\n}\n\n.mdi-hospital:before {\n  content: \"\\F2E0\";\n}\n\n.mdi-hospital-building:before {\n  content: \"\\F2E1\";\n}\n\n.mdi-hospital-marker:before {\n  content: \"\\F2E2\";\n}\n\n.mdi-hot-tub:before {\n  content: \"\\F827\";\n}\n\n.mdi-hotel:before {\n  content: \"\\F2E3\";\n}\n\n.mdi-houzz:before {\n  content: \"\\F2E4\";\n}\n\n.mdi-houzz-box:before {\n  content: \"\\F2E5\";\n}\n\n.mdi-hulu:before {\n  content: \"\\F828\";\n}\n\n.mdi-human:before {\n  content: \"\\F2E6\";\n}\n\n.mdi-human-child:before {\n  content: \"\\F2E7\";\n}\n\n.mdi-human-female:before {\n  content: \"\\F649\";\n}\n\n.mdi-human-greeting:before {\n  content: \"\\F64A\";\n}\n\n.mdi-human-handsdown:before {\n  content: \"\\F64B\";\n}\n\n.mdi-human-handsup:before {\n  content: \"\\F64C\";\n}\n\n.mdi-human-male:before {\n  content: \"\\F64D\";\n}\n\n.mdi-human-male-female:before {\n  content: \"\\F2E8\";\n}\n\n.mdi-human-pregnant:before {\n  content: \"\\F5CF\";\n}\n\n.mdi-humble-bundle:before {\n  content: \"\\F743\";\n}\n\n.mdi-ice-cream:before {\n  content: \"\\F829\";\n}\n\n.mdi-image:before {\n  content: \"\\F2E9\";\n}\n\n.mdi-image-album:before {\n  content: \"\\F2EA\";\n}\n\n.mdi-image-area:before {\n  content: \"\\F2EB\";\n}\n\n.mdi-image-area-close:before {\n  content: \"\\F2EC\";\n}\n\n.mdi-image-broken:before {\n  content: \"\\F2ED\";\n}\n\n.mdi-image-broken-variant:before {\n  content: \"\\F2EE\";\n}\n\n.mdi-image-filter:before {\n  content: \"\\F2EF\";\n}\n\n.mdi-image-filter-black-white:before {\n  content: \"\\F2F0\";\n}\n\n.mdi-image-filter-center-focus:before {\n  content: \"\\F2F1\";\n}\n\n.mdi-image-filter-center-focus-weak:before {\n  content: \"\\F2F2\";\n}\n\n.mdi-image-filter-drama:before {\n  content: \"\\F2F3\";\n}\n\n.mdi-image-filter-frames:before {\n  content: \"\\F2F4\";\n}\n\n.mdi-image-filter-hdr:before {\n  content: \"\\F2F5\";\n}\n\n.mdi-image-filter-none:before {\n  content: \"\\F2F6\";\n}\n\n.mdi-image-filter-tilt-shift:before {\n  content: \"\\F2F7\";\n}\n\n.mdi-image-filter-vintage:before {\n  content: \"\\F2F8\";\n}\n\n.mdi-image-multiple:before {\n  content: \"\\F2F9\";\n}\n\n.mdi-image-off:before {\n  content: \"\\F82A\";\n}\n\n.mdi-image-outline:before {\n  content: \"\\F975\";\n}\n\n.mdi-image-plus:before {\n  content: \"\\F87B\";\n}\n\n.mdi-image-search:before {\n  content: \"\\F976\";\n}\n\n.mdi-image-search-outline:before {\n  content: \"\\F977\";\n}\n\n.mdi-import:before {\n  content: \"\\F2FA\";\n}\n\n.mdi-inbox:before {\n  content: \"\\F686\";\n}\n\n.mdi-inbox-arrow-down:before {\n  content: \"\\F2FB\";\n}\n\n.mdi-inbox-arrow-up:before {\n  content: \"\\F3D1\";\n}\n\n.mdi-inbox-multiple:before {\n  content: \"\\F8AF\";\n}\n\n.mdi-incognito:before {\n  content: \"\\F5F9\";\n}\n\n.mdi-infinity:before {\n  content: \"\\F6E3\";\n}\n\n.mdi-information:before {\n  content: \"\\F2FC\";\n}\n\n.mdi-information-outline:before {\n  content: \"\\F2FD\";\n}\n\n.mdi-information-variant:before {\n  content: \"\\F64E\";\n}\n\n.mdi-instagram:before {\n  content: \"\\F2FE\";\n}\n\n.mdi-instapaper:before {\n  content: \"\\F2FF\";\n}\n\n.mdi-internet-explorer:before {\n  content: \"\\F300\";\n}\n\n.mdi-invert-colors:before {\n  content: \"\\F301\";\n}\n\n.mdi-islam:before {\n  content: \"\\F978\";\n}\n\n.mdi-itunes:before {\n  content: \"\\F676\";\n}\n\n.mdi-jeepney:before {\n  content: \"\\F302\";\n}\n\n.mdi-jira:before {\n  content: \"\\F303\";\n}\n\n.mdi-jquery:before {\n  content: \"\\F87C\";\n}\n\n.mdi-jsfiddle:before {\n  content: \"\\F304\";\n}\n\n.mdi-json:before {\n  content: \"\\F626\";\n}\n\n.mdi-judaism:before {\n  content: \"\\F979\";\n}\n\n.mdi-karate:before {\n  content: \"\\F82B\";\n}\n\n.mdi-keg:before {\n  content: \"\\F305\";\n}\n\n.mdi-kettle:before {\n  content: \"\\F5FA\";\n}\n\n.mdi-key:before {\n  content: \"\\F306\";\n}\n\n.mdi-key-change:before {\n  content: \"\\F307\";\n}\n\n.mdi-key-minus:before {\n  content: \"\\F308\";\n}\n\n.mdi-key-plus:before {\n  content: \"\\F309\";\n}\n\n.mdi-key-remove:before {\n  content: \"\\F30A\";\n}\n\n.mdi-key-variant:before {\n  content: \"\\F30B\";\n}\n\n.mdi-keyboard:before {\n  content: \"\\F30C\";\n}\n\n.mdi-keyboard-backspace:before {\n  content: \"\\F30D\";\n}\n\n.mdi-keyboard-caps:before {\n  content: \"\\F30E\";\n}\n\n.mdi-keyboard-close:before {\n  content: \"\\F30F\";\n}\n\n.mdi-keyboard-off:before {\n  content: \"\\F310\";\n}\n\n.mdi-keyboard-outline:before {\n  content: \"\\F97A\";\n}\n\n.mdi-keyboard-return:before {\n  content: \"\\F311\";\n}\n\n.mdi-keyboard-tab:before {\n  content: \"\\F312\";\n}\n\n.mdi-keyboard-variant:before {\n  content: \"\\F313\";\n}\n\n.mdi-kickstarter:before {\n  content: \"\\F744\";\n}\n\n.mdi-kodi:before {\n  content: \"\\F314\";\n}\n\n.mdi-label:before {\n  content: \"\\F315\";\n}\n\n.mdi-label-outline:before {\n  content: \"\\F316\";\n}\n\n.mdi-ladybug:before {\n  content: \"\\F82C\";\n}\n\n.mdi-lambda:before {\n  content: \"\\F627\";\n}\n\n.mdi-lamp:before {\n  content: \"\\F6B4\";\n}\n\n.mdi-lan:before {\n  content: \"\\F317\";\n}\n\n.mdi-lan-connect:before {\n  content: \"\\F318\";\n}\n\n.mdi-lan-disconnect:before {\n  content: \"\\F319\";\n}\n\n.mdi-lan-pending:before {\n  content: \"\\F31A\";\n}\n\n.mdi-language-c:before {\n  content: \"\\F671\";\n}\n\n.mdi-language-cpp:before {\n  content: \"\\F672\";\n}\n\n.mdi-language-csharp:before {\n  content: \"\\F31B\";\n}\n\n.mdi-language-css3:before {\n  content: \"\\F31C\";\n}\n\n.mdi-language-go:before {\n  content: \"\\F7D2\";\n}\n\n.mdi-language-html5:before {\n  content: \"\\F31D\";\n}\n\n.mdi-language-javascript:before {\n  content: \"\\F31E\";\n}\n\n.mdi-language-lua:before {\n  content: \"\\F8B0\";\n}\n\n.mdi-language-php:before {\n  content: \"\\F31F\";\n}\n\n.mdi-language-python:before {\n  content: \"\\F320\";\n}\n\n.mdi-language-python-text:before {\n  content: \"\\F321\";\n}\n\n.mdi-language-r:before {\n  content: \"\\F7D3\";\n}\n\n.mdi-language-swift:before {\n  content: \"\\F6E4\";\n}\n\n.mdi-language-typescript:before {\n  content: \"\\F6E5\";\n}\n\n.mdi-laptop:before {\n  content: \"\\F322\";\n}\n\n.mdi-laptop-chromebook:before {\n  content: \"\\F323\";\n}\n\n.mdi-laptop-mac:before {\n  content: \"\\F324\";\n}\n\n.mdi-laptop-off:before {\n  content: \"\\F6E6\";\n}\n\n.mdi-laptop-windows:before {\n  content: \"\\F325\";\n}\n\n.mdi-lastfm:before {\n  content: \"\\F326\";\n}\n\n.mdi-lastpass:before {\n  content: \"\\F446\";\n}\n\n.mdi-launch:before {\n  content: \"\\F327\";\n}\n\n.mdi-lava-lamp:before {\n  content: \"\\F7D4\";\n}\n\n.mdi-layers:before {\n  content: \"\\F328\";\n}\n\n.mdi-layers-off:before {\n  content: \"\\F329\";\n}\n\n.mdi-lead-pencil:before {\n  content: \"\\F64F\";\n}\n\n.mdi-leaf:before {\n  content: \"\\F32A\";\n}\n\n.mdi-led-off:before {\n  content: \"\\F32B\";\n}\n\n.mdi-led-on:before {\n  content: \"\\F32C\";\n}\n\n.mdi-led-outline:before {\n  content: \"\\F32D\";\n}\n\n.mdi-led-strip:before {\n  content: \"\\F7D5\";\n}\n\n.mdi-led-variant-off:before {\n  content: \"\\F32E\";\n}\n\n.mdi-led-variant-on:before {\n  content: \"\\F32F\";\n}\n\n.mdi-led-variant-outline:before {\n  content: \"\\F330\";\n}\n\n.mdi-less-than:before {\n  content: \"\\F97B\";\n}\n\n.mdi-less-than-or-equal:before {\n  content: \"\\F97C\";\n}\n\n.mdi-library:before {\n  content: \"\\F331\";\n}\n\n.mdi-library-books:before {\n  content: \"\\F332\";\n}\n\n.mdi-library-music:before {\n  content: \"\\F333\";\n}\n\n.mdi-library-plus:before {\n  content: \"\\F334\";\n}\n\n.mdi-lifebuoy:before {\n  content: \"\\F87D\";\n}\n\n.mdi-light-switch:before {\n  content: \"\\F97D\";\n}\n\n.mdi-lightbulb:before {\n  content: \"\\F335\";\n}\n\n.mdi-lightbulb-on:before {\n  content: \"\\F6E7\";\n}\n\n.mdi-lightbulb-on-outline:before {\n  content: \"\\F6E8\";\n}\n\n.mdi-lightbulb-outline:before {\n  content: \"\\F336\";\n}\n\n.mdi-link:before {\n  content: \"\\F337\";\n}\n\n.mdi-link-off:before {\n  content: \"\\F338\";\n}\n\n.mdi-link-variant:before {\n  content: \"\\F339\";\n}\n\n.mdi-link-variant-off:before {\n  content: \"\\F33A\";\n}\n\n.mdi-linkedin:before {\n  content: \"\\F33B\";\n}\n\n.mdi-linkedin-box:before {\n  content: \"\\F33C\";\n}\n\n.mdi-linux:before {\n  content: \"\\F33D\";\n}\n\n.mdi-linux-mint:before {\n  content: \"\\F8EC\";\n}\n\n.mdi-loading:before {\n  content: \"\\F771\";\n}\n\n.mdi-lock:before {\n  content: \"\\F33E\";\n}\n\n.mdi-lock-alert:before {\n  content: \"\\F8ED\";\n}\n\n.mdi-lock-clock:before {\n  content: \"\\F97E\";\n}\n\n.mdi-lock-open:before {\n  content: \"\\F33F\";\n}\n\n.mdi-lock-open-outline:before {\n  content: \"\\F340\";\n}\n\n.mdi-lock-outline:before {\n  content: \"\\F341\";\n}\n\n.mdi-lock-pattern:before {\n  content: \"\\F6E9\";\n}\n\n.mdi-lock-plus:before {\n  content: \"\\F5FB\";\n}\n\n.mdi-lock-question:before {\n  content: \"\\F8EE\";\n}\n\n.mdi-lock-reset:before {\n  content: \"\\F772\";\n}\n\n.mdi-lock-smart:before {\n  content: \"\\F8B1\";\n}\n\n.mdi-locker:before {\n  content: \"\\F7D6\";\n}\n\n.mdi-locker-multiple:before {\n  content: \"\\F7D7\";\n}\n\n.mdi-login:before {\n  content: \"\\F342\";\n}\n\n.mdi-login-variant:before {\n  content: \"\\F5FC\";\n}\n\n.mdi-logout:before {\n  content: \"\\F343\";\n}\n\n.mdi-logout-variant:before {\n  content: \"\\F5FD\";\n}\n\n.mdi-looks:before {\n  content: \"\\F344\";\n}\n\n.mdi-loop:before {\n  content: \"\\F6EA\";\n}\n\n.mdi-loupe:before {\n  content: \"\\F345\";\n}\n\n.mdi-lumx:before {\n  content: \"\\F346\";\n}\n\n.mdi-magnet:before {\n  content: \"\\F347\";\n}\n\n.mdi-magnet-on:before {\n  content: \"\\F348\";\n}\n\n.mdi-magnify:before {\n  content: \"\\F349\";\n}\n\n.mdi-magnify-close:before {\n  content: \"\\F97F\";\n}\n\n.mdi-magnify-minus:before {\n  content: \"\\F34A\";\n}\n\n.mdi-magnify-minus-outline:before {\n  content: \"\\F6EB\";\n}\n\n.mdi-magnify-plus:before {\n  content: \"\\F34B\";\n}\n\n.mdi-magnify-plus-outline:before {\n  content: \"\\F6EC\";\n}\n\n.mdi-mail-ru:before {\n  content: \"\\F34C\";\n}\n\n.mdi-mailbox:before {\n  content: \"\\F6ED\";\n}\n\n.mdi-map:before {\n  content: \"\\F34D\";\n}\n\n.mdi-map-marker:before {\n  content: \"\\F34E\";\n}\n\n.mdi-map-marker-circle:before {\n  content: \"\\F34F\";\n}\n\n.mdi-map-marker-distance:before {\n  content: \"\\F8EF\";\n}\n\n.mdi-map-marker-minus:before {\n  content: \"\\F650\";\n}\n\n.mdi-map-marker-multiple:before {\n  content: \"\\F350\";\n}\n\n.mdi-map-marker-off:before {\n  content: \"\\F351\";\n}\n\n.mdi-map-marker-outline:before {\n  content: \"\\F7D8\";\n}\n\n.mdi-map-marker-plus:before {\n  content: \"\\F651\";\n}\n\n.mdi-map-marker-radius:before {\n  content: \"\\F352\";\n}\n\n.mdi-map-minus:before {\n  content: \"\\F980\";\n}\n\n.mdi-map-outline:before {\n  content: \"\\F981\";\n}\n\n.mdi-map-plus:before {\n  content: \"\\F982\";\n}\n\n.mdi-map-search:before {\n  content: \"\\F983\";\n}\n\n.mdi-map-search-outline:before {\n  content: \"\\F984\";\n}\n\n.mdi-margin:before {\n  content: \"\\F353\";\n}\n\n.mdi-markdown:before {\n  content: \"\\F354\";\n}\n\n.mdi-marker:before {\n  content: \"\\F652\";\n}\n\n.mdi-marker-check:before {\n  content: \"\\F355\";\n}\n\n.mdi-material-design:before {\n  content: \"\\F985\";\n}\n\n.mdi-material-ui:before {\n  content: \"\\F357\";\n}\n\n.mdi-math-compass:before {\n  content: \"\\F358\";\n}\n\n.mdi-matrix:before {\n  content: \"\\F628\";\n}\n\n.mdi-maxcdn:before {\n  content: \"\\F359\";\n}\n\n.mdi-medal:before {\n  content: \"\\F986\";\n}\n\n.mdi-medical-bag:before {\n  content: \"\\F6EE\";\n}\n\n.mdi-medium:before {\n  content: \"\\F35A\";\n}\n\n.mdi-memory:before {\n  content: \"\\F35B\";\n}\n\n.mdi-menu:before {\n  content: \"\\F35C\";\n}\n\n.mdi-menu-down:before {\n  content: \"\\F35D\";\n}\n\n.mdi-menu-down-outline:before {\n  content: \"\\F6B5\";\n}\n\n.mdi-menu-left:before {\n  content: \"\\F35E\";\n}\n\n.mdi-menu-right:before {\n  content: \"\\F35F\";\n}\n\n.mdi-menu-up:before {\n  content: \"\\F360\";\n}\n\n.mdi-menu-up-outline:before {\n  content: \"\\F6B6\";\n}\n\n.mdi-message:before {\n  content: \"\\F361\";\n}\n\n.mdi-message-alert:before {\n  content: \"\\F362\";\n}\n\n.mdi-message-bulleted:before {\n  content: \"\\F6A1\";\n}\n\n.mdi-message-bulleted-off:before {\n  content: \"\\F6A2\";\n}\n\n.mdi-message-draw:before {\n  content: \"\\F363\";\n}\n\n.mdi-message-image:before {\n  content: \"\\F364\";\n}\n\n.mdi-message-outline:before {\n  content: \"\\F365\";\n}\n\n.mdi-message-plus:before {\n  content: \"\\F653\";\n}\n\n.mdi-message-processing:before {\n  content: \"\\F366\";\n}\n\n.mdi-message-reply:before {\n  content: \"\\F367\";\n}\n\n.mdi-message-reply-text:before {\n  content: \"\\F368\";\n}\n\n.mdi-message-settings:before {\n  content: \"\\F6EF\";\n}\n\n.mdi-message-settings-variant:before {\n  content: \"\\F6F0\";\n}\n\n.mdi-message-text:before {\n  content: \"\\F369\";\n}\n\n.mdi-message-text-outline:before {\n  content: \"\\F36A\";\n}\n\n.mdi-message-video:before {\n  content: \"\\F36B\";\n}\n\n.mdi-meteor:before {\n  content: \"\\F629\";\n}\n\n.mdi-metronome:before {\n  content: \"\\F7D9\";\n}\n\n.mdi-metronome-tick:before {\n  content: \"\\F7DA\";\n}\n\n.mdi-micro-sd:before {\n  content: \"\\F7DB\";\n}\n\n.mdi-microphone:before {\n  content: \"\\F36C\";\n}\n\n.mdi-microphone-minus:before {\n  content: \"\\F8B2\";\n}\n\n.mdi-microphone-off:before {\n  content: \"\\F36D\";\n}\n\n.mdi-microphone-outline:before {\n  content: \"\\F36E\";\n}\n\n.mdi-microphone-plus:before {\n  content: \"\\F8B3\";\n}\n\n.mdi-microphone-settings:before {\n  content: \"\\F36F\";\n}\n\n.mdi-microphone-variant:before {\n  content: \"\\F370\";\n}\n\n.mdi-microphone-variant-off:before {\n  content: \"\\F371\";\n}\n\n.mdi-microscope:before {\n  content: \"\\F654\";\n}\n\n.mdi-microsoft:before {\n  content: \"\\F372\";\n}\n\n.mdi-microsoft-dynamics:before {\n  content: \"\\F987\";\n}\n\n.mdi-midi:before {\n  content: \"\\F8F0\";\n}\n\n.mdi-midi-port:before {\n  content: \"\\F8F1\";\n}\n\n.mdi-minecraft:before {\n  content: \"\\F373\";\n}\n\n.mdi-minus:before {\n  content: \"\\F374\";\n}\n\n.mdi-minus-box:before {\n  content: \"\\F375\";\n}\n\n.mdi-minus-box-outline:before {\n  content: \"\\F6F1\";\n}\n\n.mdi-minus-circle:before {\n  content: \"\\F376\";\n}\n\n.mdi-minus-circle-outline:before {\n  content: \"\\F377\";\n}\n\n.mdi-minus-network:before {\n  content: \"\\F378\";\n}\n\n.mdi-mixcloud:before {\n  content: \"\\F62A\";\n}\n\n.mdi-mixed-reality:before {\n  content: \"\\F87E\";\n}\n\n.mdi-mixer:before {\n  content: \"\\F7DC\";\n}\n\n.mdi-monitor:before {\n  content: \"\\F379\";\n}\n\n.mdi-monitor-cellphone:before {\n  content: \"\\F988\";\n}\n\n.mdi-monitor-cellphone-star:before {\n  content: \"\\F989\";\n}\n\n.mdi-monitor-multiple:before {\n  content: \"\\F37A\";\n}\n\n.mdi-more:before {\n  content: \"\\F37B\";\n}\n\n.mdi-motorbike:before {\n  content: \"\\F37C\";\n}\n\n.mdi-mouse:before {\n  content: \"\\F37D\";\n}\n\n.mdi-mouse-bluetooth:before {\n  content: \"\\F98A\";\n}\n\n.mdi-mouse-off:before {\n  content: \"\\F37E\";\n}\n\n.mdi-mouse-variant:before {\n  content: \"\\F37F\";\n}\n\n.mdi-mouse-variant-off:before {\n  content: \"\\F380\";\n}\n\n.mdi-move-resize:before {\n  content: \"\\F655\";\n}\n\n.mdi-move-resize-variant:before {\n  content: \"\\F656\";\n}\n\n.mdi-movie:before {\n  content: \"\\F381\";\n}\n\n.mdi-movie-roll:before {\n  content: \"\\F7DD\";\n}\n\n.mdi-muffin:before {\n  content: \"\\F98B\";\n}\n\n.mdi-multiplication:before {\n  content: \"\\F382\";\n}\n\n.mdi-multiplication-box:before {\n  content: \"\\F383\";\n}\n\n.mdi-mushroom:before {\n  content: \"\\F7DE\";\n}\n\n.mdi-mushroom-outline:before {\n  content: \"\\F7DF\";\n}\n\n.mdi-music:before {\n  content: \"\\F759\";\n}\n\n.mdi-music-box:before {\n  content: \"\\F384\";\n}\n\n.mdi-music-box-outline:before {\n  content: \"\\F385\";\n}\n\n.mdi-music-circle:before {\n  content: \"\\F386\";\n}\n\n.mdi-music-note:before {\n  content: \"\\F387\";\n}\n\n.mdi-music-note-bluetooth:before {\n  content: \"\\F5FE\";\n}\n\n.mdi-music-note-bluetooth-off:before {\n  content: \"\\F5FF\";\n}\n\n.mdi-music-note-eighth:before {\n  content: \"\\F388\";\n}\n\n.mdi-music-note-half:before {\n  content: \"\\F389\";\n}\n\n.mdi-music-note-off:before {\n  content: \"\\F38A\";\n}\n\n.mdi-music-note-quarter:before {\n  content: \"\\F38B\";\n}\n\n.mdi-music-note-sixteenth:before {\n  content: \"\\F38C\";\n}\n\n.mdi-music-note-whole:before {\n  content: \"\\F38D\";\n}\n\n.mdi-music-off:before {\n  content: \"\\F75A\";\n}\n\n.mdi-nas:before {\n  content: \"\\F8F2\";\n}\n\n.mdi-nativescript:before {\n  content: \"\\F87F\";\n}\n\n.mdi-nature:before {\n  content: \"\\F38E\";\n}\n\n.mdi-nature-people:before {\n  content: \"\\F38F\";\n}\n\n.mdi-navigation:before {\n  content: \"\\F390\";\n}\n\n.mdi-near-me:before {\n  content: \"\\F5CD\";\n}\n\n.mdi-needle:before {\n  content: \"\\F391\";\n}\n\n.mdi-netflix:before {\n  content: \"\\F745\";\n}\n\n.mdi-network:before {\n  content: \"\\F6F2\";\n}\n\n.mdi-network-strength-1:before {\n  content: \"\\F8F3\";\n}\n\n.mdi-network-strength-1-alert:before {\n  content: \"\\F8F4\";\n}\n\n.mdi-network-strength-2:before {\n  content: \"\\F8F5\";\n}\n\n.mdi-network-strength-2-alert:before {\n  content: \"\\F8F6\";\n}\n\n.mdi-network-strength-3:before {\n  content: \"\\F8F7\";\n}\n\n.mdi-network-strength-3-alert:before {\n  content: \"\\F8F8\";\n}\n\n.mdi-network-strength-4:before {\n  content: \"\\F8F9\";\n}\n\n.mdi-network-strength-4-alert:before {\n  content: \"\\F8FA\";\n}\n\n.mdi-network-strength-off:before {\n  content: \"\\F8FB\";\n}\n\n.mdi-network-strength-off-outline:before {\n  content: \"\\F8FC\";\n}\n\n.mdi-network-strength-outline:before {\n  content: \"\\F8FD\";\n}\n\n.mdi-new-box:before {\n  content: \"\\F394\";\n}\n\n.mdi-newspaper:before {\n  content: \"\\F395\";\n}\n\n.mdi-nfc:before {\n  content: \"\\F396\";\n}\n\n.mdi-nfc-tap:before {\n  content: \"\\F397\";\n}\n\n.mdi-nfc-variant:before {\n  content: \"\\F398\";\n}\n\n.mdi-ninja:before {\n  content: \"\\F773\";\n}\n\n.mdi-nintendo-switch:before {\n  content: \"\\F7E0\";\n}\n\n.mdi-nodejs:before {\n  content: \"\\F399\";\n}\n\n.mdi-not-equal:before {\n  content: \"\\F98C\";\n}\n\n.mdi-not-equal-variant:before {\n  content: \"\\F98D\";\n}\n\n.mdi-note:before {\n  content: \"\\F39A\";\n}\n\n.mdi-note-multiple:before {\n  content: \"\\F6B7\";\n}\n\n.mdi-note-multiple-outline:before {\n  content: \"\\F6B8\";\n}\n\n.mdi-note-outline:before {\n  content: \"\\F39B\";\n}\n\n.mdi-note-plus:before {\n  content: \"\\F39C\";\n}\n\n.mdi-note-plus-outline:before {\n  content: \"\\F39D\";\n}\n\n.mdi-note-text:before {\n  content: \"\\F39E\";\n}\n\n.mdi-notebook:before {\n  content: \"\\F82D\";\n}\n\n.mdi-notification-clear-all:before {\n  content: \"\\F39F\";\n}\n\n.mdi-npm:before {\n  content: \"\\F6F6\";\n}\n\n.mdi-npm-variant:before {\n  content: \"\\F98E\";\n}\n\n.mdi-npm-variant-outline:before {\n  content: \"\\F98F\";\n}\n\n.mdi-nuke:before {\n  content: \"\\F6A3\";\n}\n\n.mdi-null:before {\n  content: \"\\F7E1\";\n}\n\n.mdi-numeric:before {\n  content: \"\\F3A0\";\n}\n\n.mdi-numeric-0-box:before {\n  content: \"\\F3A1\";\n}\n\n.mdi-numeric-0-box-multiple-outline:before {\n  content: \"\\F3A2\";\n}\n\n.mdi-numeric-0-box-outline:before {\n  content: \"\\F3A3\";\n}\n\n.mdi-numeric-1-box:before {\n  content: \"\\F3A4\";\n}\n\n.mdi-numeric-1-box-multiple-outline:before {\n  content: \"\\F3A5\";\n}\n\n.mdi-numeric-1-box-outline:before {\n  content: \"\\F3A6\";\n}\n\n.mdi-numeric-2-box:before {\n  content: \"\\F3A7\";\n}\n\n.mdi-numeric-2-box-multiple-outline:before {\n  content: \"\\F3A8\";\n}\n\n.mdi-numeric-2-box-outline:before {\n  content: \"\\F3A9\";\n}\n\n.mdi-numeric-3-box:before {\n  content: \"\\F3AA\";\n}\n\n.mdi-numeric-3-box-multiple-outline:before {\n  content: \"\\F3AB\";\n}\n\n.mdi-numeric-3-box-outline:before {\n  content: \"\\F3AC\";\n}\n\n.mdi-numeric-4-box:before {\n  content: \"\\F3AD\";\n}\n\n.mdi-numeric-4-box-multiple-outline:before {\n  content: \"\\F3AE\";\n}\n\n.mdi-numeric-4-box-outline:before {\n  content: \"\\F3AF\";\n}\n\n.mdi-numeric-5-box:before {\n  content: \"\\F3B0\";\n}\n\n.mdi-numeric-5-box-multiple-outline:before {\n  content: \"\\F3B1\";\n}\n\n.mdi-numeric-5-box-outline:before {\n  content: \"\\F3B2\";\n}\n\n.mdi-numeric-6-box:before {\n  content: \"\\F3B3\";\n}\n\n.mdi-numeric-6-box-multiple-outline:before {\n  content: \"\\F3B4\";\n}\n\n.mdi-numeric-6-box-outline:before {\n  content: \"\\F3B5\";\n}\n\n.mdi-numeric-7-box:before {\n  content: \"\\F3B6\";\n}\n\n.mdi-numeric-7-box-multiple-outline:before {\n  content: \"\\F3B7\";\n}\n\n.mdi-numeric-7-box-outline:before {\n  content: \"\\F3B8\";\n}\n\n.mdi-numeric-8-box:before {\n  content: \"\\F3B9\";\n}\n\n.mdi-numeric-8-box-multiple-outline:before {\n  content: \"\\F3BA\";\n}\n\n.mdi-numeric-8-box-outline:before {\n  content: \"\\F3BB\";\n}\n\n.mdi-numeric-9-box:before {\n  content: \"\\F3BC\";\n}\n\n.mdi-numeric-9-box-multiple-outline:before {\n  content: \"\\F3BD\";\n}\n\n.mdi-numeric-9-box-outline:before {\n  content: \"\\F3BE\";\n}\n\n.mdi-numeric-9-plus-box:before {\n  content: \"\\F3BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline:before {\n  content: \"\\F3C0\";\n}\n\n.mdi-numeric-9-plus-box-outline:before {\n  content: \"\\F3C1\";\n}\n\n.mdi-nut:before {\n  content: \"\\F6F7\";\n}\n\n.mdi-nutrition:before {\n  content: \"\\F3C2\";\n}\n\n.mdi-oar:before {\n  content: \"\\F67B\";\n}\n\n.mdi-octagon:before {\n  content: \"\\F3C3\";\n}\n\n.mdi-octagon-outline:before {\n  content: \"\\F3C4\";\n}\n\n.mdi-octagram:before {\n  content: \"\\F6F8\";\n}\n\n.mdi-octagram-outline:before {\n  content: \"\\F774\";\n}\n\n.mdi-odnoklassniki:before {\n  content: \"\\F3C5\";\n}\n\n.mdi-office:before {\n  content: \"\\F3C6\";\n}\n\n.mdi-office-building:before {\n  content: \"\\F990\";\n}\n\n.mdi-oil:before {\n  content: \"\\F3C7\";\n}\n\n.mdi-oil-temperature:before {\n  content: \"\\F3C8\";\n}\n\n.mdi-omega:before {\n  content: \"\\F3C9\";\n}\n\n.mdi-onedrive:before {\n  content: \"\\F3CA\";\n}\n\n.mdi-onenote:before {\n  content: \"\\F746\";\n}\n\n.mdi-onepassword:before {\n  content: \"\\F880\";\n}\n\n.mdi-opacity:before {\n  content: \"\\F5CC\";\n}\n\n.mdi-open-in-app:before {\n  content: \"\\F3CB\";\n}\n\n.mdi-open-in-new:before {\n  content: \"\\F3CC\";\n}\n\n.mdi-openid:before {\n  content: \"\\F3CD\";\n}\n\n.mdi-opera:before {\n  content: \"\\F3CE\";\n}\n\n.mdi-orbit:before {\n  content: \"\\F018\";\n}\n\n.mdi-ornament:before {\n  content: \"\\F3CF\";\n}\n\n.mdi-ornament-variant:before {\n  content: \"\\F3D0\";\n}\n\n.mdi-owl:before {\n  content: \"\\F3D2\";\n}\n\n.mdi-package:before {\n  content: \"\\F3D3\";\n}\n\n.mdi-package-down:before {\n  content: \"\\F3D4\";\n}\n\n.mdi-package-up:before {\n  content: \"\\F3D5\";\n}\n\n.mdi-package-variant:before {\n  content: \"\\F3D6\";\n}\n\n.mdi-package-variant-closed:before {\n  content: \"\\F3D7\";\n}\n\n.mdi-page-first:before {\n  content: \"\\F600\";\n}\n\n.mdi-page-last:before {\n  content: \"\\F601\";\n}\n\n.mdi-page-layout-body:before {\n  content: \"\\F6F9\";\n}\n\n.mdi-page-layout-footer:before {\n  content: \"\\F6FA\";\n}\n\n.mdi-page-layout-header:before {\n  content: \"\\F6FB\";\n}\n\n.mdi-page-layout-sidebar-left:before {\n  content: \"\\F6FC\";\n}\n\n.mdi-page-layout-sidebar-right:before {\n  content: \"\\F6FD\";\n}\n\n.mdi-palette:before {\n  content: \"\\F3D8\";\n}\n\n.mdi-palette-advanced:before {\n  content: \"\\F3D9\";\n}\n\n.mdi-palette-swatch:before {\n  content: \"\\F8B4\";\n}\n\n.mdi-panda:before {\n  content: \"\\F3DA\";\n}\n\n.mdi-pandora:before {\n  content: \"\\F3DB\";\n}\n\n.mdi-panorama:before {\n  content: \"\\F3DC\";\n}\n\n.mdi-panorama-fisheye:before {\n  content: \"\\F3DD\";\n}\n\n.mdi-panorama-horizontal:before {\n  content: \"\\F3DE\";\n}\n\n.mdi-panorama-vertical:before {\n  content: \"\\F3DF\";\n}\n\n.mdi-panorama-wide-angle:before {\n  content: \"\\F3E0\";\n}\n\n.mdi-paper-cut-vertical:before {\n  content: \"\\F3E1\";\n}\n\n.mdi-paperclip:before {\n  content: \"\\F3E2\";\n}\n\n.mdi-parking:before {\n  content: \"\\F3E3\";\n}\n\n.mdi-passport:before {\n  content: \"\\F7E2\";\n}\n\n.mdi-patreon:before {\n  content: \"\\F881\";\n}\n\n.mdi-pause:before {\n  content: \"\\F3E4\";\n}\n\n.mdi-pause-circle:before {\n  content: \"\\F3E5\";\n}\n\n.mdi-pause-circle-outline:before {\n  content: \"\\F3E6\";\n}\n\n.mdi-pause-octagon:before {\n  content: \"\\F3E7\";\n}\n\n.mdi-pause-octagon-outline:before {\n  content: \"\\F3E8\";\n}\n\n.mdi-paw:before {\n  content: \"\\F3E9\";\n}\n\n.mdi-paw-off:before {\n  content: \"\\F657\";\n}\n\n.mdi-paypal:before {\n  content: \"\\F882\";\n}\n\n.mdi-peace:before {\n  content: \"\\F883\";\n}\n\n.mdi-pen:before {\n  content: \"\\F3EA\";\n}\n\n.mdi-pencil:before {\n  content: \"\\F3EB\";\n}\n\n.mdi-pencil-box:before {\n  content: \"\\F3EC\";\n}\n\n.mdi-pencil-box-outline:before {\n  content: \"\\F3ED\";\n}\n\n.mdi-pencil-circle:before {\n  content: \"\\F6FE\";\n}\n\n.mdi-pencil-circle-outline:before {\n  content: \"\\F775\";\n}\n\n.mdi-pencil-lock:before {\n  content: \"\\F3EE\";\n}\n\n.mdi-pencil-off:before {\n  content: \"\\F3EF\";\n}\n\n.mdi-pentagon:before {\n  content: \"\\F6FF\";\n}\n\n.mdi-pentagon-outline:before {\n  content: \"\\F700\";\n}\n\n.mdi-percent:before {\n  content: \"\\F3F0\";\n}\n\n.mdi-periodic-table:before {\n  content: \"\\F8B5\";\n}\n\n.mdi-periodic-table-co2:before {\n  content: \"\\F7E3\";\n}\n\n.mdi-periscope:before {\n  content: \"\\F747\";\n}\n\n.mdi-pharmacy:before {\n  content: \"\\F3F1\";\n}\n\n.mdi-phone:before {\n  content: \"\\F3F2\";\n}\n\n.mdi-phone-bluetooth:before {\n  content: \"\\F3F3\";\n}\n\n.mdi-phone-classic:before {\n  content: \"\\F602\";\n}\n\n.mdi-phone-forward:before {\n  content: \"\\F3F4\";\n}\n\n.mdi-phone-hangup:before {\n  content: \"\\F3F5\";\n}\n\n.mdi-phone-in-talk:before {\n  content: \"\\F3F6\";\n}\n\n.mdi-phone-incoming:before {\n  content: \"\\F3F7\";\n}\n\n.mdi-phone-locked:before {\n  content: \"\\F3F8\";\n}\n\n.mdi-phone-log:before {\n  content: \"\\F3F9\";\n}\n\n.mdi-phone-minus:before {\n  content: \"\\F658\";\n}\n\n.mdi-phone-missed:before {\n  content: \"\\F3FA\";\n}\n\n.mdi-phone-outgoing:before {\n  content: \"\\F3FB\";\n}\n\n.mdi-phone-paused:before {\n  content: \"\\F3FC\";\n}\n\n.mdi-phone-plus:before {\n  content: \"\\F659\";\n}\n\n.mdi-phone-return:before {\n  content: \"\\F82E\";\n}\n\n.mdi-phone-rotate-landscape:before {\n  content: \"\\F884\";\n}\n\n.mdi-phone-rotate-portrait:before {\n  content: \"\\F885\";\n}\n\n.mdi-phone-settings:before {\n  content: \"\\F3FD\";\n}\n\n.mdi-phone-voip:before {\n  content: \"\\F3FE\";\n}\n\n.mdi-pi:before {\n  content: \"\\F3FF\";\n}\n\n.mdi-pi-box:before {\n  content: \"\\F400\";\n}\n\n.mdi-piano:before {\n  content: \"\\F67C\";\n}\n\n.mdi-pickaxe:before {\n  content: \"\\F8B6\";\n}\n\n.mdi-pier:before {\n  content: \"\\F886\";\n}\n\n.mdi-pier-crane:before {\n  content: \"\\F887\";\n}\n\n.mdi-pig:before {\n  content: \"\\F401\";\n}\n\n.mdi-pill:before {\n  content: \"\\F402\";\n}\n\n.mdi-pillar:before {\n  content: \"\\F701\";\n}\n\n.mdi-pin:before {\n  content: \"\\F403\";\n}\n\n.mdi-pin-off:before {\n  content: \"\\F404\";\n}\n\n.mdi-pin-off-outline:before {\n  content: \"\\F92F\";\n}\n\n.mdi-pin-outline:before {\n  content: \"\\F930\";\n}\n\n.mdi-pine-tree:before {\n  content: \"\\F405\";\n}\n\n.mdi-pine-tree-box:before {\n  content: \"\\F406\";\n}\n\n.mdi-pinterest:before {\n  content: \"\\F407\";\n}\n\n.mdi-pinterest-box:before {\n  content: \"\\F408\";\n}\n\n.mdi-pipe:before {\n  content: \"\\F7E4\";\n}\n\n.mdi-pipe-disconnected:before {\n  content: \"\\F7E5\";\n}\n\n.mdi-pipe-leak:before {\n  content: \"\\F888\";\n}\n\n.mdi-pistol:before {\n  content: \"\\F702\";\n}\n\n.mdi-piston:before {\n  content: \"\\F889\";\n}\n\n.mdi-pizza:before {\n  content: \"\\F409\";\n}\n\n.mdi-plane-shield:before {\n  content: \"\\F6BA\";\n}\n\n.mdi-play:before {\n  content: \"\\F40A\";\n}\n\n.mdi-play-box-outline:before {\n  content: \"\\F40B\";\n}\n\n.mdi-play-circle:before {\n  content: \"\\F40C\";\n}\n\n.mdi-play-circle-outline:before {\n  content: \"\\F40D\";\n}\n\n.mdi-play-network:before {\n  content: \"\\F88A\";\n}\n\n.mdi-play-pause:before {\n  content: \"\\F40E\";\n}\n\n.mdi-play-protected-content:before {\n  content: \"\\F40F\";\n}\n\n.mdi-play-speed:before {\n  content: \"\\F8FE\";\n}\n\n.mdi-playlist-check:before {\n  content: \"\\F5C7\";\n}\n\n.mdi-playlist-edit:before {\n  content: \"\\F8FF\";\n}\n\n.mdi-playlist-minus:before {\n  content: \"\\F410\";\n}\n\n.mdi-playlist-play:before {\n  content: \"\\F411\";\n}\n\n.mdi-playlist-plus:before {\n  content: \"\\F412\";\n}\n\n.mdi-playlist-remove:before {\n  content: \"\\F413\";\n}\n\n.mdi-playstation:before {\n  content: \"\\F414\";\n}\n\n.mdi-plex:before {\n  content: \"\\F6B9\";\n}\n\n.mdi-plus:before {\n  content: \"\\F415\";\n}\n\n.mdi-plus-box:before {\n  content: \"\\F416\";\n}\n\n.mdi-plus-box-outline:before {\n  content: \"\\F703\";\n}\n\n.mdi-plus-circle:before {\n  content: \"\\F417\";\n}\n\n.mdi-plus-circle-multiple-outline:before {\n  content: \"\\F418\";\n}\n\n.mdi-plus-circle-outline:before {\n  content: \"\\F419\";\n}\n\n.mdi-plus-minus:before {\n  content: \"\\F991\";\n}\n\n.mdi-plus-minus-box:before {\n  content: \"\\F992\";\n}\n\n.mdi-plus-network:before {\n  content: \"\\F41A\";\n}\n\n.mdi-plus-one:before {\n  content: \"\\F41B\";\n}\n\n.mdi-plus-outline:before {\n  content: \"\\F704\";\n}\n\n.mdi-pocket:before {\n  content: \"\\F41C\";\n}\n\n.mdi-podcast:before {\n  content: \"\\F993\";\n}\n\n.mdi-pokeball:before {\n  content: \"\\F41D\";\n}\n\n.mdi-poker-chip:before {\n  content: \"\\F82F\";\n}\n\n.mdi-polaroid:before {\n  content: \"\\F41E\";\n}\n\n.mdi-poll:before {\n  content: \"\\F41F\";\n}\n\n.mdi-poll-box:before {\n  content: \"\\F420\";\n}\n\n.mdi-polymer:before {\n  content: \"\\F421\";\n}\n\n.mdi-pool:before {\n  content: \"\\F606\";\n}\n\n.mdi-popcorn:before {\n  content: \"\\F422\";\n}\n\n.mdi-pot:before {\n  content: \"\\F65A\";\n}\n\n.mdi-pot-mix:before {\n  content: \"\\F65B\";\n}\n\n.mdi-pound:before {\n  content: \"\\F423\";\n}\n\n.mdi-pound-box:before {\n  content: \"\\F424\";\n}\n\n.mdi-power:before {\n  content: \"\\F425\";\n}\n\n.mdi-power-cycle:before {\n  content: \"\\F900\";\n}\n\n.mdi-power-off:before {\n  content: \"\\F901\";\n}\n\n.mdi-power-on:before {\n  content: \"\\F902\";\n}\n\n.mdi-power-plug:before {\n  content: \"\\F6A4\";\n}\n\n.mdi-power-plug-off:before {\n  content: \"\\F6A5\";\n}\n\n.mdi-power-settings:before {\n  content: \"\\F426\";\n}\n\n.mdi-power-sleep:before {\n  content: \"\\F903\";\n}\n\n.mdi-power-socket:before {\n  content: \"\\F427\";\n}\n\n.mdi-power-socket-au:before {\n  content: \"\\F904\";\n}\n\n.mdi-power-socket-eu:before {\n  content: \"\\F7E6\";\n}\n\n.mdi-power-socket-uk:before {\n  content: \"\\F7E7\";\n}\n\n.mdi-power-socket-us:before {\n  content: \"\\F7E8\";\n}\n\n.mdi-power-standby:before {\n  content: \"\\F905\";\n}\n\n.mdi-prescription:before {\n  content: \"\\F705\";\n}\n\n.mdi-presentation:before {\n  content: \"\\F428\";\n}\n\n.mdi-presentation-play:before {\n  content: \"\\F429\";\n}\n\n.mdi-printer:before {\n  content: \"\\F42A\";\n}\n\n.mdi-printer-3d:before {\n  content: \"\\F42B\";\n}\n\n.mdi-printer-alert:before {\n  content: \"\\F42C\";\n}\n\n.mdi-printer-settings:before {\n  content: \"\\F706\";\n}\n\n.mdi-priority-high:before {\n  content: \"\\F603\";\n}\n\n.mdi-priority-low:before {\n  content: \"\\F604\";\n}\n\n.mdi-professional-hexagon:before {\n  content: \"\\F42D\";\n}\n\n.mdi-progress-check:before {\n  content: \"\\F994\";\n}\n\n.mdi-progress-clock:before {\n  content: \"\\F995\";\n}\n\n.mdi-progress-download:before {\n  content: \"\\F996\";\n}\n\n.mdi-progress-upload:before {\n  content: \"\\F997\";\n}\n\n.mdi-projector:before {\n  content: \"\\F42E\";\n}\n\n.mdi-projector-screen:before {\n  content: \"\\F42F\";\n}\n\n.mdi-publish:before {\n  content: \"\\F6A6\";\n}\n\n.mdi-pulse:before {\n  content: \"\\F430\";\n}\n\n.mdi-puzzle:before {\n  content: \"\\F431\";\n}\n\n.mdi-qi:before {\n  content: \"\\F998\";\n}\n\n.mdi-qqchat:before {\n  content: \"\\F605\";\n}\n\n.mdi-qrcode:before {\n  content: \"\\F432\";\n}\n\n.mdi-qrcode-edit:before {\n  content: \"\\F8B7\";\n}\n\n.mdi-qrcode-scan:before {\n  content: \"\\F433\";\n}\n\n.mdi-quadcopter:before {\n  content: \"\\F434\";\n}\n\n.mdi-quality-high:before {\n  content: \"\\F435\";\n}\n\n.mdi-quicktime:before {\n  content: \"\\F436\";\n}\n\n.mdi-rabbit:before {\n  content: \"\\F906\";\n}\n\n.mdi-radar:before {\n  content: \"\\F437\";\n}\n\n.mdi-radiator:before {\n  content: \"\\F438\";\n}\n\n.mdi-radio:before {\n  content: \"\\F439\";\n}\n\n.mdi-radio-handheld:before {\n  content: \"\\F43A\";\n}\n\n.mdi-radio-tower:before {\n  content: \"\\F43B\";\n}\n\n.mdi-radioactive:before {\n  content: \"\\F43C\";\n}\n\n.mdi-radiobox-blank:before {\n  content: \"\\F43D\";\n}\n\n.mdi-radiobox-marked:before {\n  content: \"\\F43E\";\n}\n\n.mdi-raspberrypi:before {\n  content: \"\\F43F\";\n}\n\n.mdi-ray-end:before {\n  content: \"\\F440\";\n}\n\n.mdi-ray-end-arrow:before {\n  content: \"\\F441\";\n}\n\n.mdi-ray-start:before {\n  content: \"\\F442\";\n}\n\n.mdi-ray-start-arrow:before {\n  content: \"\\F443\";\n}\n\n.mdi-ray-start-end:before {\n  content: \"\\F444\";\n}\n\n.mdi-ray-vertex:before {\n  content: \"\\F445\";\n}\n\n.mdi-react:before {\n  content: \"\\F707\";\n}\n\n.mdi-read:before {\n  content: \"\\F447\";\n}\n\n.mdi-receipt:before {\n  content: \"\\F449\";\n}\n\n.mdi-record:before {\n  content: \"\\F44A\";\n}\n\n.mdi-record-player:before {\n  content: \"\\F999\";\n}\n\n.mdi-record-rec:before {\n  content: \"\\F44B\";\n}\n\n.mdi-recycle:before {\n  content: \"\\F44C\";\n}\n\n.mdi-reddit:before {\n  content: \"\\F44D\";\n}\n\n.mdi-redo:before {\n  content: \"\\F44E\";\n}\n\n.mdi-redo-variant:before {\n  content: \"\\F44F\";\n}\n\n.mdi-refresh:before {\n  content: \"\\F450\";\n}\n\n.mdi-regex:before {\n  content: \"\\F451\";\n}\n\n.mdi-relative-scale:before {\n  content: \"\\F452\";\n}\n\n.mdi-reload:before {\n  content: \"\\F453\";\n}\n\n.mdi-reminder:before {\n  content: \"\\F88B\";\n}\n\n.mdi-remote:before {\n  content: \"\\F454\";\n}\n\n.mdi-remote-desktop:before {\n  content: \"\\F8B8\";\n}\n\n.mdi-rename-box:before {\n  content: \"\\F455\";\n}\n\n.mdi-reorder-horizontal:before {\n  content: \"\\F687\";\n}\n\n.mdi-reorder-vertical:before {\n  content: \"\\F688\";\n}\n\n.mdi-repeat:before {\n  content: \"\\F456\";\n}\n\n.mdi-repeat-off:before {\n  content: \"\\F457\";\n}\n\n.mdi-repeat-once:before {\n  content: \"\\F458\";\n}\n\n.mdi-replay:before {\n  content: \"\\F459\";\n}\n\n.mdi-reply:before {\n  content: \"\\F45A\";\n}\n\n.mdi-reply-all:before {\n  content: \"\\F45B\";\n}\n\n.mdi-reproduction:before {\n  content: \"\\F45C\";\n}\n\n.mdi-resize-bottom-right:before {\n  content: \"\\F45D\";\n}\n\n.mdi-responsive:before {\n  content: \"\\F45E\";\n}\n\n.mdi-restart:before {\n  content: \"\\F708\";\n}\n\n.mdi-restore:before {\n  content: \"\\F99A\";\n}\n\n.mdi-restore-clock:before {\n  content: \"\\F6A7\";\n}\n\n.mdi-rewind:before {\n  content: \"\\F45F\";\n}\n\n.mdi-rewind-outline:before {\n  content: \"\\F709\";\n}\n\n.mdi-rhombus:before {\n  content: \"\\F70A\";\n}\n\n.mdi-rhombus-outline:before {\n  content: \"\\F70B\";\n}\n\n.mdi-ribbon:before {\n  content: \"\\F460\";\n}\n\n.mdi-rice:before {\n  content: \"\\F7E9\";\n}\n\n.mdi-ring:before {\n  content: \"\\F7EA\";\n}\n\n.mdi-road:before {\n  content: \"\\F461\";\n}\n\n.mdi-road-variant:before {\n  content: \"\\F462\";\n}\n\n.mdi-robot:before {\n  content: \"\\F6A8\";\n}\n\n.mdi-robot-vacuum:before {\n  content: \"\\F70C\";\n}\n\n.mdi-robot-vacuum-variant:before {\n  content: \"\\F907\";\n}\n\n.mdi-rocket:before {\n  content: \"\\F463\";\n}\n\n.mdi-room-service:before {\n  content: \"\\F88C\";\n}\n\n.mdi-rotate-3d:before {\n  content: \"\\F464\";\n}\n\n.mdi-rotate-left:before {\n  content: \"\\F465\";\n}\n\n.mdi-rotate-left-variant:before {\n  content: \"\\F466\";\n}\n\n.mdi-rotate-right:before {\n  content: \"\\F467\";\n}\n\n.mdi-rotate-right-variant:before {\n  content: \"\\F468\";\n}\n\n.mdi-rounded-corner:before {\n  content: \"\\F607\";\n}\n\n.mdi-router-wireless:before {\n  content: \"\\F469\";\n}\n\n.mdi-routes:before {\n  content: \"\\F46A\";\n}\n\n.mdi-rowing:before {\n  content: \"\\F608\";\n}\n\n.mdi-rss:before {\n  content: \"\\F46B\";\n}\n\n.mdi-rss-box:before {\n  content: \"\\F46C\";\n}\n\n.mdi-ruler:before {\n  content: \"\\F46D\";\n}\n\n.mdi-run:before {\n  content: \"\\F70D\";\n}\n\n.mdi-run-fast:before {\n  content: \"\\F46E\";\n}\n\n.mdi-sale:before {\n  content: \"\\F46F\";\n}\n\n.mdi-salesforce:before {\n  content: \"\\F88D\";\n}\n\n.mdi-sass:before {\n  content: \"\\F7EB\";\n}\n\n.mdi-satellite:before {\n  content: \"\\F470\";\n}\n\n.mdi-satellite-uplink:before {\n  content: \"\\F908\";\n}\n\n.mdi-satellite-variant:before {\n  content: \"\\F471\";\n}\n\n.mdi-sausage:before {\n  content: \"\\F8B9\";\n}\n\n.mdi-saxophone:before {\n  content: \"\\F609\";\n}\n\n.mdi-scale:before {\n  content: \"\\F472\";\n}\n\n.mdi-scale-balance:before {\n  content: \"\\F5D1\";\n}\n\n.mdi-scale-bathroom:before {\n  content: \"\\F473\";\n}\n\n.mdi-scanner:before {\n  content: \"\\F6AA\";\n}\n\n.mdi-scanner-off:before {\n  content: \"\\F909\";\n}\n\n.mdi-school:before {\n  content: \"\\F474\";\n}\n\n.mdi-screen-rotation:before {\n  content: \"\\F475\";\n}\n\n.mdi-screen-rotation-lock:before {\n  content: \"\\F476\";\n}\n\n.mdi-screwdriver:before {\n  content: \"\\F477\";\n}\n\n.mdi-script:before {\n  content: \"\\F478\";\n}\n\n.mdi-sd:before {\n  content: \"\\F479\";\n}\n\n.mdi-seal:before {\n  content: \"\\F47A\";\n}\n\n.mdi-search-web:before {\n  content: \"\\F70E\";\n}\n\n.mdi-seat-flat:before {\n  content: \"\\F47B\";\n}\n\n.mdi-seat-flat-angled:before {\n  content: \"\\F47C\";\n}\n\n.mdi-seat-individual-suite:before {\n  content: \"\\F47D\";\n}\n\n.mdi-seat-legroom-extra:before {\n  content: \"\\F47E\";\n}\n\n.mdi-seat-legroom-normal:before {\n  content: \"\\F47F\";\n}\n\n.mdi-seat-legroom-reduced:before {\n  content: \"\\F480\";\n}\n\n.mdi-seat-recline-extra:before {\n  content: \"\\F481\";\n}\n\n.mdi-seat-recline-normal:before {\n  content: \"\\F482\";\n}\n\n.mdi-security:before {\n  content: \"\\F483\";\n}\n\n.mdi-security-account:before {\n  content: \"\\F88E\";\n}\n\n.mdi-security-close:before {\n  content: \"\\F99B\";\n}\n\n.mdi-security-home:before {\n  content: \"\\F689\";\n}\n\n.mdi-security-lock:before {\n  content: \"\\F99C\";\n}\n\n.mdi-security-network:before {\n  content: \"\\F484\";\n}\n\n.mdi-security-off:before {\n  content: \"\\F99D\";\n}\n\n.mdi-select:before {\n  content: \"\\F485\";\n}\n\n.mdi-select-all:before {\n  content: \"\\F486\";\n}\n\n.mdi-select-inverse:before {\n  content: \"\\F487\";\n}\n\n.mdi-select-off:before {\n  content: \"\\F488\";\n}\n\n.mdi-selection:before {\n  content: \"\\F489\";\n}\n\n.mdi-selection-off:before {\n  content: \"\\F776\";\n}\n\n.mdi-send:before {\n  content: \"\\F48A\";\n}\n\n.mdi-send-secure:before {\n  content: \"\\F7EC\";\n}\n\n.mdi-serial-port:before {\n  content: \"\\F65C\";\n}\n\n.mdi-server:before {\n  content: \"\\F48B\";\n}\n\n.mdi-server-minus:before {\n  content: \"\\F48C\";\n}\n\n.mdi-server-network:before {\n  content: \"\\F48D\";\n}\n\n.mdi-server-network-off:before {\n  content: \"\\F48E\";\n}\n\n.mdi-server-off:before {\n  content: \"\\F48F\";\n}\n\n.mdi-server-plus:before {\n  content: \"\\F490\";\n}\n\n.mdi-server-remove:before {\n  content: \"\\F491\";\n}\n\n.mdi-server-security:before {\n  content: \"\\F492\";\n}\n\n.mdi-set-all:before {\n  content: \"\\F777\";\n}\n\n.mdi-set-center:before {\n  content: \"\\F778\";\n}\n\n.mdi-set-center-right:before {\n  content: \"\\F779\";\n}\n\n.mdi-set-left:before {\n  content: \"\\F77A\";\n}\n\n.mdi-set-left-center:before {\n  content: \"\\F77B\";\n}\n\n.mdi-set-left-right:before {\n  content: \"\\F77C\";\n}\n\n.mdi-set-none:before {\n  content: \"\\F77D\";\n}\n\n.mdi-set-right:before {\n  content: \"\\F77E\";\n}\n\n.mdi-set-top-box:before {\n  content: \"\\F99E\";\n}\n\n.mdi-settings:before {\n  content: \"\\F493\";\n}\n\n.mdi-settings-box:before {\n  content: \"\\F494\";\n}\n\n.mdi-settings-outline:before {\n  content: \"\\F8BA\";\n}\n\n.mdi-shape:before {\n  content: \"\\F830\";\n}\n\n.mdi-shape-circle-plus:before {\n  content: \"\\F65D\";\n}\n\n.mdi-shape-outline:before {\n  content: \"\\F831\";\n}\n\n.mdi-shape-plus:before {\n  content: \"\\F495\";\n}\n\n.mdi-shape-polygon-plus:before {\n  content: \"\\F65E\";\n}\n\n.mdi-shape-rectangle-plus:before {\n  content: \"\\F65F\";\n}\n\n.mdi-shape-square-plus:before {\n  content: \"\\F660\";\n}\n\n.mdi-share:before {\n  content: \"\\F496\";\n}\n\n.mdi-share-outline:before {\n  content: \"\\F931\";\n}\n\n.mdi-share-variant:before {\n  content: \"\\F497\";\n}\n\n.mdi-shield:before {\n  content: \"\\F498\";\n}\n\n.mdi-shield-half-full:before {\n  content: \"\\F77F\";\n}\n\n.mdi-shield-outline:before {\n  content: \"\\F499\";\n}\n\n.mdi-ship-wheel:before {\n  content: \"\\F832\";\n}\n\n.mdi-shopping:before {\n  content: \"\\F49A\";\n}\n\n.mdi-shopping-music:before {\n  content: \"\\F49B\";\n}\n\n.mdi-shovel:before {\n  content: \"\\F70F\";\n}\n\n.mdi-shovel-off:before {\n  content: \"\\F710\";\n}\n\n.mdi-shower:before {\n  content: \"\\F99F\";\n}\n\n.mdi-shower-head:before {\n  content: \"\\F9A0\";\n}\n\n.mdi-shredder:before {\n  content: \"\\F49C\";\n}\n\n.mdi-shuffle:before {\n  content: \"\\F49D\";\n}\n\n.mdi-shuffle-disabled:before {\n  content: \"\\F49E\";\n}\n\n.mdi-shuffle-variant:before {\n  content: \"\\F49F\";\n}\n\n.mdi-sigma:before {\n  content: \"\\F4A0\";\n}\n\n.mdi-sigma-lower:before {\n  content: \"\\F62B\";\n}\n\n.mdi-sign-caution:before {\n  content: \"\\F4A1\";\n}\n\n.mdi-sign-direction:before {\n  content: \"\\F780\";\n}\n\n.mdi-sign-text:before {\n  content: \"\\F781\";\n}\n\n.mdi-signal:before {\n  content: \"\\F4A2\";\n}\n\n.mdi-signal-2g:before {\n  content: \"\\F711\";\n}\n\n.mdi-signal-3g:before {\n  content: \"\\F712\";\n}\n\n.mdi-signal-4g:before {\n  content: \"\\F713\";\n}\n\n.mdi-signal-cellular-1:before {\n  content: \"\\F8BB\";\n}\n\n.mdi-signal-cellular-2:before {\n  content: \"\\F8BC\";\n}\n\n.mdi-signal-cellular-3:before {\n  content: \"\\F8BD\";\n}\n\n.mdi-signal-cellular-outline:before {\n  content: \"\\F8BE\";\n}\n\n.mdi-signal-hspa:before {\n  content: \"\\F714\";\n}\n\n.mdi-signal-hspa-plus:before {\n  content: \"\\F715\";\n}\n\n.mdi-signal-off:before {\n  content: \"\\F782\";\n}\n\n.mdi-signal-variant:before {\n  content: \"\\F60A\";\n}\n\n.mdi-silverware:before {\n  content: \"\\F4A3\";\n}\n\n.mdi-silverware-fork:before {\n  content: \"\\F4A4\";\n}\n\n.mdi-silverware-spoon:before {\n  content: \"\\F4A5\";\n}\n\n.mdi-silverware-variant:before {\n  content: \"\\F4A6\";\n}\n\n.mdi-sim:before {\n  content: \"\\F4A7\";\n}\n\n.mdi-sim-alert:before {\n  content: \"\\F4A8\";\n}\n\n.mdi-sim-off:before {\n  content: \"\\F4A9\";\n}\n\n.mdi-sitemap:before {\n  content: \"\\F4AA\";\n}\n\n.mdi-skip-backward:before {\n  content: \"\\F4AB\";\n}\n\n.mdi-skip-forward:before {\n  content: \"\\F4AC\";\n}\n\n.mdi-skip-next:before {\n  content: \"\\F4AD\";\n}\n\n.mdi-skip-next-circle:before {\n  content: \"\\F661\";\n}\n\n.mdi-skip-next-circle-outline:before {\n  content: \"\\F662\";\n}\n\n.mdi-skip-previous:before {\n  content: \"\\F4AE\";\n}\n\n.mdi-skip-previous-circle:before {\n  content: \"\\F663\";\n}\n\n.mdi-skip-previous-circle-outline:before {\n  content: \"\\F664\";\n}\n\n.mdi-skull:before {\n  content: \"\\F68B\";\n}\n\n.mdi-skype:before {\n  content: \"\\F4AF\";\n}\n\n.mdi-skype-business:before {\n  content: \"\\F4B0\";\n}\n\n.mdi-slack:before {\n  content: \"\\F4B1\";\n}\n\n.mdi-slackware:before {\n  content: \"\\F90A\";\n}\n\n.mdi-sleep:before {\n  content: \"\\F4B2\";\n}\n\n.mdi-sleep-off:before {\n  content: \"\\F4B3\";\n}\n\n.mdi-smoke-detector:before {\n  content: \"\\F392\";\n}\n\n.mdi-smoking:before {\n  content: \"\\F4B4\";\n}\n\n.mdi-smoking-off:before {\n  content: \"\\F4B5\";\n}\n\n.mdi-snapchat:before {\n  content: \"\\F4B6\";\n}\n\n.mdi-snowflake:before {\n  content: \"\\F716\";\n}\n\n.mdi-snowman:before {\n  content: \"\\F4B7\";\n}\n\n.mdi-soccer:before {\n  content: \"\\F4B8\";\n}\n\n.mdi-soccer-field:before {\n  content: \"\\F833\";\n}\n\n.mdi-sofa:before {\n  content: \"\\F4B9\";\n}\n\n.mdi-solid:before {\n  content: \"\\F68C\";\n}\n\n.mdi-sort:before {\n  content: \"\\F4BA\";\n}\n\n.mdi-sort-alphabetical:before {\n  content: \"\\F4BB\";\n}\n\n.mdi-sort-ascending:before {\n  content: \"\\F4BC\";\n}\n\n.mdi-sort-descending:before {\n  content: \"\\F4BD\";\n}\n\n.mdi-sort-numeric:before {\n  content: \"\\F4BE\";\n}\n\n.mdi-sort-variant:before {\n  content: \"\\F4BF\";\n}\n\n.mdi-soundcloud:before {\n  content: \"\\F4C0\";\n}\n\n.mdi-source-branch:before {\n  content: \"\\F62C\";\n}\n\n.mdi-source-commit:before {\n  content: \"\\F717\";\n}\n\n.mdi-source-commit-end:before {\n  content: \"\\F718\";\n}\n\n.mdi-source-commit-end-local:before {\n  content: \"\\F719\";\n}\n\n.mdi-source-commit-local:before {\n  content: \"\\F71A\";\n}\n\n.mdi-source-commit-next-local:before {\n  content: \"\\F71B\";\n}\n\n.mdi-source-commit-start:before {\n  content: \"\\F71C\";\n}\n\n.mdi-source-commit-start-next-local:before {\n  content: \"\\F71D\";\n}\n\n.mdi-source-fork:before {\n  content: \"\\F4C1\";\n}\n\n.mdi-source-merge:before {\n  content: \"\\F62D\";\n}\n\n.mdi-source-pull:before {\n  content: \"\\F4C2\";\n}\n\n.mdi-soy-sauce:before {\n  content: \"\\F7ED\";\n}\n\n.mdi-speaker:before {\n  content: \"\\F4C3\";\n}\n\n.mdi-speaker-bluetooth:before {\n  content: \"\\F9A1\";\n}\n\n.mdi-speaker-off:before {\n  content: \"\\F4C4\";\n}\n\n.mdi-speaker-wireless:before {\n  content: \"\\F71E\";\n}\n\n.mdi-speedometer:before {\n  content: \"\\F4C5\";\n}\n\n.mdi-spellcheck:before {\n  content: \"\\F4C6\";\n}\n\n.mdi-spotify:before {\n  content: \"\\F4C7\";\n}\n\n.mdi-spotlight:before {\n  content: \"\\F4C8\";\n}\n\n.mdi-spotlight-beam:before {\n  content: \"\\F4C9\";\n}\n\n.mdi-spray:before {\n  content: \"\\F665\";\n}\n\n.mdi-square:before {\n  content: \"\\F763\";\n}\n\n.mdi-square-edit-outline:before {\n  content: \"\\F90B\";\n}\n\n.mdi-square-inc:before {\n  content: \"\\F4CA\";\n}\n\n.mdi-square-inc-cash:before {\n  content: \"\\F4CB\";\n}\n\n.mdi-square-outline:before {\n  content: \"\\F762\";\n}\n\n.mdi-square-root:before {\n  content: \"\\F783\";\n}\n\n.mdi-square-root-box:before {\n  content: \"\\F9A2\";\n}\n\n.mdi-ssh:before {\n  content: \"\\F8BF\";\n}\n\n.mdi-stack-exchange:before {\n  content: \"\\F60B\";\n}\n\n.mdi-stack-overflow:before {\n  content: \"\\F4CC\";\n}\n\n.mdi-stadium:before {\n  content: \"\\F71F\";\n}\n\n.mdi-stairs:before {\n  content: \"\\F4CD\";\n}\n\n.mdi-standard-definition:before {\n  content: \"\\F7EE\";\n}\n\n.mdi-star:before {\n  content: \"\\F4CE\";\n}\n\n.mdi-star-circle:before {\n  content: \"\\F4CF\";\n}\n\n.mdi-star-circle-outline:before {\n  content: \"\\F9A3\";\n}\n\n.mdi-star-face:before {\n  content: \"\\F9A4\";\n}\n\n.mdi-star-half:before {\n  content: \"\\F4D0\";\n}\n\n.mdi-star-off:before {\n  content: \"\\F4D1\";\n}\n\n.mdi-star-outline:before {\n  content: \"\\F4D2\";\n}\n\n.mdi-steam:before {\n  content: \"\\F4D3\";\n}\n\n.mdi-steam-box:before {\n  content: \"\\F90C\";\n}\n\n.mdi-steering:before {\n  content: \"\\F4D4\";\n}\n\n.mdi-steering-off:before {\n  content: \"\\F90D\";\n}\n\n.mdi-step-backward:before {\n  content: \"\\F4D5\";\n}\n\n.mdi-step-backward-2:before {\n  content: \"\\F4D6\";\n}\n\n.mdi-step-forward:before {\n  content: \"\\F4D7\";\n}\n\n.mdi-step-forward-2:before {\n  content: \"\\F4D8\";\n}\n\n.mdi-stethoscope:before {\n  content: \"\\F4D9\";\n}\n\n.mdi-sticker:before {\n  content: \"\\F5D0\";\n}\n\n.mdi-sticker-emoji:before {\n  content: \"\\F784\";\n}\n\n.mdi-stocking:before {\n  content: \"\\F4DA\";\n}\n\n.mdi-stop:before {\n  content: \"\\F4DB\";\n}\n\n.mdi-stop-circle:before {\n  content: \"\\F666\";\n}\n\n.mdi-stop-circle-outline:before {\n  content: \"\\F667\";\n}\n\n.mdi-store:before {\n  content: \"\\F4DC\";\n}\n\n.mdi-store-24-hour:before {\n  content: \"\\F4DD\";\n}\n\n.mdi-stove:before {\n  content: \"\\F4DE\";\n}\n\n.mdi-subdirectory-arrow-left:before {\n  content: \"\\F60C\";\n}\n\n.mdi-subdirectory-arrow-right:before {\n  content: \"\\F60D\";\n}\n\n.mdi-subway:before {\n  content: \"\\F6AB\";\n}\n\n.mdi-subway-variant:before {\n  content: \"\\F4DF\";\n}\n\n.mdi-summit:before {\n  content: \"\\F785\";\n}\n\n.mdi-sunglasses:before {\n  content: \"\\F4E0\";\n}\n\n.mdi-surround-sound:before {\n  content: \"\\F5C5\";\n}\n\n.mdi-surround-sound-2-0:before {\n  content: \"\\F7EF\";\n}\n\n.mdi-surround-sound-3-1:before {\n  content: \"\\F7F0\";\n}\n\n.mdi-surround-sound-5-1:before {\n  content: \"\\F7F1\";\n}\n\n.mdi-surround-sound-7-1:before {\n  content: \"\\F7F2\";\n}\n\n.mdi-svg:before {\n  content: \"\\F720\";\n}\n\n.mdi-swap-horizontal:before {\n  content: \"\\F4E1\";\n}\n\n.mdi-swap-horizontal-variant:before {\n  content: \"\\F8C0\";\n}\n\n.mdi-swap-vertical:before {\n  content: \"\\F4E2\";\n}\n\n.mdi-swap-vertical-variant:before {\n  content: \"\\F8C1\";\n}\n\n.mdi-swim:before {\n  content: \"\\F4E3\";\n}\n\n.mdi-switch:before {\n  content: \"\\F4E4\";\n}\n\n.mdi-sword:before {\n  content: \"\\F4E5\";\n}\n\n.mdi-sword-cross:before {\n  content: \"\\F786\";\n}\n\n.mdi-sync:before {\n  content: \"\\F4E6\";\n}\n\n.mdi-sync-alert:before {\n  content: \"\\F4E7\";\n}\n\n.mdi-sync-off:before {\n  content: \"\\F4E8\";\n}\n\n.mdi-tab:before {\n  content: \"\\F4E9\";\n}\n\n.mdi-tab-plus:before {\n  content: \"\\F75B\";\n}\n\n.mdi-tab-unselected:before {\n  content: \"\\F4EA\";\n}\n\n.mdi-table:before {\n  content: \"\\F4EB\";\n}\n\n.mdi-table-column:before {\n  content: \"\\F834\";\n}\n\n.mdi-table-column-plus-after:before {\n  content: \"\\F4EC\";\n}\n\n.mdi-table-column-plus-before:before {\n  content: \"\\F4ED\";\n}\n\n.mdi-table-column-remove:before {\n  content: \"\\F4EE\";\n}\n\n.mdi-table-column-width:before {\n  content: \"\\F4EF\";\n}\n\n.mdi-table-edit:before {\n  content: \"\\F4F0\";\n}\n\n.mdi-table-large:before {\n  content: \"\\F4F1\";\n}\n\n.mdi-table-merge-cells:before {\n  content: \"\\F9A5\";\n}\n\n.mdi-table-of-contents:before {\n  content: \"\\F835\";\n}\n\n.mdi-table-row:before {\n  content: \"\\F836\";\n}\n\n.mdi-table-row-height:before {\n  content: \"\\F4F2\";\n}\n\n.mdi-table-row-plus-after:before {\n  content: \"\\F4F3\";\n}\n\n.mdi-table-row-plus-before:before {\n  content: \"\\F4F4\";\n}\n\n.mdi-table-row-remove:before {\n  content: \"\\F4F5\";\n}\n\n.mdi-table-search:before {\n  content: \"\\F90E\";\n}\n\n.mdi-table-settings:before {\n  content: \"\\F837\";\n}\n\n.mdi-tablet:before {\n  content: \"\\F4F6\";\n}\n\n.mdi-tablet-android:before {\n  content: \"\\F4F7\";\n}\n\n.mdi-tablet-cellphone:before {\n  content: \"\\F9A6\";\n}\n\n.mdi-tablet-ipad:before {\n  content: \"\\F4F8\";\n}\n\n.mdi-taco:before {\n  content: \"\\F761\";\n}\n\n.mdi-tag:before {\n  content: \"\\F4F9\";\n}\n\n.mdi-tag-faces:before {\n  content: \"\\F4FA\";\n}\n\n.mdi-tag-heart:before {\n  content: \"\\F68A\";\n}\n\n.mdi-tag-minus:before {\n  content: \"\\F90F\";\n}\n\n.mdi-tag-multiple:before {\n  content: \"\\F4FB\";\n}\n\n.mdi-tag-outline:before {\n  content: \"\\F4FC\";\n}\n\n.mdi-tag-plus:before {\n  content: \"\\F721\";\n}\n\n.mdi-tag-remove:before {\n  content: \"\\F722\";\n}\n\n.mdi-tag-text-outline:before {\n  content: \"\\F4FD\";\n}\n\n.mdi-target:before {\n  content: \"\\F4FE\";\n}\n\n.mdi-taxi:before {\n  content: \"\\F4FF\";\n}\n\n.mdi-teach:before {\n  content: \"\\F88F\";\n}\n\n.mdi-teamviewer:before {\n  content: \"\\F500\";\n}\n\n.mdi-telegram:before {\n  content: \"\\F501\";\n}\n\n.mdi-television:before {\n  content: \"\\F502\";\n}\n\n.mdi-television-box:before {\n  content: \"\\F838\";\n}\n\n.mdi-television-classic:before {\n  content: \"\\F7F3\";\n}\n\n.mdi-television-classic-off:before {\n  content: \"\\F839\";\n}\n\n.mdi-television-guide:before {\n  content: \"\\F503\";\n}\n\n.mdi-television-off:before {\n  content: \"\\F83A\";\n}\n\n.mdi-temperature-celsius:before {\n  content: \"\\F504\";\n}\n\n.mdi-temperature-fahrenheit:before {\n  content: \"\\F505\";\n}\n\n.mdi-temperature-kelvin:before {\n  content: \"\\F506\";\n}\n\n.mdi-tennis:before {\n  content: \"\\F507\";\n}\n\n.mdi-tent:before {\n  content: \"\\F508\";\n}\n\n.mdi-terrain:before {\n  content: \"\\F509\";\n}\n\n.mdi-test-tube:before {\n  content: \"\\F668\";\n}\n\n.mdi-test-tube-empty:before {\n  content: \"\\F910\";\n}\n\n.mdi-test-tube-off:before {\n  content: \"\\F911\";\n}\n\n.mdi-text:before {\n  content: \"\\F9A7\";\n}\n\n.mdi-text-shadow:before {\n  content: \"\\F669\";\n}\n\n.mdi-text-short:before {\n  content: \"\\F9A8\";\n}\n\n.mdi-text-subject:before {\n  content: \"\\F9A9\";\n}\n\n.mdi-text-to-speech:before {\n  content: \"\\F50A\";\n}\n\n.mdi-text-to-speech-off:before {\n  content: \"\\F50B\";\n}\n\n.mdi-textbox:before {\n  content: \"\\F60E\";\n}\n\n.mdi-textbox-password:before {\n  content: \"\\F7F4\";\n}\n\n.mdi-texture:before {\n  content: \"\\F50C\";\n}\n\n.mdi-theater:before {\n  content: \"\\F50D\";\n}\n\n.mdi-theme-light-dark:before {\n  content: \"\\F50E\";\n}\n\n.mdi-thermometer:before {\n  content: \"\\F50F\";\n}\n\n.mdi-thermometer-lines:before {\n  content: \"\\F510\";\n}\n\n.mdi-thermostat:before {\n  content: \"\\F393\";\n}\n\n.mdi-thermostat-box:before {\n  content: \"\\F890\";\n}\n\n.mdi-thought-bubble:before {\n  content: \"\\F7F5\";\n}\n\n.mdi-thought-bubble-outline:before {\n  content: \"\\F7F6\";\n}\n\n.mdi-thumb-down:before {\n  content: \"\\F511\";\n}\n\n.mdi-thumb-down-outline:before {\n  content: \"\\F512\";\n}\n\n.mdi-thumb-up:before {\n  content: \"\\F513\";\n}\n\n.mdi-thumb-up-outline:before {\n  content: \"\\F514\";\n}\n\n.mdi-thumbs-up-down:before {\n  content: \"\\F515\";\n}\n\n.mdi-ticket:before {\n  content: \"\\F516\";\n}\n\n.mdi-ticket-account:before {\n  content: \"\\F517\";\n}\n\n.mdi-ticket-confirmation:before {\n  content: \"\\F518\";\n}\n\n.mdi-ticket-outline:before {\n  content: \"\\F912\";\n}\n\n.mdi-ticket-percent:before {\n  content: \"\\F723\";\n}\n\n.mdi-tie:before {\n  content: \"\\F519\";\n}\n\n.mdi-tilde:before {\n  content: \"\\F724\";\n}\n\n.mdi-timelapse:before {\n  content: \"\\F51A\";\n}\n\n.mdi-timer:before {\n  content: \"\\F51B\";\n}\n\n.mdi-timer-10:before {\n  content: \"\\F51C\";\n}\n\n.mdi-timer-3:before {\n  content: \"\\F51D\";\n}\n\n.mdi-timer-off:before {\n  content: \"\\F51E\";\n}\n\n.mdi-timer-sand:before {\n  content: \"\\F51F\";\n}\n\n.mdi-timer-sand-empty:before {\n  content: \"\\F6AC\";\n}\n\n.mdi-timer-sand-full:before {\n  content: \"\\F78B\";\n}\n\n.mdi-timetable:before {\n  content: \"\\F520\";\n}\n\n.mdi-toggle-switch:before {\n  content: \"\\F521\";\n}\n\n.mdi-toggle-switch-off:before {\n  content: \"\\F522\";\n}\n\n.mdi-toilet:before {\n  content: \"\\F9AA\";\n}\n\n.mdi-toolbox:before {\n  content: \"\\F9AB\";\n}\n\n.mdi-toolbox-outline:before {\n  content: \"\\F9AC\";\n}\n\n.mdi-tooltip:before {\n  content: \"\\F523\";\n}\n\n.mdi-tooltip-edit:before {\n  content: \"\\F524\";\n}\n\n.mdi-tooltip-image:before {\n  content: \"\\F525\";\n}\n\n.mdi-tooltip-outline:before {\n  content: \"\\F526\";\n}\n\n.mdi-tooltip-outline-plus:before {\n  content: \"\\F527\";\n}\n\n.mdi-tooltip-text:before {\n  content: \"\\F528\";\n}\n\n.mdi-tooth:before {\n  content: \"\\F8C2\";\n}\n\n.mdi-tooth-outline:before {\n  content: \"\\F529\";\n}\n\n.mdi-tor:before {\n  content: \"\\F52A\";\n}\n\n.mdi-tournament:before {\n  content: \"\\F9AD\";\n}\n\n.mdi-tower-beach:before {\n  content: \"\\F680\";\n}\n\n.mdi-tower-fire:before {\n  content: \"\\F681\";\n}\n\n.mdi-towing:before {\n  content: \"\\F83B\";\n}\n\n.mdi-track-light:before {\n  content: \"\\F913\";\n}\n\n.mdi-trackpad:before {\n  content: \"\\F7F7\";\n}\n\n.mdi-trackpad-lock:before {\n  content: \"\\F932\";\n}\n\n.mdi-tractor:before {\n  content: \"\\F891\";\n}\n\n.mdi-traffic-light:before {\n  content: \"\\F52B\";\n}\n\n.mdi-train:before {\n  content: \"\\F52C\";\n}\n\n.mdi-train-variant:before {\n  content: \"\\F8C3\";\n}\n\n.mdi-tram:before {\n  content: \"\\F52D\";\n}\n\n.mdi-transcribe:before {\n  content: \"\\F52E\";\n}\n\n.mdi-transcribe-close:before {\n  content: \"\\F52F\";\n}\n\n.mdi-transfer:before {\n  content: \"\\F530\";\n}\n\n.mdi-transit-transfer:before {\n  content: \"\\F6AD\";\n}\n\n.mdi-transition:before {\n  content: \"\\F914\";\n}\n\n.mdi-transition-masked:before {\n  content: \"\\F915\";\n}\n\n.mdi-translate:before {\n  content: \"\\F5CA\";\n}\n\n.mdi-treasure-chest:before {\n  content: \"\\F725\";\n}\n\n.mdi-tree:before {\n  content: \"\\F531\";\n}\n\n.mdi-trello:before {\n  content: \"\\F532\";\n}\n\n.mdi-trending-down:before {\n  content: \"\\F533\";\n}\n\n.mdi-trending-neutral:before {\n  content: \"\\F534\";\n}\n\n.mdi-trending-up:before {\n  content: \"\\F535\";\n}\n\n.mdi-triangle:before {\n  content: \"\\F536\";\n}\n\n.mdi-triangle-outline:before {\n  content: \"\\F537\";\n}\n\n.mdi-trophy:before {\n  content: \"\\F538\";\n}\n\n.mdi-trophy-award:before {\n  content: \"\\F539\";\n}\n\n.mdi-trophy-outline:before {\n  content: \"\\F53A\";\n}\n\n.mdi-trophy-variant:before {\n  content: \"\\F53B\";\n}\n\n.mdi-trophy-variant-outline:before {\n  content: \"\\F53C\";\n}\n\n.mdi-truck:before {\n  content: \"\\F53D\";\n}\n\n.mdi-truck-delivery:before {\n  content: \"\\F53E\";\n}\n\n.mdi-truck-fast:before {\n  content: \"\\F787\";\n}\n\n.mdi-truck-trailer:before {\n  content: \"\\F726\";\n}\n\n.mdi-tshirt-crew:before {\n  content: \"\\F53F\";\n}\n\n.mdi-tshirt-v:before {\n  content: \"\\F540\";\n}\n\n.mdi-tumble-dryer:before {\n  content: \"\\F916\";\n}\n\n.mdi-tumblr:before {\n  content: \"\\F541\";\n}\n\n.mdi-tumblr-box:before {\n  content: \"\\F917\";\n}\n\n.mdi-tumblr-reblog:before {\n  content: \"\\F542\";\n}\n\n.mdi-tune:before {\n  content: \"\\F62E\";\n}\n\n.mdi-tune-vertical:before {\n  content: \"\\F66A\";\n}\n\n.mdi-twitch:before {\n  content: \"\\F543\";\n}\n\n.mdi-twitter:before {\n  content: \"\\F544\";\n}\n\n.mdi-twitter-box:before {\n  content: \"\\F545\";\n}\n\n.mdi-twitter-circle:before {\n  content: \"\\F546\";\n}\n\n.mdi-twitter-retweet:before {\n  content: \"\\F547\";\n}\n\n.mdi-two-factor-authentication:before {\n  content: \"\\F9AE\";\n}\n\n.mdi-uber:before {\n  content: \"\\F748\";\n}\n\n.mdi-ubuntu:before {\n  content: \"\\F548\";\n}\n\n.mdi-ultra-high-definition:before {\n  content: \"\\F7F8\";\n}\n\n.mdi-umbraco:before {\n  content: \"\\F549\";\n}\n\n.mdi-umbrella:before {\n  content: \"\\F54A\";\n}\n\n.mdi-umbrella-closed:before {\n  content: \"\\F9AF\";\n}\n\n.mdi-umbrella-outline:before {\n  content: \"\\F54B\";\n}\n\n.mdi-undo:before {\n  content: \"\\F54C\";\n}\n\n.mdi-undo-variant:before {\n  content: \"\\F54D\";\n}\n\n.mdi-unfold-less-horizontal:before {\n  content: \"\\F54E\";\n}\n\n.mdi-unfold-less-vertical:before {\n  content: \"\\F75F\";\n}\n\n.mdi-unfold-more-horizontal:before {\n  content: \"\\F54F\";\n}\n\n.mdi-unfold-more-vertical:before {\n  content: \"\\F760\";\n}\n\n.mdi-ungroup:before {\n  content: \"\\F550\";\n}\n\n.mdi-unity:before {\n  content: \"\\F6AE\";\n}\n\n.mdi-unreal:before {\n  content: \"\\F9B0\";\n}\n\n.mdi-untappd:before {\n  content: \"\\F551\";\n}\n\n.mdi-update:before {\n  content: \"\\F6AF\";\n}\n\n.mdi-upload:before {\n  content: \"\\F552\";\n}\n\n.mdi-upload-multiple:before {\n  content: \"\\F83C\";\n}\n\n.mdi-upload-network:before {\n  content: \"\\F6F5\";\n}\n\n.mdi-usb:before {\n  content: \"\\F553\";\n}\n\n.mdi-van-passenger:before {\n  content: \"\\F7F9\";\n}\n\n.mdi-van-utility:before {\n  content: \"\\F7FA\";\n}\n\n.mdi-vanish:before {\n  content: \"\\F7FB\";\n}\n\n.mdi-vector-arrange-above:before {\n  content: \"\\F554\";\n}\n\n.mdi-vector-arrange-below:before {\n  content: \"\\F555\";\n}\n\n.mdi-vector-circle:before {\n  content: \"\\F556\";\n}\n\n.mdi-vector-circle-variant:before {\n  content: \"\\F557\";\n}\n\n.mdi-vector-combine:before {\n  content: \"\\F558\";\n}\n\n.mdi-vector-curve:before {\n  content: \"\\F559\";\n}\n\n.mdi-vector-difference:before {\n  content: \"\\F55A\";\n}\n\n.mdi-vector-difference-ab:before {\n  content: \"\\F55B\";\n}\n\n.mdi-vector-difference-ba:before {\n  content: \"\\F55C\";\n}\n\n.mdi-vector-ellipse:before {\n  content: \"\\F892\";\n}\n\n.mdi-vector-intersection:before {\n  content: \"\\F55D\";\n}\n\n.mdi-vector-line:before {\n  content: \"\\F55E\";\n}\n\n.mdi-vector-point:before {\n  content: \"\\F55F\";\n}\n\n.mdi-vector-polygon:before {\n  content: \"\\F560\";\n}\n\n.mdi-vector-polyline:before {\n  content: \"\\F561\";\n}\n\n.mdi-vector-radius:before {\n  content: \"\\F749\";\n}\n\n.mdi-vector-rectangle:before {\n  content: \"\\F5C6\";\n}\n\n.mdi-vector-selection:before {\n  content: \"\\F562\";\n}\n\n.mdi-vector-square:before {\n  content: \"\\F001\";\n}\n\n.mdi-vector-triangle:before {\n  content: \"\\F563\";\n}\n\n.mdi-vector-union:before {\n  content: \"\\F564\";\n}\n\n.mdi-venmo:before {\n  content: \"\\F578\";\n}\n\n.mdi-verified:before {\n  content: \"\\F565\";\n}\n\n.mdi-vibrate:before {\n  content: \"\\F566\";\n}\n\n.mdi-video:before {\n  content: \"\\F567\";\n}\n\n.mdi-video-3d:before {\n  content: \"\\F7FC\";\n}\n\n.mdi-video-4k-box:before {\n  content: \"\\F83D\";\n}\n\n.mdi-video-account:before {\n  content: \"\\F918\";\n}\n\n.mdi-video-image:before {\n  content: \"\\F919\";\n}\n\n.mdi-video-input-antenna:before {\n  content: \"\\F83E\";\n}\n\n.mdi-video-input-component:before {\n  content: \"\\F83F\";\n}\n\n.mdi-video-input-hdmi:before {\n  content: \"\\F840\";\n}\n\n.mdi-video-input-svideo:before {\n  content: \"\\F841\";\n}\n\n.mdi-video-minus:before {\n  content: \"\\F9B1\";\n}\n\n.mdi-video-off:before {\n  content: \"\\F568\";\n}\n\n.mdi-video-plus:before {\n  content: \"\\F9B2\";\n}\n\n.mdi-video-stabilization:before {\n  content: \"\\F91A\";\n}\n\n.mdi-video-switch:before {\n  content: \"\\F569\";\n}\n\n.mdi-view-agenda:before {\n  content: \"\\F56A\";\n}\n\n.mdi-view-array:before {\n  content: \"\\F56B\";\n}\n\n.mdi-view-carousel:before {\n  content: \"\\F56C\";\n}\n\n.mdi-view-column:before {\n  content: \"\\F56D\";\n}\n\n.mdi-view-dashboard:before {\n  content: \"\\F56E\";\n}\n\n.mdi-view-dashboard-variant:before {\n  content: \"\\F842\";\n}\n\n.mdi-view-day:before {\n  content: \"\\F56F\";\n}\n\n.mdi-view-grid:before {\n  content: \"\\F570\";\n}\n\n.mdi-view-headline:before {\n  content: \"\\F571\";\n}\n\n.mdi-view-list:before {\n  content: \"\\F572\";\n}\n\n.mdi-view-module:before {\n  content: \"\\F573\";\n}\n\n.mdi-view-parallel:before {\n  content: \"\\F727\";\n}\n\n.mdi-view-quilt:before {\n  content: \"\\F574\";\n}\n\n.mdi-view-sequential:before {\n  content: \"\\F728\";\n}\n\n.mdi-view-stream:before {\n  content: \"\\F575\";\n}\n\n.mdi-view-week:before {\n  content: \"\\F576\";\n}\n\n.mdi-vimeo:before {\n  content: \"\\F577\";\n}\n\n.mdi-violin:before {\n  content: \"\\F60F\";\n}\n\n.mdi-virtual-reality:before {\n  content: \"\\F893\";\n}\n\n.mdi-visualstudio:before {\n  content: \"\\F610\";\n}\n\n.mdi-vk:before {\n  content: \"\\F579\";\n}\n\n.mdi-vk-box:before {\n  content: \"\\F57A\";\n}\n\n.mdi-vk-circle:before {\n  content: \"\\F57B\";\n}\n\n.mdi-vlc:before {\n  content: \"\\F57C\";\n}\n\n.mdi-voice:before {\n  content: \"\\F5CB\";\n}\n\n.mdi-voicemail:before {\n  content: \"\\F57D\";\n}\n\n.mdi-volleyball:before {\n  content: \"\\F9B3\";\n}\n\n.mdi-volume-high:before {\n  content: \"\\F57E\";\n}\n\n.mdi-volume-low:before {\n  content: \"\\F57F\";\n}\n\n.mdi-volume-medium:before {\n  content: \"\\F580\";\n}\n\n.mdi-volume-minus:before {\n  content: \"\\F75D\";\n}\n\n.mdi-volume-mute:before {\n  content: \"\\F75E\";\n}\n\n.mdi-volume-off:before {\n  content: \"\\F581\";\n}\n\n.mdi-volume-plus:before {\n  content: \"\\F75C\";\n}\n\n.mdi-vpn:before {\n  content: \"\\F582\";\n}\n\n.mdi-vuejs:before {\n  content: \"\\F843\";\n}\n\n.mdi-walk:before {\n  content: \"\\F583\";\n}\n\n.mdi-wall:before {\n  content: \"\\F7FD\";\n}\n\n.mdi-wall-sconce:before {\n  content: \"\\F91B\";\n}\n\n.mdi-wall-sconce-flat:before {\n  content: \"\\F91C\";\n}\n\n.mdi-wall-sconce-variant:before {\n  content: \"\\F91D\";\n}\n\n.mdi-wallet:before {\n  content: \"\\F584\";\n}\n\n.mdi-wallet-giftcard:before {\n  content: \"\\F585\";\n}\n\n.mdi-wallet-membership:before {\n  content: \"\\F586\";\n}\n\n.mdi-wallet-travel:before {\n  content: \"\\F587\";\n}\n\n.mdi-wan:before {\n  content: \"\\F588\";\n}\n\n.mdi-washing-machine:before {\n  content: \"\\F729\";\n}\n\n.mdi-watch:before {\n  content: \"\\F589\";\n}\n\n.mdi-watch-export:before {\n  content: \"\\F58A\";\n}\n\n.mdi-watch-export-variant:before {\n  content: \"\\F894\";\n}\n\n.mdi-watch-import:before {\n  content: \"\\F58B\";\n}\n\n.mdi-watch-import-variant:before {\n  content: \"\\F895\";\n}\n\n.mdi-watch-variant:before {\n  content: \"\\F896\";\n}\n\n.mdi-watch-vibrate:before {\n  content: \"\\F6B0\";\n}\n\n.mdi-water:before {\n  content: \"\\F58C\";\n}\n\n.mdi-water-off:before {\n  content: \"\\F58D\";\n}\n\n.mdi-water-percent:before {\n  content: \"\\F58E\";\n}\n\n.mdi-water-pump:before {\n  content: \"\\F58F\";\n}\n\n.mdi-watermark:before {\n  content: \"\\F612\";\n}\n\n.mdi-waves:before {\n  content: \"\\F78C\";\n}\n\n.mdi-weather-cloudy:before {\n  content: \"\\F590\";\n}\n\n.mdi-weather-fog:before {\n  content: \"\\F591\";\n}\n\n.mdi-weather-hail:before {\n  content: \"\\F592\";\n}\n\n.mdi-weather-hurricane:before {\n  content: \"\\F897\";\n}\n\n.mdi-weather-lightning:before {\n  content: \"\\F593\";\n}\n\n.mdi-weather-lightning-rainy:before {\n  content: \"\\F67D\";\n}\n\n.mdi-weather-night:before {\n  content: \"\\F594\";\n}\n\n.mdi-weather-partlycloudy:before {\n  content: \"\\F595\";\n}\n\n.mdi-weather-pouring:before {\n  content: \"\\F596\";\n}\n\n.mdi-weather-rainy:before {\n  content: \"\\F597\";\n}\n\n.mdi-weather-snowy:before {\n  content: \"\\F598\";\n}\n\n.mdi-weather-snowy-rainy:before {\n  content: \"\\F67E\";\n}\n\n.mdi-weather-sunny:before {\n  content: \"\\F599\";\n}\n\n.mdi-weather-sunset:before {\n  content: \"\\F59A\";\n}\n\n.mdi-weather-sunset-down:before {\n  content: \"\\F59B\";\n}\n\n.mdi-weather-sunset-up:before {\n  content: \"\\F59C\";\n}\n\n.mdi-weather-windy:before {\n  content: \"\\F59D\";\n}\n\n.mdi-weather-windy-variant:before {\n  content: \"\\F59E\";\n}\n\n.mdi-web:before {\n  content: \"\\F59F\";\n}\n\n.mdi-webcam:before {\n  content: \"\\F5A0\";\n}\n\n.mdi-webhook:before {\n  content: \"\\F62F\";\n}\n\n.mdi-webpack:before {\n  content: \"\\F72A\";\n}\n\n.mdi-wechat:before {\n  content: \"\\F611\";\n}\n\n.mdi-weight:before {\n  content: \"\\F5A1\";\n}\n\n.mdi-weight-kilogram:before {\n  content: \"\\F5A2\";\n}\n\n.mdi-weight-pound:before {\n  content: \"\\F9B4\";\n}\n\n.mdi-whatsapp:before {\n  content: \"\\F5A3\";\n}\n\n.mdi-wheelchair-accessibility:before {\n  content: \"\\F5A4\";\n}\n\n.mdi-whistle:before {\n  content: \"\\F9B5\";\n}\n\n.mdi-white-balance-auto:before {\n  content: \"\\F5A5\";\n}\n\n.mdi-white-balance-incandescent:before {\n  content: \"\\F5A6\";\n}\n\n.mdi-white-balance-iridescent:before {\n  content: \"\\F5A7\";\n}\n\n.mdi-white-balance-sunny:before {\n  content: \"\\F5A8\";\n}\n\n.mdi-widgets:before {\n  content: \"\\F72B\";\n}\n\n.mdi-wifi:before {\n  content: \"\\F5A9\";\n}\n\n.mdi-wifi-off:before {\n  content: \"\\F5AA\";\n}\n\n.mdi-wifi-strength-1:before {\n  content: \"\\F91E\";\n}\n\n.mdi-wifi-strength-1-alert:before {\n  content: \"\\F91F\";\n}\n\n.mdi-wifi-strength-1-lock:before {\n  content: \"\\F920\";\n}\n\n.mdi-wifi-strength-2:before {\n  content: \"\\F921\";\n}\n\n.mdi-wifi-strength-2-alert:before {\n  content: \"\\F922\";\n}\n\n.mdi-wifi-strength-2-lock:before {\n  content: \"\\F923\";\n}\n\n.mdi-wifi-strength-3:before {\n  content: \"\\F924\";\n}\n\n.mdi-wifi-strength-3-alert:before {\n  content: \"\\F925\";\n}\n\n.mdi-wifi-strength-3-lock:before {\n  content: \"\\F926\";\n}\n\n.mdi-wifi-strength-4:before {\n  content: \"\\F927\";\n}\n\n.mdi-wifi-strength-4-alert:before {\n  content: \"\\F928\";\n}\n\n.mdi-wifi-strength-4-lock:before {\n  content: \"\\F929\";\n}\n\n.mdi-wifi-strength-alert-outline:before {\n  content: \"\\F92A\";\n}\n\n.mdi-wifi-strength-lock-outline:before {\n  content: \"\\F92B\";\n}\n\n.mdi-wifi-strength-off:before {\n  content: \"\\F92C\";\n}\n\n.mdi-wifi-strength-off-outline:before {\n  content: \"\\F92D\";\n}\n\n.mdi-wifi-strength-outline:before {\n  content: \"\\F92E\";\n}\n\n.mdi-wii:before {\n  content: \"\\F5AB\";\n}\n\n.mdi-wiiu:before {\n  content: \"\\F72C\";\n}\n\n.mdi-wikipedia:before {\n  content: \"\\F5AC\";\n}\n\n.mdi-window-close:before {\n  content: \"\\F5AD\";\n}\n\n.mdi-window-closed:before {\n  content: \"\\F5AE\";\n}\n\n.mdi-window-maximize:before {\n  content: \"\\F5AF\";\n}\n\n.mdi-window-minimize:before {\n  content: \"\\F5B0\";\n}\n\n.mdi-window-open:before {\n  content: \"\\F5B1\";\n}\n\n.mdi-window-restore:before {\n  content: \"\\F5B2\";\n}\n\n.mdi-windows:before {\n  content: \"\\F5B3\";\n}\n\n.mdi-wordpress:before {\n  content: \"\\F5B4\";\n}\n\n.mdi-worker:before {\n  content: \"\\F5B5\";\n}\n\n.mdi-wrap:before {\n  content: \"\\F5B6\";\n}\n\n.mdi-wrench:before {\n  content: \"\\F5B7\";\n}\n\n.mdi-wunderlist:before {\n  content: \"\\F5B8\";\n}\n\n.mdi-xamarin:before {\n  content: \"\\F844\";\n}\n\n.mdi-xamarin-outline:before {\n  content: \"\\F845\";\n}\n\n.mdi-xaml:before {\n  content: \"\\F673\";\n}\n\n.mdi-xbox:before {\n  content: \"\\F5B9\";\n}\n\n.mdi-xbox-controller:before {\n  content: \"\\F5BA\";\n}\n\n.mdi-xbox-controller-battery-alert:before {\n  content: \"\\F74A\";\n}\n\n.mdi-xbox-controller-battery-empty:before {\n  content: \"\\F74B\";\n}\n\n.mdi-xbox-controller-battery-full:before {\n  content: \"\\F74C\";\n}\n\n.mdi-xbox-controller-battery-low:before {\n  content: \"\\F74D\";\n}\n\n.mdi-xbox-controller-battery-medium:before {\n  content: \"\\F74E\";\n}\n\n.mdi-xbox-controller-battery-unknown:before {\n  content: \"\\F74F\";\n}\n\n.mdi-xbox-controller-off:before {\n  content: \"\\F5BB\";\n}\n\n.mdi-xda:before {\n  content: \"\\F5BC\";\n}\n\n.mdi-xing:before {\n  content: \"\\F5BD\";\n}\n\n.mdi-xing-box:before {\n  content: \"\\F5BE\";\n}\n\n.mdi-xing-circle:before {\n  content: \"\\F5BF\";\n}\n\n.mdi-xml:before {\n  content: \"\\F5C0\";\n}\n\n.mdi-xmpp:before {\n  content: \"\\F7FE\";\n}\n\n.mdi-yammer:before {\n  content: \"\\F788\";\n}\n\n.mdi-yeast:before {\n  content: \"\\F5C1\";\n}\n\n.mdi-yelp:before {\n  content: \"\\F5C2\";\n}\n\n.mdi-yin-yang:before {\n  content: \"\\F67F\";\n}\n\n.mdi-youtube:before {\n  content: \"\\F5C3\";\n}\n\n.mdi-youtube-creator-studio:before {\n  content: \"\\F846\";\n}\n\n.mdi-youtube-gaming:before {\n  content: \"\\F847\";\n}\n\n.mdi-youtube-tv:before {\n  content: \"\\F448\";\n}\n\n.mdi-zip-box:before {\n  content: \"\\F5C4\";\n}\n\n.mdi-blank:before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(45deg);\n      transform: scaleX(-1) rotate(45deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: scaleY(-1) rotate(45deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(90deg);\n      transform: scaleX(-1) rotate(90deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(90deg);\n      -ms-transform: rotate(90deg);\n      transform: scaleY(-1) rotate(90deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(135deg);\n      transform: scaleX(-1) rotate(135deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(135deg);\n      -ms-transform: rotate(135deg);\n      transform: scaleY(-1) rotate(135deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(180deg);\n      transform: scaleX(-1) rotate(180deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(180deg);\n      -ms-transform: rotate(180deg);\n      transform: scaleY(-1) rotate(180deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(225deg);\n      transform: scaleX(-1) rotate(225deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(225deg);\n      -ms-transform: rotate(225deg);\n      transform: scaleY(-1) rotate(225deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(270deg);\n      transform: scaleX(-1) rotate(270deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(270deg);\n      -ms-transform: rotate(270deg);\n      transform: scaleY(-1) rotate(270deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n  // Not included in production\n  &.mdi-flip-h:before {\n      -webkit-transform: scaleX(-1) rotate(315deg);\n      transform: scaleX(-1) rotate(315deg);\n      filter: FlipH;\n      -ms-filter: \"FlipH\";\n  }\n  &.mdi-flip-v:before {\n      -webkit-transform: scaleY(-1) rotate(315deg);\n      -ms-transform: rotate(315deg);\n      transform: scaleY(-1) rotate(315deg);\n      filter: FlipV;\n      -ms-filter: \"FlipV\";\n  }\n  */\n}\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
